var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ALLViewer, AnnotationType, NoteStatus, NoteType } from "@@/Annotation";
import { ObjectUpdateType } from "@/share/models";
import { ReminderUnit, RuleType, SchemaItemType, TriggerType } from "@@/Schema";
import { ProjectObjectType } from "@@/Project";
import { CalendarViewState } from "./CalendarViewState";
import { CardItem } from "@/share/CardItem";
import { ChartType, ChartViewState } from "./ChartViewState";
import { decryptCell as GDecryptcell, canShowRemoteEntry, checkRowSatifyCond, convertDepToRows, filterInvalidConsitions, parser, sortEntriesByRow, textRuleParser } from "@@/RuleParser";
import { action, makeObservable, observable, toJS } from "mobx";
import { SearchMetadataOp } from "@@/ModuleJob";
import { TimelineState } from "./TimelineState";
import { isIpadScreen, stripHTML as LWStripHTML, stripHTML } from "@@/Util";
import { APPEvent } from "@/events/AppEvents";
import { AccessGroupState } from "./AccessgroupState";
import { AlignMent } from "@@/Tab";
import { AppState } from "@/share/AppState";
import { Apphandler } from "@/ipc/MainAppHandler";
import { BaseDialogState } from "../UIComponents/BaseDialog";
import { CodeEditorState } from "./CodeEditorState";
import { ColorStore } from "../UIComponents/ColorDialog";
import { CommentState } from "../UIComponents/Comments";
import { DataRuleBuilderState } from "./DataRuleBuilderState";
import { DateLib } from "@@/Datelib";
import { DraftNoteUI } from "./DraftNoteUI";
import { FileUploadDialogState } from "../UIComponents/FileUploadDialog";
import { FilterDialogState } from "../UIComponents/FilterDialogState";
import { FooterResultExecStore } from "./FooterResultExecStore";
import { FooterRuleBuilderStore } from "./FooterRuleBuilderStore";
import { KanbanStore } from "./KanbanStore";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { NotesFilterState } from "./NotesFilterState";
import { RemoteRowBuilderState } from "./RemoteRowBuilderState";
import { Router } from "./Router";
import { RuleBuilderStore } from "./RuleBuilderStore";
import { RuleExecutionDropDownState } from "./RuleExecDropDownstate";
import { SelectMemberDialogState } from "../UIComponents/SelectMemberDialog";
import { TriggerStore } from "./TriggerStore";
import { WebViewReportsState } from "../UIComponents/WebViewReportsState";
import { WebViewUserState } from "./WebViewAppUsersState";
import { timeout } from "@@/Util";
import { expandNumbers10 } from "@/util/Util";
import { SchemaStore as BSchemaStore } from "../../background/store/SchemaStore";
import { comm } from "@/Comm/comm";
import { ServerPath } from "@@/ServerPath";
const ExcelImportDialogState = await import("./ExcelImportDialogState");
const SchemaImportDialogState = await import("./SchemaBuilderFromExcelStore");
export class SchemaStore {
    constructor() {
        this.schemas = new Map();
        this.sortedschemaitems = [];
        this.enableallsel = false;
        this.editrowslistitems = [];
        this.runningaiquery = false;
        this.webviewuserstate = new WebViewUserState();
        this.webviewreportsstate = new WebViewReportsState();
        this.codeeditor = new CodeEditorState();
        this.customcolcb = new Map();
        this.customcolbuilder = new Map();
        this.buildingcolns = new Set();
        this.customchecks = new Map();
        this.chathis = [];
        this.duplicating = false;
        this.duplicatingcount = 0;
        this.attaching = false;
        this.addingbarcodecol = false;
        this.totalduplicatecount = 0;
        this.drows = [];
        this.deleteentries = [];
        this.cacheui = new Map();
        this.gettingstate = new Map();
        this.savingstate = new Map();
        this.activelterid = "";
        this.loading = false;
        this.activeschema = "";
        this.loadingcontent = false;
        this.customgetupdatessince = new Map();
        this.rowcolbasedfiltering = new Map();
        this.showform = false;
        this.listitems = [];
        this.newlistitemsmap = new Map();
        this.extralistitems = new Map();
        this.rebuildformcompo = new Set();
        this.changedlistitems = new Set();
        this.storingform = false;
        this.updatingdatasheet = false;
        this.parsingentry = new Set();
        this.newformmap = new Map();
        this.listdetails = new Map();
        this.activeformid = "";
        this.addnforms = "";
        this.formentry = new Map();
        this.rowsMap = new Map();
        this.newrowsmap = [];
        this.columnwidths = new Map();
        this.webviewcolwidths = new Map();
        this.buildingview = false;
        this.showlinkdialog = false;
        this.deleteingrows = false;
        this.showactiveviewmenu = false;
        this.showwebview = false;
        this.showfiltereset = false;
        this.showworksheetattach = false;
        this.showalertforentries = new Set();
        this.showinfopanelshow = false;
        this.viewdefaultvalue = new Map();
        this.activeview = "grid";
        this.copyactive = false;
        this.showdtmennu = false;
        this.copyschema = undefined;
        this.rowsarrids = [];
        this.metadatadialog = new BaseDialogState();
        this.reportdialog = new BaseDialogState();
        this.dviews = new Set();
        this.viewjs = "";
        this.viewfilterjs = "";
        this.viewdefaultvaluejs = "";
        this.showwebviewfilterjs = false;
        this.expandlistitem = new Set();
        this.expandlistrow = new Map();
        this.loadinganaview = false;
        this.customcolsheetfun = undefined;
        this.showdefaultvaluejs = false;
        this.customrowjs = "";
        this.shownormaldispaly = false;
        this.addview = false;
        this.customcolshareddataforrows = new Map();
        this.afx = 0;
        this.afy = 0;
        this.bafx = 0;
        this.bafy = 0;
        this.showfilter = false;
        this.commentstate = new CommentState();
        this.schemaimportstate = new ExcelImportDialogState.ExcelImportDialogState();
        this.schemabuilderstate = new SchemaImportDialogState.SchemaBuilderFromExcelStore();
        this.selectedrows = new Set();
        this.attchinglabel = false;
        this.selrowmap = new Map();
        this.showactions = false;
        this.showbacodes = false;
        this.chatstate = new CommentState();
        this.smstate = new SelectMemberDialogState();
        this.rowstate = new SelectMemberDialogState();
        this.schemamstate = new SelectMemberDialogState();
        this.activeusers = [];
        this.lastcommenttime = -1;
        this.lastchattime = -1;
        this.tableref = null;
        this.showstatuesmenu = false;
        this.buildingrulefor = new Map();
        this.buildingruleforscol = new Set();
        this.loadmore = false;
        this.activecardsttaus = "";
        this.activecardgroupby = "";
        this.hiddenrows = new Set();
        this.activecardstatusname = "";
        this.activecardgroupname = "";
        this.startnotes = false;
        this.showgroupbymenu = false;
        this.showganttstartdate = false;
        this.showganttstartdatename = "Task Start Date";
        this.showganttenddatename = "Task End Date";
        this.colorfieldname = "Default Colors";
        this.colorfieldid = "";
        this.showcolorfield = false;
        this.showchartmenu = false;
        this.showcolumnview = false;
        this.links = [];
        this.schemanotesloading = false;
        this.checkingandcollecting = false;
        this.rowRules = new Map();
        this.rowDataRules = new Map();
        this.schemaviews = new Map();
        this.accessstorestate = new AccessGroupState();
        this.storeschemaids = new Set();
        this.activeschemametaids = new Set();
        this.colwithschemarules = new Set();
        this.footerruleexestate = new FooterResultExecStore();
        this.remoteitembuilder = new RemoteRowBuilderState();
        this.rowsorter = "orig";
        this.rowsorterorderasc = true;
        this.forcerebuildcustom = new Set();
        this.rulebuilderstate = new RuleBuilderStore();
        this.dataruleexec = new RuleExecutionDropDownState();
        this.datarulebuilder = new DataRuleBuilderState();
        this.triggerrulebuilder = new TriggerStore();
        this.rowrulebuilderstate = new RuleBuilderStore();
        this.rowdatarulebuilderstate = new DataRuleBuilderState();
        this.footerrulebilder = new FooterRuleBuilderStore();
        this.schmeapostactionfunc = undefined;
        this.gettinganas = false;
        this.anas = new Map();
        this.anasschema = new Map();
        this.activeloadednotesref = "";
        this.deletenoteids = new Set();
        this.shownotespanel = !isIpadScreen() ? true : false;
        this.dependentdata = new Map();
        this.descfieldname = "";
        this.descfieldid = "";
        this.showdescfield = false;
        this.activedetailtab = "detail";
        this.loadingcomments = false;
        this.loadingchats = false;
        this.deletingnote = false;
        this.enableannotation = true;
        this.readonlyrows = false;
        this.showrowsilter = false;
        this.showchatbot = false;
        this.savingschema = false;
        this.filterdialogstate = new FilterDialogState();
        this.schemasmap = new Map();
        this.schemaapimap = new Map();
        this.schematemplatemap = new Map();
        this.selectallrows = false;
        this.changedrowsid = new Set();
        this.colorstate = new ColorStore();
        this.lastnotesupdatetime = -1;
        this.notesbyid = new Map();
        this.activeaccessids = new Set([ALLViewer]);
        this.appliedaclstr = "---";
        this.editnoteid = "";
        this.activeentriesid = "";
        this.editmode = false;
        this.showcomments = false;
        this.loadingnotes = false;
        this.authors = new Map();
        this.showdervivedschemafields = false;
        this.activerequestid = "";
        this.notefilterstate = new NotesFilterState();
        this.hiddencolumns = new Set();
        this.showganttenddate = false;
        this.ganttstartid = "";
        this.ganttendid = "";
        this.ganttasknameid = "";
        this.ganttasknamefieldname = "";
        this.activerowid = "";
        this.savingrow = false;
        this.savingnote = false;
        this.addingrowtochild = false;
        this.activechildschema = "";
        this.editrowproperty = new Map();
        this.activerowindex = -1;
        this.notelinksdialogleft = 0;
        this.vieweditid = "";
        this.notelinksdialogtop = 70;
        this.chartstate = new Map();
        this.colors = ['#eb4438', '#7869b5', '#33a851'];
        this.removingrowsfromsh = new Set();
        this.showpasswordfor = new Set();
        this.loadingviews = false;
        this.triggersbyCols = new Map();
        this.activebuilingid = -1;
        this.kanbanstatus = new KanbanStore();
        this.timelinestatus = new TimelineState();
        this.calendarstate = new CalendarViewState();
        this.showinoutlinks = new Set();
        this.activeaction = "unknown";
        this.depschemarows = new Map();
        this.depschema = new Map();
        this.fetchingdepend = false;
        this.ignorerebuildcustomcomponent = new Set();
        this.loadedentry = 0;
        this.waitingentries = [];
        this.viewname = "";
        this.viewuseall = false;
        this.activedatasheet = "";
        this.fileuploadstate = new FileUploadDialogState();
        this.activereqid = "";
        this.initdatasheetid = "";
        this.initischemaid = "";
        this.initrowid = "";
        this.deletingschema = false;
        this.startnewview = false;
        this.rebuildingcustom = false;
        this.deletingschid = "";
        this.vfx = 0;
        this.vfy = 0;
        this.cfx = 0;
        this.cfy = 0;
        this.chartfx = 0;
        this.chartfy = 0;
        this.sfx = 0;
        this.sfy = 0;
        this.fieldfx = 0;
        this.fieldfy = 0;
        this.gfx = 0;
        this.gfy = 0;
        this.rfx = 0;
        this.rfy = 0;
        this.wvfx = 0;
        this.wvfy = 0;
        this.attachvfx = 0;
        this.attachvfy = 0;
        this.defaultdetailtab = "detail";
        this.showoperatormenu = false;
        this.datasheets = new Map();
        this.duplicatecount = 0;
        this.lastschemaupdatetime = -1;
        this.updateitemcount = 0;
        this.initialTopMostItemIndex = 0;
        this.currentactiverowid = "";
        this.colEditId = "";
        this.editColName = "";
        this.selattachids = [];
        this.attachdialogfilter = "";
        this.colDeleteId = "";
        this.addingtriggers = false;
        this.loadingremotecontent = false;
        this.remoteRowsMap = new Map();
        this.activeremoteschema = "";
        this.rerunning = false;
        this.remoteRowRules = new Map();
        this.customtabs = new Set();
        this.activecustomtab = "";
        // public rtdependentdata: Map<string, TabSchemaRemoteItem[]> = new Map();
        this.activeschemametalist = new Set();
        this.reportname = "";
        this.showreport = false;
        this.activewebview = "";
        this.showcustomview = false;
        this.showsearchbar = false;
        this.barcodeinput = new Map();
        this.mapofdep = new Map();
        this.triggerrowids = new Set();
        this.showonhomepage = false;
        this.twopanelfields = new Set();
        this.reverseorder = false;
        this.enableCodeView = false;
        this.userid = "";
        this.newrowindex = "";
        makeObservable(this);
        APPEvent.addSubscriberForGetUpdateSince((req) => {
            const scb = this.customgetupdatessince.get(req.reqsid);
            if (scb) {
                scb(req);
            }
        });
        APPEvent.addSubscriberForUserID((id) => {
            this.userid = id;
        });
        APPEvent.addSubscriberForGetDatasheet((schs) => {
            for (const sch of schs) {
                if (sch.letrid === this.activelterid) {
                    this.addDatasheet(sch);
                }
            }
        });
        APPEvent.addSubscriberForGetSchemaStateData((d) => {
            var _a, _b, _c;
            if (this.gettingstate.has(d.id)) {
                (_a = this.gettingstate.get(d.id)) === null || _a === void 0 ? void 0 : _a(d.id, (_c = (_b = d.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : '');
            }
            this.removeSchemaState(d.id);
        });
        APPEvent.addSubscriberForStoreSchemaStateData((d) => {
            var _a, _b, _c;
            if (this.savingstate.has(d.id)) {
                (_a = this.savingstate.get(d.id)) === null || _a === void 0 ? void 0 : _a(d.id, (_c = (_b = d.data) === null || _b === void 0 ? void 0 : _b.data) !== null && _c !== void 0 ? _c : '');
            }
            this.removeSchemaSaveState(d.id);
        });
        APPEvent.addSubscriberForGettriggers((trs) => {
            if (trs.ok) {
                if (trs.tigs.length > 0 && trs.tigs[0].schemaid === this.activeschema) {
                    this.addTrigger(trs.tigs);
                }
            }
        });
        APPEvent.addSubscriberForAddtriggers((trs) => {
            if (this.triggerrulebuilder.saving) {
                if (trs.ok) {
                    this.addTrigger(trs.tigs);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to save trigger");
                }
                this.triggerrulebuilder.setSaving(false);
            }
            ;
        });
        APPEvent.addSubscriberForAddDatasheet((sh) => {
            if (sh.sh && sh.sh.letrid === this.activelterid) {
                this.addDatasheet(sh.sh);
            }
        });
        APPEvent.addSubscriberForUpdateDatasheet((up) => {
            if (up.ok) {
                this.addDatasheet(up.sch);
            }
        });
        APPEvent.addSubscriberForGetWebViews((vs) => {
            if (vs.schemaid === this.activeschema) {
                this.clearAllViews();
                for (const v of vs.views) {
                    this.setView(v);
                }
                this.setLoadingViews(false);
            }
        });
        APPEvent.addSubscriberForAttachBarcode((res) => {
            if (this.attchinglabel) {
                if (res.res.schemaid === this.activeschema) {
                    if (res.ok) {
                        this.updateRowBarcode(res.res.rowid, res.res.barcode);
                    }
                    else {
                        APPEvent.publishApperror("Sorry failed to attach barcode. Please try again later or contact support");
                    }
                }
                this.setAttachinglabel(false);
            }
        });
        APPEvent.addSubscriberForAddWebViews((vs) => {
            if (vs.shid === this.activeschema) {
                if (vs.view) {
                    this.setView(vs.view);
                    this.setStartActiveNewView(false);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add app view. Please make sure to check your permissions and try again.");
                }
                this.setAddingView(false);
            }
        });
        APPEvent.addSubscriberForUpdateWebViews((vs) => {
            if (vs.shid === this.activeschema) {
                if (vs.view) {
                    this.setView(vs.view);
                    this.setStartActiveNewView(false);
                    this.vieweditid = "";
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to update app view. Please make sure to check your permissions and try again.");
                }
                this.setAddingView(false);
            }
        });
        APPEvent.addSubscriberForDeleteRow((del) => {
            var _a;
            if (this.deleteingrows && del.sid === this.activeschema) {
                if (del.deleteall) {
                    this.setActiveSchema(this.activeschema);
                }
                else {
                    for (const rid of del.rids) {
                        this.removeRow(rid);
                    }
                }
                (_a = this.updatesb) === null || _a === void 0 ? void 0 : _a.call(this);
                this.setDeleteingRows(false);
            }
        });
        APPEvent.addSubscriberForSchemaAnalytics((ans) => {
            if (ans.letrid !== this.activelterid)
                return;
            this.clearAns();
            for (const an of ans.ans) {
                this.addAns(an);
            }
            this.setGettingAns(false);
        });
        APPEvent.addSubscriberForDependResp(async (res) => {
            var _a, _b;
            if (!res.floating && res.schemaid === this.activeschema) {
                // awesome!!
                // lets store this now
                this.schemadep = res;
                // lets build data for columns now!!
                const mapofdata = new Map();
                if (res.depn) {
                    for (const en of res.depn) {
                        if (!mapofdata.has(en.id)) {
                            mapofdata.set(en.id, []);
                        }
                        (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(...en.entries);
                    }
                }
                // we should create some missing columns that we might need!!
                // there might be rule 
                let dsrows = convertDepToRows(mapofdata);
                for (const s of dsrows.keys()) {
                    this.depschemarows.set(s, (_b = dsrows.get(s)) !== null && _b !== void 0 ? _b : []);
                }
                //  this.depschemarows = convertDepToRows(mapofdata);
                if (res.schemas) {
                    for (const shh of res.schemas) {
                        this.schemasmap.set(shh.id, shh);
                        if (shh.apicode) {
                            this.schemaapimap.set(shh.apicode, shh);
                        }
                        if (shh.templateid) {
                            this.schematemplatemap.set(shh.templateid, shh);
                        }
                    }
                }
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex));
                this.setFeatchingDepende(false);
                for (const en of this.waitingentries) {
                    // lets do these first and then we will be fine!
                    this.parseCellRule(en);
                }
                this.waitingentries = [];
                // also build the rule for one that are done!!
            }
        });
        APPEvent.addSubscriberForDeleteDatasheet((del) => {
            if (!this.deletingschema) {
                return;
            }
            if (!del.ok) {
                APPEvent.publishApperror("Sorry, failed to delete datasheet");
            }
            this.setDeleting(false);
        });
        APPEvent.addSubscriberForGetDatasheet((schs) => {
            if (this.initdatasheetid) {
                for (const sh of schs) {
                    if (sh.id === this.initdatasheetid) {
                        this.setActiveDatasheet(this.initdatasheetid);
                        break;
                    }
                }
                this.initdatasheetid = "";
            }
        });
        APPEvent.addSubscriberForDeleteSchema((sh) => {
            if (sh.ok) {
                if (this.schemas.has(sh.id)) {
                    // lets delete this chema now
                    this.removeSchema(sh.id);
                }
            }
            else if (sh.id === this.deletingschid) {
                APPEvent.publishApperror("Sorry, failed to delete worksheet");
            }
            if (sh.id === this.deletingschid) {
                this.setDeleting(false);
            }
        });
        APPEvent.addSubscriberForUpdateDatasheet((sh) => {
            this.setUpdatingDatasheet(false);
        });
        APPEvent.addSubscriberForDeleteWebViews((v) => {
            if (this.dviews.has(v.id)) {
                if (!v.ok) {
                    APPEvent.publishApperror("Sorry, failed to delete view.");
                }
                else {
                    this.removeView(v.id);
                }
                this.removeViewFromDelete(v.id);
            }
        });
        APPEvent.addSubscriberForUpdateSchema((sh) => {
            if (sh.ok) {
                if (sh.colEditId && sh.colEditId === this.colEditId) {
                    //do nothing
                    this.editSchemaItem();
                    this.setColEditId("");
                    this.setEditColName("");
                }
                else if (sh.colDeleteId && sh.colDeleteId === this.colDeleteId && sh.sch.id === this.activeschema) {
                    this.deleteSchemaItem();
                }
                else {
                    if (sh.sch.datasheetid === this.activedatasheet) {
                        this.addSchema(sh.sch);
                    }
                    // we dont need to reload if already have things!
                    if (sh.sch.id === this.activeschema && !this.footerrulebilder.saving) {
                        this.setActiveSchema(this.activeschema);
                    }
                    this.setSavngSchema(false);
                    this.metadatadialog.setOpen(false);
                    this.rulebuilderstate.setShow(false);
                    this.footerrulebilder.setShow(false);
                    this.datarulebuilder.setShow(false);
                    this.setShowWorksheetAttach(false);
                }
            }
            else if (this.rulebuilderstate.saving) {
                APPEvent.publishApperror("Sorry, failed to save rule. Please try again later");
            }
            else if (this.footerrulebilder.saving) {
                APPEvent.publishApperror("Sorry, failed to save rules. Please try again later");
            }
            else if (sh.colEditId && sh.colEditId === this.colEditId) {
                APPEvent.publishApperror("Sorry, failed to edit column name. Please try again later.");
            }
            else if (sh.colDeleteId && sh.colDeleteId === this.colDeleteId) {
                APPEvent.publishApperror("Sorry, failed to delete column. Please try again later.");
            }
            else if (this.datarulebuilder.saving) {
                APPEvent.publishApperror("Sorry, failed to save rule. Please try again later");
            }
            else if (this.attaching) {
                APPEvent.publishApperror("Sorry, failed save attachments. Please try again later");
            }
            else if (this.addingbarcodecol) {
                APPEvent.publishApperror("Sorry, failed add barcode column. Please try again later");
            }
            this.setAttaching(false);
            this.setAddingBarcodecol(false);
            this.datarulebuilder.setSaving(false);
            this.rulebuilderstate.setSaving(false);
            this.footerrulebilder.setSaving(false);
            this.setColDeleteId("");
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForUpdateRows((res) => {
            var _a;
            if (res.schemaid === this.activeschema) {
                for (const data of res.row) {
                    this.updateRow((_a = data.rowid) !== null && _a !== void 0 ? _a : '', data.entry);
                }
                this.dataruleexec.setExecuting(false);
                this.dataruleexec.setShow(false);
            }
        });
        APPEvent.addSubscriberForUpdateEntry((data) => {
            var _a;
            if (data.sid === this.activeschema && data.row !== undefined) {
                this.updateRow((_a = data.rowid) !== null && _a !== void 0 ? _a : '', data.row.entry);
                this.setActiveRowId(""); //
                this.setSavingRow(false);
                this.rowrulebuilderstate.setSaving(false);
                this.rowrulebuilderstate.setShow(false);
            }
        });
        APPEvent.addSubscriberForSaveNote((sn) => {
            if (sn.letrid === this.activelterid &&
                sn.objectid == "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid
                && sn.reqid === this.activerequestid) {
                if (sn.note) {
                    this.addNote(sn.note);
                }
                this.setSavingNote(false);
                this.setStartNotes(false);
                this.setShowComments(false);
                this.commentstate.clear();
                this.clearLinks();
            }
        });
        APPEvent.addSubscriberForGetNote((notes) => {
            if (notes.ischooser) {
                return;
            }
            if (notes.letrid === this.activelterid && notes.objectid.indexOf("datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) !== -1) {
                notes.note.forEach((n) => {
                    if (n.status === NoteStatus.Dead) {
                        this.removeNote(n.id);
                    }
                    else {
                        this.setAuthor(n);
                        this.addNote(n);
                    }
                });
                this.setLoadingNotes(false);
                this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
            }
        });
        APPEvent.addSubscriberForUpdateAndAddRows(() => {
            window.location.reload();
        });
        APPEvent.addSubscriberForAddEntries(async (added) => {
            var _a, _b;
            if (added.reqid === this.activeentriesid) {
                if (added.ok && added.row && ((_a = added.row) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    // okay we have everything
                    await this.addRowInline(added.row, false);
                    this.insertRowsAtEnd(added.row); // this can be wrong too!!
                    // maybe we should scroll too 
                    this.setActiveRowId("");
                    (_b = this.tableref) === null || _b === void 0 ? void 0 : _b.scrollToIndex(this.rowsMap.size - 1);
                    this.schemaimportstate.setShow(false);
                    this.remoteitembuilder.setShow(false);
                    this.schemabuilderstate.setShow(false);
                    for (const r of added.row) {
                        this.changedrowsid.add(r.rowid);
                    }
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add rows");
                }
                this.schemaimportstate.setSaving(false);
                this.remoteitembuilder.setAdding(false);
                this.schemabuilderstate.setSaving(false);
            }
        });
        APPEvent.addSubscriberForRowRules((rules) => {
            if (rules[0].schemaid === this.activeschema) {
                this.cleaRowRule();
                for (const rr of rules) {
                    this.addRowRule(rr);
                }
                if (this.rowrulebuilderstate.saving) {
                    this.collectRowsAndBuildRulesResult(); // re do collection now!!
                }
                if (this.activerowid) {
                    const ar = this.rowsMap.get(this.activerowid);
                    if (ar) {
                        this.updateRow(ar.rowid, ar.entry);
                    }
                }
                // lets also collect the data again ?
                this.rowrulebuilderstate.setSaving(false);
                this.rowrulebuilderstate.setShow(false);
                this.rowdatarulebuilderstate.setSaving(false);
                this.rowdatarulebuilderstate.setShow(false);
            }
        });
        APPEvent.addSubscriberForAddEntry((added) => {
            var _a, _b;
            if (added.duplicaterequest) {
                if (added.row) {
                    this.addRow(added.row);
                    this.insertRowsAtEnd([added.row]);
                    // maybe we should scroll too 
                    (_a = this.tableref) === null || _a === void 0 ? void 0 : _a.scrollToIndex(this.rowsMap.size - 1);
                    this.changedrowsid.add(added.row.rowid);
                }
                if (this.duplicating) {
                    this.setDuplicatedCount(++this.duplicatingcount);
                    if (this.duplicatingcount >= this.totalduplicatecount) {
                        this.setDuplicatingRows(false);
                    }
                    else {
                        this.addNextDuplicate();
                    }
                }
            }
            else if (added.reqid === this.activereqid) {
                if (added.row) {
                    // okay we have everything
                    this.addRow(added.row);
                    this.insertRowsAtEnd([added.row]);
                    // maybe we should scroll too 
                    this.setActiveRowId("");
                    (_b = this.tableref) === null || _b === void 0 ? void 0 : _b.scrollToIndex(this.rowsMap.size - 1);
                    this.setShowForm(false);
                    this.changedrowsid.add(added.row.rowid);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add new row");
                }
                this.setStoringForm(false);
            }
        });
        APPEvent.addSubscriberForPartialRows(async (rows) => {
            var _a;
            if (rows.floating || rows.schemaid !== this.activeschema) {
                return;
            }
            if (rows.rows.length > 0) {
                await this.addRowInline(rows.rows, false);
                //await this.addToTemp(rows.rows);
                this.setLoadedRows(this.rowsMap.size);
            }
            if (rows.islast) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRowRule(rr);
                    }
                }
                if (rows.deps) {
                    this.decryptAndSetupDepRemoteItems(rows.deps, (_a = rows.depsdep) !== null && _a !== void 0 ? _a : []);
                }
                this.checkAndAddSoftRowsForItem();
                await this.addRuleEntryToRows();
                if (this.initactivedetailtab !== undefined) {
                    this.setActiveTab(this.initactivedetailtab);
                }
                // we have new rules now
                this.collectRowsAndBuildRulesResult();
                if (this.initrowid && this.rowsMap.has(this.initrowid)) {
                    this.setActiveRowId(this.initrowid);
                }
                this.initactivedetailtab = undefined;
                await this.buildRowsArray();
                this.initrowid = "";
                this.setLoadingContent(false);
            }
        });
        APPEvent.addSubscriberForRemoteRows(async (rows) => {
            if (this.loadingremotecontent && rows.schemaid === this.activeremoteschema) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRemoteRowRule(rr);
                    }
                }
                await this.addRemoteRows(rows.rows);
                this.setLoadingRemoteContent(false);
            }
        });
        APPEvent.addSubscriberForGetRows(async (rows) => {
            var _a;
            // lets now sort and add these rows!!
            if (rows.floating || rows.schemaid !== this.activeschema) {
                return;
            }
            if (this.loadingcontent) {
                if (rows.rules) {
                    for (const rr of rows.rules) {
                        this.addRowRule(rr);
                    }
                }
                // lets decrypt the data as well!!
                // we dont need to get the 
                if (rows.deps) {
                    this.decryptAndSetupDepRemoteItems(rows.deps, (_a = rows.depsdep) !== null && _a !== void 0 ? _a : []);
                }
                await this.addRows(rows.rows);
                await this.addRuleEntryToRows();
                if (this.initrowid && this.rowsMap.has(this.initrowid)) {
                    this.setActiveRowId(this.initrowid);
                }
                if (this.initactivedetailtab !== undefined) {
                    this.setActiveTab(this.initactivedetailtab);
                }
                this.initrowid = "";
                // we have new rules now
                this.collectRowsAndBuildRulesResult();
                this.initactivedetailtab = undefined;
                this.setLoadingContent(false);
            }
        });
        APPEvent.addSubscriberForActiveLetr((letr) => {
            if (this.activelterid !== letr) {
                this.activelterid = letr;
                this.reset();
            }
        });
        APPEvent.addSubscriberForAddRow((res) => {
            if (this.addingrowtochild && res.schemaid === this.activeschema) {
                if (!res.ok) {
                    APPEvent.publishApperror("Sorry, failed to add rows to the dervied schema");
                }
                else {
                    this.setActiveChildSchema("");
                    for (const rid of res.rowid) {
                        this.addSchemaToRowChList(rid, res.childschema);
                    }
                }
                this.setAddingRowToChildren(false);
                this.setReadonlyRows(false);
            }
        });
        APPEvent.addSubscriberForAddSchema((sch) => {
            if (sch.sh && sch.sh.datasheetid === this.activedatasheet) {
                this.addSchema(sch.sh);
                if (sch.sh.parentschema) {
                    this.addSchemaToParent(sch.sh);
                }
                this.setActiveSchema(sch.sh.id);
                if (this.schemabuilderstate.saving) {
                    if (this.schemabuilderstate.saveDatacb) {
                        this.schemabuilderstate.saveDatacb();
                    }
                    else {
                        this.schemabuilderstate.setSaving(false);
                        this.schemabuilderstate.setShow(false);
                    }
                }
            }
        });
        APPEvent.addSubscriberForGetSchema((schs) => {
            if (schs.floating) {
                return;
            }
            let set = "";
            for (const sch of schs.schema) {
                if (sch.letrid === this.activelterid) {
                    this.addSchema(sch);
                    if (this.activeschema === sch.id ||
                        this.initischemaid === sch.id) {
                        set = sch.id;
                    }
                }
            }
            if (!set && this.schemas.size > 0) {
                set = Array.from(this.schemas.values()).sort((sh1, sh2) => sh1.name.toLowerCase().localeCompare(sh2.name.toLowerCase()))[0].id;
                this.initrowid = "";
            }
            if (set) {
                this.setActiveSchema(set);
            }
            this.initischemaid = "";
            this.setLoading(false);
        });
        APPEvent.addSubscriberForNoteDelete((req) => {
            if (req.type === ObjectUpdateType.Comment) {
                if (req.objectid === this.editnoteid) {
                    if (req.ok) {
                        this.commentstate.removeComment(req.id);
                    }
                    else {
                        APPEvent.publishApperror("Sorry, failed to delete the comment.");
                        this.commentstate.removeCommentFromDelete(req.id);
                    }
                }
                else if (req.objectid.startsWith("datasheet-")) {
                    if (req.ok) {
                        this.chatstate.removeComment(req.id);
                    }
                    else {
                        APPEvent.publishApperror("Sorry, failed to delete the comment.");
                        this.chatstate.removeCommentFromDelete(req.id);
                    }
                }
                return;
            }
            if (this.deletenoteids.has(req.id)) {
                if (!req.ok) {
                    APPEvent.publishApperror("Sorry, failed to delete the note.");
                }
                else {
                    this.removeNote(req.id);
                }
                if (this.editnoteid === req.id) {
                    this.setEditMode(false);
                    this.setEditNoteId("");
                    this.setAppliedAclString("");
                    this.selectAccessids([ALLViewer]);
                }
                this.removeDeletingNote(req.id);
            }
        });
        APPEvent.addSubscriberForSaveComments((res) => {
            if (this.commentstate.sendingcomments.has(res.replaceid)) {
                this.commentstate.removeSendingComment(res.replaceid);
                if (res.comment !== undefined) {
                    if (res.noteid === "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
                        this.chatstate.setComment(res.comment);
                    }
                    else {
                        this.commentstate.setComment(res.comment);
                    }
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add comment");
                }
            }
        });
        APPEvent.addSubscriberForRemoveRowFromChildSh((sh) => {
            if (sh.ok && sh.schemaid === this.activeschema) {
                // we should now remove this!
                for (const rid of sh.rowid) {
                    this.removeSchemaFromRowChList(rid, sh.childschema);
                }
            }
            this.removeIdToRemovingCh(sh.childschema);
        });
        APPEvent.addSubscriberForNoteUpdate((up) => {
            if (up.letrid === this.activelterid && up.objectid === "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
                /// we good to go here now!!
                let lastupdatetime = -1;
                for (const n of up.notes) {
                    if (n.status !== NoteStatus.Dead) {
                        this.addNote(n);
                    }
                    else {
                        // delete this note that's all!
                        this.removeNote(n.id);
                    }
                    if (n.updatetime > lastupdatetime) {
                        lastupdatetime = n.updatetime;
                    }
                }
                if (lastupdatetime > -1) {
                    this.lastnotesupdatetime = lastupdatetime;
                }
                else {
                    this.lastnotesupdatetime = new Date().getTime();
                }
            }
        });
        APPEvent.addSubscriberForGetComments((res) => {
            if (res.noteid === this.editnoteid) {
                // lets just add these now
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.commentstate.removeComment(com.id);
                    }
                    else {
                        this.commentstate.setComment(com);
                    }
                    if (com.updatetime > this.lastcommenttime) {
                        this.lastcommenttime = com.updatetime;
                    }
                });
                this.setLoadingComments(false);
            }
            else if (res.noteid === "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.chatstate.removeComment(com.id);
                    }
                    else {
                        this.chatstate.setComment(com);
                    }
                    if (com.updatetime > this.lastchattime) {
                        this.lastchattime = com.updatetime;
                    }
                });
                this.setLoadingChat(false);
                this.chattimeout = setTimeout(() => this.getChatUpdate(), 10000);
            }
        });
        this.metadatadialog.setHeaderLabel("Manage Metadata");
        this.metadatadialog.setOkLabel("Save");
        this.metadatadialog.onOk = () => {
            this.setSavngSchema(true);
            this.saveMetaSchema();
        };
        APPEvent.addSubscriberForDuplicateRowRes(async (res) => {
            var _a;
            if (res.letrid === this.activelterid && res.sid === this.activeschema && this.duplicating) {
                await this.addDuplicateRows(res);
                (_a = this.tableref) === null || _a === void 0 ? void 0 : _a.scrollToIndex(this.getRows().length - 1);
                this.setDuplicatingRows(false);
            }
        });
        APPEvent.addSubscriberForSchemaUpdate(async (res) => {
            if (res.letrid === this.activelterid && res.schemaid === this.activeschema) {
                if (res.itemcount > 0) {
                    this.setUpdateItemCount(res.itemcount);
                }
            }
        });
        // APPEvent.addSubscriberForDeleteAppUser((ud) => {
        //     const wvs = Array.from(this.schemaviews.values());
        //     if(ud.delids !== undefined && ud.delids.length > 0) {
        //         for (const sv of wvs) {
        //             for(const d of ud.delids) {
        //                 if (sv.appformbox) {
        //                     for (let i=0; i < sv.appformbox.length;  i++) {
        //                         if (sv.appformbox[i].id === d) {
        //                             sv.appformbox.splice(i, 1);
        //                         }
        //                     }
        //                 }
        //                 if (sv.formusers) {
        //                     for (let i=0; i < sv.formusers.length;  i++) {
        //                         if (sv.formusers[i].id === d) {
        //                             sv.formusers.splice(i, 1);
        //                         }
        //                     }
        //                 }
        //             }
        //         } 
        //     }
        // });
    }
    setAddNForms(n) {
        this.addnforms = parseInt(n + "") + "";
    }
    createForms() {
        if (this.addnforms) {
            let ni = parseInt(this.addnforms);
            if (!isNaN(ni)) {
                for (let n = 0; n < ni; n++) {
                    this.addNewForm(false);
                }
            }
        }
    }
    setTwoPanelField(fid) {
        this.twopanelfields.add(fid);
    }
    clearTwoPanelField() {
        this.twopanelfields.clear();
    }
    setLoadingAnaView(loading) {
        this.loadinganaview = loading;
    }
    buildAnalyticsConfig() {
    }
    setShowSearchBar(show) {
        this.showsearchbar = show;
    }
    setAddingTriggers(show) {
        this.addingtriggers = show;
    }
    setShowReport(show) {
        this.showreport = show;
    }
    setRowSorter(rows) {
        this.rowsorter = rows;
        localStorage.setItem(this.activeschema + "_sortby", rows);
    }
    setRowSorterOrder(as) {
        localStorage.setItem(this.activeschema + "_sortasc", as ? 'asc' : 'dec');
        this.rowsorterorderasc = as;
    }
    addCustomTab(tab) {
        this.customtabs.add(tab);
    }
    setAddingView(adding) {
        this.addview = adding;
        if (!adding) {
            this.setViewAll(false);
            this.setViewName("");
            this.setShowOnHomePage(false);
            this.setReverseOrder(false);
            this.setEnableCodeView(false);
            this.twopanelfields = new Set();
        }
    }
    reorderListItem(changetitem, newindex, item) {
        if (newindex > item.items.length - 1) {
            newindex = item.items.length - 1;
        }
        changetitem.orderindex = newindex;
        const exititem = item.items[newindex];
        let newitems = [];
        for (let i = 0; i < newindex; i++) {
            newitems.push(item.items[i]);
        }
        newitems.push(changetitem);
        for (let i = newindex; i < item.items.length; i++) {
            const mit = item.items[i];
            if (mit.id === changetitem.id)
                continue;
            mit.orderindex = i + 1;
            newitems.push(mit);
        }
        item.items = newitems;
    }
    getUpdateSince(sid, since, cb) {
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            reqschemaid: sid,
            since: since,
        };
        this.customgetupdatessince.set(sid, cb);
        Apphandler.sendMessage("getUpdatesSince", req);
    }
    getChangedRows() {
        let rows = [];
        console.log(this.changedrowsid);
        for (const rr of this.changedrowsid) {
            let rs = this.rowsMap.get(rr);
            if (rs) {
                rows.push(rs);
            }
        }
        return rows;
    }
    arrangeCells(ens) {
        // the way to arrange these will be via the 
        var _a;
        ens.sort((en1, en2) => {
            var _a, _b;
            const s1 = (_a = en1.subrowindex) !== null && _a !== void 0 ? _a : -1;
            const s2 = (_b = en2.subrowindex) !== null && _b !== void 0 ? _b : -1;
            if (s1 === -1 && s2 === -1) {
                return 0;
            }
            if (s1 === -1) {
                return 1;
            }
            if (s2 === -1) {
                return -1;
            }
            const parts1 = s1.split("----");
            const parts2 = s2.split("----");
            if (parts1[0] === parts2[0]) {
                // if(parts1.length < 2 || parts2.length < 2) {
                //     return -1;
                // }
                return parts1[1].localeCompare(parts2[1]);
            }
            return parseInt(parts1[0]) - parseInt(parts2[0]);
        });
        let trow = [];
        const rows = [];
        for (const en of ens) {
            const s1 = (_a = en.subrowindex) !== null && _a !== void 0 ? _a : -1;
            if (s1 !== -1) {
                if (trow.indexOf(s1) === -1) {
                    trow.push(s1);
                }
            }
        }
        return trow;
    }
    setExpandEntireList(id) {
        this.expandlistitem.add(id);
        this.storeCurrentStateForLists();
    }
    storeCurrentStateForLists() {
        let aid = this.activeschema;
        if (aid) {
            let el = [];
            let elr = [];
            let obj = { "exandlist": el, "expandrows": elr };
            for (const ii of this.expandlistitem) {
                obj["exandlist"].push(ii);
            }
            for (const [id, rows] of this.expandlistrow) {
                for (const row of rows) {
                    let rid = id + "----" + row;
                    obj["expandrows"].push(rid);
                }
            }
            window.localStorage.setItem("liste" + aid, JSON.stringify(obj));
        }
    }
    readListState(aid) {
        var _a;
        if (aid) {
            let iiis = window.localStorage.getItem("liste" + aid);
            if (iiis) {
                let obj = JSON.parse(iiis);
                if (obj.exandlist) {
                    for (const ii of obj.exandlist) {
                        this.expandlistitem.add(ii);
                    }
                }
                if (obj.expandrows) {
                    for (const ii of obj.expandrows) {
                        let pp = ii.split("----");
                        if (!this.expandlistrow.has(pp[0])) {
                            this.expandlistrow.set(pp[0], new Set());
                        }
                        (_a = this.expandlistrow.get(pp[0])) === null || _a === void 0 ? void 0 : _a.add(pp[1]);
                    }
                }
            }
        }
    }
    setCollapseEntireList(id) {
        this.expandlistitem.delete(id);
        this.expandlistrow.delete(id);
        this.storeCurrentStateForLists();
    }
    setExpandListRow(id, rowid) {
        var _a;
        let rows = this.expandlistrow.get(id);
        if (!rows) {
            rows = new Set();
            this.expandlistrow.set(id, rows);
        }
        (_a = this.expandlistrow.get(id)) === null || _a === void 0 ? void 0 : _a.add(rowid);
        this.storeCurrentStateForLists();
    }
    setCollapseListRow(id, rowid) {
        let rows = this.expandlistrow.get(id);
        if (rows) {
            rows.delete(rowid);
        }
        this.storeCurrentStateForLists();
    }
    addNewForm(setac = true) {
        if (this.activeformid) {
            this.newformmap.set(this.activeformid, new Map(this.formentry));
        }
        let id = Math.random() + "-" + this.newformmap.size;
        this.newformmap.set(id, new Map());
        if (setac) {
            this.activeformid = id;
        }
        return id;
    }
    removeForm(id) {
        this.newformmap.delete(id);
        if (this.activeformid === id) {
            this.activeformid = "";
            this.setActiveForm(Array.from(this.newformmap.keys())[0]);
        }
    }
    setActiveForm(id) {
        var _a;
        if (!this.newformmap.has(id))
            return;
        if (this.activeformid) {
            this.newformmap.set(this.activeformid, new Map(this.formentry));
            if (this.newlistitemsmap.size > 0) {
                this.listdetails.set(this.activeformid, new Map(this.newlistitemsmap));
            }
        }
        this.newlistitemsmap = new Map();
        this.activeformid = id;
        let deets = this.listdetails.get(this.activeformid);
        if (deets) {
            this.newlistitemsmap = deets;
        }
        this.formentry = (_a = this.newformmap.get(id)) !== null && _a !== void 0 ? _a : new Map();
    }
    async collectRowsToUpdate(rtupdate) {
        var _a, _b;
        const achema = this.schemas.get(this.activeschema);
        const req = [];
        if (achema === undefined) {
            return [];
        }
        const rmap = new Map();
        const rowarr = Array.from(this.rowsMap.values());
        const rtupdatemap = new Map();
        const cellidinnterested = new Set();
        rtupdate.map((rt) => {
            rtupdatemap.set(rt.id, rt);
        });
        const fields = this.sortedschemaitems.slice().filter(it => {
            if (it.id.indexOf("----") !== -1) {
                const lit = it;
                for (const lii of lit.items) {
                    if (rtupdatemap.has(it.id + "----" + lii.id)) {
                        return true;
                    }
                }
                return false;
            }
            return rtupdatemap.has(it.id);
        });
        for (let i = 0; i < rowarr.length; i++) {
            if (i % 100 === 0)
                await timeout(20);
            const emap = new Map();
            const row = rowarr[i];
            // ohh the mainn 
            for (const en of row.entry) {
                if (!en.decrypted && rtupdatemap.has(en.cellid)) {
                    this.decryptCell(en);
                }
                let id = en.cellid;
                if (en.cellid.indexOf("----") !== -1) {
                    id = en.cellid.split("----")[0];
                }
                if (!emap.has(id)) {
                    emap.set(id, []);
                }
                (_a = emap.get(id)) === null || _a === void 0 ? void 0 : _a.push(en);
            }
            rmap.set(row.rowid, emap);
        }
        const cellmap = new Map();
        for (const shi of achema.items) {
            cellmap.set(shi.id, shi);
            if (shi.type === SchemaItemType.List) {
                const litem = shi;
                if (litem.items && litem.items.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                        for (const id of this.changedlistitems) {
                            if (id.indexOf(litem.id + "----" + item.id) !== -1) {
                                cellmap.set(id, item.item); //save we have sitem for this now!
                            }
                        }
                    }
                    ;
                }
            }
        }
        let count = 0;
        let siddenmap = new Map();
        let sidrdenmap = new Map();
        for (const entry of fields) {
            const uent = entry;
            const dp = this.mapofdep.get(uent.sid);
            if (dp !== undefined && dp.schemaopen !== undefined) {
                const entries = dp.entries;
                let counter = 0;
                const denmap = new Map();
                const rdenmap = new Map();
                for (const en of entries) {
                    counter++;
                    if (counter % 100 === 0)
                        await timeout(10);
                    if (!en.decrypted) {
                        GDecryptcell(en, dp.schemaopen);
                    }
                    denmap.set(en.id, en);
                    if (!rdenmap.has(en.rowid)) {
                        rdenmap.set(en.rowid, []);
                    }
                    (_b = rdenmap.get(en.rowid)) === null || _b === void 0 ? void 0 : _b.push(en);
                }
                siddenmap.set(uent.sid, denmap);
                sidrdenmap.set(uent.sid, rdenmap);
            }
        }
        for (const [k, v] of rmap) {
            count++;
            if (count % 100 === 0)
                await timeout(20);
            for (const entry of fields) {
                const ens = v.get(entry.id);
                if (ens !== undefined) {
                    const ent = ens[0];
                    if (entry.type !== SchemaItemType.List && entry.type === SchemaItemType.Remote && rtupdatemap.has(entry.id)) {
                        const uent = entry;
                        const dp = this.mapofdep.get(uent.sid);
                        if (dp !== undefined && dp.schemaopen !== undefined) {
                            const denmap = siddenmap.get(uent.sid);
                            const rdenmap = sidrdenmap.get(uent.sid);
                            if (!denmap || !rdenmap)
                                continue;
                            const bits = ent.celldata.split(",");
                            let remotevals = [];
                            for (const rb of bits) {
                                const ren = denmap.get(rb);
                                if (ren) {
                                    remotevals.push(ren);
                                }
                            }
                            let newrtvals = [];
                            for (const rv of remotevals) {
                                let match = false;
                                const rens = rdenmap.get(rv.rowid);
                                for (const e of rens !== null && rens !== void 0 ? rens : []) {
                                    if (rv.rowid === e.rowid && e.cellid === uent.cid) {
                                        newrtvals.push(e.id);
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) {
                                    newrtvals.push(rv.id);
                                }
                            }
                            if (newrtvals.length > 0) {
                                const sentries = [];
                                ent.celldata = newrtvals.join(",");
                                sentries.push(ent);
                                const reqid = Math.random() + "";
                                const areq = {
                                    letrid: this.activelterid,
                                    sid: this.activeschema,
                                    reqid: reqid,
                                    entries: sentries,
                                    accesskey: achema === null || achema === void 0 ? void 0 : achema.accesskey,
                                    nonce: achema === null || achema === void 0 ? void 0 : achema.nonce,
                                    rowid: k,
                                    duplicaterequest: false,
                                    schemaitems: Array.from(cellmap.values()),
                                    deleteentries: [],
                                    assigns: [],
                                    nvs: []
                                };
                                this.activereqid = reqid;
                                req.push(areq);
                            }
                        }
                    }
                    else if (entry.type === SchemaItemType.List) {
                        const items = entry.items;
                        const totalrows = this.arrangeCells(ens);
                        const entrymap = new Map();
                        const emap = new Map();
                        for (const ei of items) {
                            emap.set(entry.id + "----" + ei.id, ei.item);
                        }
                        for (const en of ens) {
                            if (!en.subrowindex)
                                continue;
                            entrymap.set(en.cellid + "----" + en.subrowindex, en);
                        }
                        const lientries = Array.from(emap.values());
                        const lsentries = [];
                        for (let i = 0; i < totalrows.length; i++) {
                            for (const lientry of lientries) {
                                if (lientry.type === SchemaItemType.Remote && rtupdatemap.has(lientry.id)) {
                                    const lient = entrymap.get(entry.id + "----" + lientry.id + "----" + totalrows[i]);
                                    const uent = lientry;
                                    const dp = this.mapofdep.get(uent.sid);
                                    if (lient !== undefined && dp !== undefined && dp.schemaopen !== undefined) {
                                        const denmap = siddenmap.get(uent.sid);
                                        const rdenmap = sidrdenmap.get(uent.sid);
                                        if (!denmap || !rdenmap)
                                            continue;
                                        const bits = lient.celldata.split(",");
                                        let remotevals = [];
                                        for (const rb of bits) {
                                            const ren = denmap.get(rb);
                                            if (ren) {
                                                remotevals.push(ren);
                                            }
                                        }
                                        let newrtvals = [];
                                        for (const rv of remotevals) {
                                            let match = false;
                                            const rens = rdenmap.get(rv.rowid);
                                            for (const e of rens !== null && rens !== void 0 ? rens : []) {
                                                if (rv.rowid === e.rowid && e.cellid === uent.cid) {
                                                    newrtvals.push(e.id);
                                                    match = true;
                                                    break;
                                                }
                                            }
                                            if (!match) {
                                                newrtvals.push(rv.id);
                                            }
                                        }
                                        if (newrtvals.length > 0) {
                                            lient.celldata = newrtvals.join(",");
                                            lsentries.push(lient);
                                        }
                                    }
                                }
                            }
                        }
                        if (lsentries.length > 0) {
                            const reqid = Math.random() + "";
                            const areq = {
                                letrid: this.activelterid,
                                sid: this.activeschema,
                                reqid: reqid,
                                entries: lsentries,
                                accesskey: achema === null || achema === void 0 ? void 0 : achema.accesskey,
                                nonce: achema === null || achema === void 0 ? void 0 : achema.nonce,
                                rowid: k,
                                duplicaterequest: false,
                                schemaitems: Array.from(cellmap.values()),
                                deleteentries: [],
                                assigns: [],
                                nvs: []
                            };
                            this.activereqid = reqid;
                            req.push(areq);
                        }
                    }
                }
            }
            ;
        }
        return req;
    }
    setTriggerRowIds(rowid, add) {
        if (add) {
            this.triggerrowids.add(rowid);
        }
        else {
            this.triggerrowids.delete(rowid);
        }
    }
    checkRowEnnrtyNeedAlert(schemarow, colid) {
        var _a, _b;
        const aschema = this.schemas.get(this.activeschema);
        if (!aschema)
            return false;
        if (this.triggersbyCols.size === 0 || !this.triggersbyCols.has(colid))
            return false;
        const coltgs = Array.from((_b = (_a = this.triggersbyCols.get(colid)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : []);
        if (coltgs.length === 0)
            return false;
        for (const en of schemarow.entry) {
            if (en.cellid === colid) {
                for (const tg of coltgs) {
                    const rule = {
                        type: RuleType.Add,
                        conds: tg.conds,
                        params: [],
                    };
                    let validrows = !tg.conds || tg.conds.length == 0 || checkRowSatifyCond(rule, schemarow, en, aschema, aschema);
                    if (validrows) {
                        try {
                            const myval = parseFloat(en.celldata);
                            const thre = parseFloat(tg.comparevalue);
                            let diff = 0;
                            const time = new Date().getTime();
                            if (!isNaN(myval)) {
                                if (tg.triggertype === TriggerType.Equal) {
                                    if (myval === thre) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.triggertype === TriggerType.Greater) {
                                    if (myval > thre) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.triggertype === TriggerType.GreaterEqual) {
                                    if (myval >= thre) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.triggertype === TriggerType.Less) {
                                    if (myval < thre) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.triggertype === TriggerType.LessEqual) {
                                    if (myval <= thre) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.reminderunit === ReminderUnit.days) {
                                    diff = parseInt(tg.comparevalue) * (24 * 60 * 60 * 1000);
                                    const rev = myval - diff;
                                    if (rev > 0 && rev <= time) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.reminderunit === ReminderUnit.hr) {
                                    diff = parseInt(tg.comparevalue) * 60 * 60 * 1000;
                                    const rev = myval - diff;
                                    if (rev > 0 && rev <= time) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.reminderunit === ReminderUnit.min) {
                                    diff = parseInt(tg.comparevalue) * (60 * 1000);
                                    const rev = myval - diff;
                                    if (rev > 0 && rev <= time) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                                else if (tg.reminderunit === ReminderUnit.missed) {
                                    diff = -(60 * 1000);
                                    const rev = myval - diff;
                                    if (rev > 0 && rev <= time) {
                                        this.setTriggerRowIds(schemarow.rowid, true);
                                        return true;
                                    }
                                }
                            }
                        }
                        catch (ex) { }
                    }
                }
            }
        }
        this.setTriggerRowIds(schemarow.rowid, false);
        return false;
    }
    async editWebView(name, type, users, code, appusers, configs, js, filterjs, defjs) {
        var _a;
        const aschema = this.schemas.get(this.activeschema);
        const lsh = this.schemaviews.get(this.vieweditid);
        if (!aschema || !lsh)
            return;
        const currentfilter = this.createFilterForView();
        const fileds = this.getAllFields();
        const colids = [];
        for (const f of fileds) {
            if (this.hiddencolumns.has(f.id))
                continue;
            colids.push(f.id);
        }
        const shv = users.filter((f) => f.id.startsWith("schem-"));
        const newview = {
            id: this.vieweditid,
            schemaid: this.activeschema,
            letrid: this.activelterid,
            filters: currentfilter,
            columnids: colids,
            useall: false,
            configs: configs,
            type: type,
            creatorid: '',
            code: lsh.code !== '' ? lsh.code : code,
            modifytime: 0,
            name: name,
            formusers: [],
            appformbox: users,
            appusers: users.map(u => u.id),
            displayjs: js,
            showonhomepage: this.showonhomepage,
            twopanelfields: Array.from(this.twopanelfields),
            reverseorder: this.reverseorder,
            customfilerjs: filterjs,
            customdefaultjs: defjs,
            enablescanview: (_a = this.enableCodeView) !== null && _a !== void 0 ? _a : false,
        };
        if (this.webviewreportsstate.selectedReports.size > 0) {
            newview['schemareports'] = Array.from(this.webviewreportsstate.selectedReports.values());
        }
        // lets check with all rows
        const request = {
            sh: aschema,
            view: newview,
            letrid: this.activelterid
        };
        if (shv.length > 0) {
            const musers = [];
            let index = 0;
            for (const r of this.rowsMap.values()) {
                const mycols = this.checkRowNeedsAutoAssigmentForView(r.entry, appusers, [newview], true);
                if (mycols && mycols.length > 0) {
                    musers.push(...mycols);
                }
                index++;
                if (index % 1000 === 0)
                    await timeout(10);
            }
            request.asscols = musers;
        }
        this.setAddingView(true);
        Apphandler.sendMessage("updatewebview", request);
    }
    setWebViewJs(js) {
        this.viewjs = js;
    }
    setWebViewFilterJs(js) {
        this.viewfilterjs = js;
    }
    setWebViewDefaultJs(js) {
        this.viewdefaultvaluejs = js;
    }
    setShowWebViewFilterJs(js) {
        this.showwebviewfilterjs = js;
    }
    setShowWebViewDefaultValueJS(js) {
        this.showdefaultvaluejs = js;
    }
    setCustomViewColWidth(id, wid) {
        this.webviewcolwidths.set(id, wid);
    }
    resetCustomViewColWidth() {
        this.webviewcolwidths.clear();
    }
    setWebViewNormalDisplat(js) {
        this.shownormaldispaly = js;
    }
    async attachLabelToRow(rowid, barcode) {
        const req = {
            letrid: this.activelterid,
            rowid: rowid,
            schemaid: this.activeschema,
            barcode: barcode
        };
        this.setAttachinglabel(true);
        Apphandler.sendMessage("attachbarcode", req);
    }
    setShowCustomView(show) {
        this.showcustomview = show;
    }
    updateRowBarcode(rid, barcode) {
        const row = this.rowsMap.get(rid);
        if (row) {
            for (const en of row.entry) {
                en.rowbarcode = barcode;
            }
        }
    }
    setAttachinglabel(att) {
        this.attchinglabel = att;
    }
    setAddingBarcodecol(att) {
        this.addingbarcodecol = att;
    }
    async fetchschemaRow(rowid, shd) {
        const aschema = this.schemas.get(shd);
        if (!aschema)
            return;
        let cids = [];
        if (aschema.items && aschema.items.length > 0) {
            for (let i = 0; i < aschema.items.length; i++) {
                const item = aschema.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
        }
        let req = {
            schemaid: shd,
            rowid: rowid,
            letrid: this.activelterid,
            cellids: cids
        };
        const ens = await comm.post(ServerPath.getSchemaRow, req);
        return ens;
    }
    async addWebView(name, type, users, code, appusers, configs, js, filterjs, defjs) {
        var _a;
        if (this.vieweditid) {
            this.editWebView(name, type, users, code, appusers, configs, js, filterjs, defjs);
            return;
        }
        const aschema = this.schemas.get(this.activeschema);
        if (!aschema)
            return;
        const currentfilter = this.createFilterForView();
        const fileds = this.getAllFields();
        const colids = [];
        for (const f of fileds) {
            if (this.hiddencolumns.has(f.id))
                continue;
            colids.push(f.id);
        }
        const shv = users.filter((f) => f.id.startsWith("schem-"));
        const newview = {
            id: '',
            schemaid: this.activeschema,
            letrid: this.activelterid,
            filters: currentfilter,
            columnids: colids,
            useall: false,
            code: code,
            configs: configs,
            type: type,
            creatorid: '',
            modifytime: 0,
            name: name,
            formusers: [],
            appformbox: users,
            appusers: users.map(u => u.id),
            displayjs: js,
            showonhomepage: this.showonhomepage,
            twopanelfields: Array.from(this.twopanelfields),
            reverseorder: this.reverseorder,
            customfilerjs: filterjs,
            customdefaultjs: defjs,
            enablescanview: (_a = this.enableCodeView) !== null && _a !== void 0 ? _a : false
        };
        if (this.webviewreportsstate.selectedReports.size > 0) {
            newview['schemareports'] = Array.from(this.webviewreportsstate.selectedReports.values());
        }
        const request = {
            sh: aschema,
            view: newview,
            letrid: this.activelterid
        };
        if (shv.length > 0) {
            const musers = [];
            let index = 0;
            for (const r of this.rowsMap.values()) {
                const mycols = this.checkRowNeedsAutoAssigmentForView(r.entry, appusers, [newview], true);
                if (mycols && mycols.length > 0) {
                    musers.push(...mycols);
                }
                index++;
                if (index % 1000 === 0)
                    await timeout(10);
            }
            request.asscols = musers;
        }
        this.setAddingView(true);
        Apphandler.sendMessage("addwebview", request);
    }
    setViewName(name) {
        this.viewname = name;
    }
    setShowOnHomePage(show) {
        this.showonhomepage = show;
    }
    setReverseOrder(order) {
        this.reverseorder = order;
    }
    setEnableCodeView(order) {
        this.enableCodeView = order;
    }
    setViewAll(all) {
        this.viewuseall = all;
    }
    setStartActiveNewView(start) {
        this.startnewview = start;
        if (!start) {
            this.setViewAll(false);
            this.setViewName("");
            this.setShowOnHomePage(false);
            this.setReverseOrder(false);
            this.setEnableCodeView(false);
        }
    }
    setAttachDialogtext(text) {
        this.attachdialogfilter = text;
    }
    removeAttachMents(id) {
        const index = this.selattachids.indexOf(id);
        if (index > -1) {
            this.selattachids.splice(index, 1);
        }
    }
    addAttachMents(id) {
        this.selattachids.push(id);
    }
    setAttachSelids(ids) {
        this.selattachids.splice(0, this.selattachids.length);
        this.selattachids.push(...ids);
    }
    setActiveCustomTab(tab) {
        this.activecustomtab = tab;
    }
    setLoadingRemoteContent(loading) {
        this.loadingremotecontent = loading;
    }
    deleteSchemaItem() {
        const aschema = this.schemas.get(this.activeschema);
        if (aschema !== undefined) {
            for (let i = 0; i < aschema.items.length; i++) {
                const it = aschema.items[i];
                if (it.id === this.colDeleteId) {
                    aschema.items.splice(i, 1);
                    break;
                }
            }
            for (let i = 0; i < this.sortedschemaitems.length; i++) {
                const it = this.sortedschemaitems[i];
                if (it.id === this.colDeleteId) {
                    this.sortedschemaitems.splice(i, 1);
                    break;
                }
            }
        }
        this.rebuildTable();
    }
    setLoadingViews(loading) {
        this.loadingviews = loading;
    }
    setReportName(name) {
        this.reportname = name;
    }
    async rebuildTable() {
        this.setLoadingContent(true);
        await timeout(100);
        this.setLoadingContent(false);
    }
    editSchemaItem() {
        const aschema = this.schemas.get(this.activeschema);
        if (aschema !== undefined) {
            for (let it of aschema.items) {
                if (it.id === this.colEditId) {
                    it.name = this.editColName;
                    break;
                }
            }
        }
    }
    setColDeleteId(id) {
        this.colDeleteId = id;
    }
    setEditColName(name) {
        this.editColName = name;
    }
    setColEditId(id) {
        this.colEditId = id;
    }
    fetchUpdates() {
        if (!this.activelterid || !this.activeschema || !this.activedatasheet) {
            return;
        }
        let locactive = "";
        if (this.activerowid) {
            locactive = this.activerowid;
        }
        this.setActiveSchema(this.activeschema);
        this.setActiveRowId(locactive);
    }
    setUpdateItemCount(count) {
        this.updateitemcount = count;
    }
    getSchemaUpdate() {
        if (!this.activelterid || !this.activeschema || !this.activedatasheet) {
            return;
        }
        const aschema = this.schemas.get(this.activeschema);
        if (this.lastschemaupdatetime === -1) {
            this.lastschemaupdatetime = new Date().getTime();
        }
        const updatereq = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            since: this.lastschemaupdatetime,
            datasheetid: this.activedatasheet,
        };
        Apphandler.sendMessage("activeschemaupdate", updatereq);
        this.schematimeout = setTimeout(() => this.getSchemaUpdate(), 10000);
    }
    showAllColumns() {
        this.hiddencolumns.clear();
    }
    setViewDefaultValue(id, val) {
        this.viewdefaultvalue.set(id, val);
    }
    setActiveWebView(id) {
        this.activewebview = id;
        this.viewdefaultvalue.clear();
    }
    setDuplicateCount(count) {
        this.duplicatecount = count;
    }
    async addDuplicateRows(res) {
        const dupres = res.duplicateres;
        let newrows = [];
        for (let i = 0; i < dupres.length; i++) {
            const dup = dupres[i];
            const origrow = this.rowsMap.get(dup.oldrowid);
            if (origrow !== undefined) {
                if (i > 0 && i % 1000 === 0)
                    await timeout(10);
                let entrymap = new Map();
                for (const en of origrow.entry) {
                    entrymap.set(en.id, en);
                }
                let entries = [];
                for (const ent of dup.cells) {
                    const oldentry = entrymap.get(ent.oldcellid);
                    if (oldentry !== undefined) {
                        const entry = {
                            id: ent.newcellid,
                            rowindex: dup.newrowindex,
                            rowid: dup.newrowid,
                            schemaid: oldentry.schemaid,
                            cellid: oldentry.cellid,
                            celldata: oldentry.celldata,
                            subrowindex: oldentry.subrowindex,
                            cellfindstr: oldentry.cellfindstr,
                            displaystr: oldentry.displaystr,
                            parentcellid: oldentry.parentcellid,
                            sortstring: oldentry.sortstring,
                            decrypted: oldentry.decrypted,
                            childrenschemalist: oldentry.childrenschemalist,
                            readonlyschemalist: oldentry.readonlyschemalist,
                            objs: oldentry.objs,
                            shs: oldentry.shs,
                            referenceids: oldentry.referenceids,
                            linkedids: oldentry.linkedids,
                            objsdec: oldentry.objsdec,
                            schsdec: oldentry.schsdec,
                            rule: oldentry.rule,
                            ruleopen: oldentry.ruleopen
                        };
                        entries.push(entry);
                    }
                }
                let nr = {
                    rowindex: dup.newrowindex,
                    rowid: dup.newrowid,
                    childrenschemalist: origrow.childrenschemalist,
                    entry: entries,
                    objsdec: origrow.objsdec,
                    shsdec: origrow.shsdec,
                    linkedids: origrow.linkedids,
                    referenceids: origrow.referenceids
                };
                this.setDuplicateCount(i + 1);
                newrows.push(nr);
                const ruleid = this.activeschema + "~~~" + origrow.rowid;
                const rowrule = {
                    id: this.activeschema + "~~~" + dup.newrowid,
                    schemaid: this.activeschema,
                    rowid: dup.newrowid,
                    letrid: this.activelterid,
                    data: [],
                    datarules: []
                };
                if (this.rowRules.has(ruleid)) {
                    const rr = this.rowRules.get(ruleid);
                    if (rr !== undefined) {
                        rowrule.data = rr.data;
                        this.rowRules.set(rowrule.id, rowrule);
                    }
                }
                if (this.rowDataRules.has(ruleid)) {
                    const rr = this.rowDataRules.get(ruleid);
                    if (rr !== undefined) {
                        rowrule.datarules = rr.datarules;
                        this.rowDataRules.set(rowrule.id, rowrule);
                    }
                }
            }
        }
        await this.addRows(newrows, false);
        await this.insertRowsAtEnd(newrows);
        await timeout(50);
        this.setDuplicateCount(0);
    }
    addDatasheet(sch) {
        this.datasheets.set(sch.id, sch);
    }
    setShowOperatorMenu(show) {
        this.showoperatormenu = show;
    }
    setSavngSchema(saving) {
        this.savingschema = saving;
    }
    setGanttTaskField(id) {
        this.ganttasknameid = id;
    }
    clearAns() {
        this.anas.clear();
        this.anasschema.clear();
    }
    // we need add and update stuff here
    addAns(an) {
        var _a, _b;
        if (an.schemaopen && an.dhopen) {
            this.anas.set((_a = an.schemaopen) === null || _a === void 0 ? void 0 : _a.id, an);
            if (!this.anasschema.has(an.dhopen.id)) {
                this.anasschema.set(an.dhopen.id, new Map());
            }
            (_b = this.anasschema.get(an.dhopen.id)) === null || _b === void 0 ? void 0 : _b.set(an.schemaopen.id, an);
        }
    }
    addSchemaRowJSUpdate() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        req.custompanels = this.customrowjs;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        Apphandler.sendMessage('updateschema', areq);
    }
    addSchemaBarcodeCol(id) {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        req.barcodecolumnid = id;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.setAddingBarcodecol(true);
        Apphandler.sendMessage('updateschema', areq);
    }
    addSchemaAttachmensts(ids) {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        req.viewdepentschemas = ids;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.setAttaching(true);
        Apphandler.sendMessage('updateschema', areq);
    }
    setAttaching(att) {
        this.attaching = att;
    }
    getAllDisplaySchemas() {
        const ret = [];
        if (this.anas.size > 0) {
            for (const [_, an] of this.anas) {
                if (an.schemaopen && an.dhopen) {
                    ret.push({
                        id: an.schemaopen.id,
                        name: an.dhopen.name + "!" + an.schemaopen.name
                    });
                }
            }
        }
        return ret;
    }
    sortedIndexForRow(row) {
        let low = 0, high = this.rowsarrids.length;
        while (low < high) {
            let mid = (low + high) >>> 1;
            if (this.rowsarrids[mid].rowindex < row.rowindex)
                low = mid + 1;
            else
                high = mid;
        }
        return low;
    }
    async insertRowsAtBeginning(rs) {
        var _a;
        let i = 0;
        this.rowsarrids.splice(0, 0, ...rs);
        (_a = this.updatesb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    async insertRowsAtEnd(rs) {
        var _a;
        let i = 0;
        const chunkSize = 10000;
        for (let i = 0; i < rs.length; i += chunkSize) {
            const chunk = rs.slice(i, i + chunkSize);
            this.rowsarrids.splice(this.rowsarrids.length, 0, ...chunk);
            await timeout(10);
        }
        (_a = this.updatesb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    // use this for 
    async insertRows(rs) {
        var _a;
        let i = 0;
        for (const r of rs) {
            if (i > 0 && i % 1000 === 0) {
                await timeout(10);
            }
            // now lets add the row in array!
            const rindex = this.sortedIndexForRow(r);
            this.rowsarrids.splice(rindex, 0, r);
            i++;
        }
        (_a = this.updatesb) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    setGettingAns(gett) {
        this.gettinganas = gett;
    }
    setUpdatingDatasheet(updating) {
        this.updatingdatasheet = updating;
    }
    addSchemaToRowChList(rid, sid) {
        const row = this.rowsMap.get(rid);
        if (row) {
            if (!row.childrenschemalist) {
                row.childrenschemalist = [];
            }
            if (row.childrenschemalist.indexOf(sid) === -1) {
                row.childrenschemalist.push(sid);
            }
            this.updateRow(row.rowid, []);
        }
    }
    addSchemaToParent(sch) {
        if (!sch.parentschema) {
            return;
        }
        const psch = this.schemas.get(sch.parentschema.id);
        if (psch) {
            if (!psch.childrenschema) {
                psch.childrenschema = [];
            }
            psch.childrenschema.push(sch);
        }
    }
    getAllFooterRuleFor(colid) {
        const sh = this.schemas.get(this.activeschema);
        if (!sh)
            return [];
        if (!sh.footers) {
            return [];
        }
        return sh.footers.filter((ft) => ft.colid === colid);
    }
    addSchemaRowsToRemote(sid, cid, myitemid) {
        var _a, _b, _c, _d, _e, _f;
        const sh = this.schemasmap.get(sid);
        if (!sh)
            return;
        const rows = this.depschemarows.get(sid);
        if (!rows || rows.length === 0)
            return;
        const id = myitemid + "---" + sid + "---" + cid;
        if (this.dependentdata.has(id))
            return;
        this.dependentdata.set(id, []);
        let myitem = undefined;
        for (const ii of sh.items) {
            if (ii.id === cid) {
                myitem = ii;
                break;
            }
            else if (ii.type === SchemaItemType.List && ii.items.length > 0) {
                for (const si of ii.items) {
                    if (ii.id + "----" + si.item.id === cid) {
                        myitem = ii;
                        break;
                    }
                }
                if (myitem)
                    break;
            }
        }
        if (!myitem)
            return;
        if (myitem.type === SchemaItemType.Choice) {
            myitem.items.forEach((it) => {
                var _a;
                (_a = this.dependentdata.get(id)) === null || _a === void 0 ? void 0 : _a.push({
                    id: it.id,
                    value: it.name,
                    ischoice: true
                });
            });
            return;
        }
        for (const row of rows) {
            for (const en of row.entry) {
                if (en.cellid !== cid)
                    continue;
                if (en.cellid === cid) {
                    if (!en.decrypted) {
                        this.decryptEntry(en, sid);
                    }
                }
                if (en.rowbarcode && en.rowbarcode.startsWith("crypt-")) {
                    en.rowbarcode = (_a = this.decryptBC(en.rowbarcode, sid)) !== null && _a !== void 0 ? _a : '';
                }
                if (myitem.type === SchemaItemType.Text) {
                    (_b = this.dependentdata.get(id)) === null || _b === void 0 ? void 0 : _b.push({
                        id: en.id,
                        rowid: en.rowid,
                        rowbarcode: en.rowbarcode,
                        value: (_c = LWStripHTML(en.celldata)) !== null && _c !== void 0 ? _c : '',
                    });
                }
                else if (myitem.type === SchemaItemType.Date) {
                    (_d = this.dependentdata.get(id)) === null || _d === void 0 ? void 0 : _d.push({
                        id: en.id,
                        rowid: en.rowid,
                        rowbarcode: en.rowbarcode,
                        value: DateLib.displayDateWIthFormat(en.celldata, myitem.inlcudetime, (_e = myitem.excludedate) !== null && _e !== void 0 ? _e : false),
                    });
                }
                else {
                    (_f = this.dependentdata.get(id)) === null || _f === void 0 ? void 0 : _f.push({
                        id: en.id,
                        rowid: en.rowid,
                        rowbarcode: en.rowbarcode,
                        value: en.celldata,
                    });
                }
            }
        }
    }
    decryptAndSetupDepRemoteItems(dep, darr) {
        var _a, _b;
        const sh = this.schemas.get(this.activeschema);
        if (!sh)
            return;
        let setupviewde = new Set();
        const mapofdpsh = new Map();
        dep.data.forEach((dt) => {
            mapofdpsh.set(dt.schema.id, dt);
            this.mapofdep.set(dt.schema.id, dt);
            if (dt.schema.viewdepentschemas) {
                for (const vs of dt.schema.viewdepentschemas) {
                    setupviewde.add(vs);
                }
            }
        });
        const mapofdata = new Map();
        const mapofschema = new Map();
        let doneenid = new Set();
        dep.data.forEach((dt) => {
            var _a;
            if (dt.schemaopen) {
                mapofschema.set(dt.schema.id, dt.schemaopen);
            }
            for (const en of dt.entries) {
                if (!doneenid.has(en.id)) {
                    if (!mapofdata.has(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) {
                        mapofdata.set(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid, []);
                    }
                    (_a = mapofdata.get(dt.schema.datasheetid + "~~~" + dt.schema.id + "~~~" + en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
                    doneenid.add(en.id);
                }
                else {
                }
            }
        });
        for (const en of darr) {
            if (!mapofdata.has(en.id)) {
                mapofdata.set(en.id, []);
            }
            for (const e of en.entries) {
                if (!doneenid.has(e.id)) {
                    (_a = mapofdata.get(en.id)) === null || _a === void 0 ? void 0 : _a.push(e);
                    doneenid.add(e.id);
                }
            }
        }
        // we should create some missing columns that we might need!!
        // there might be rule 
        console.log(mapofdata);
        const depschemarows = convertDepToRows(mapofdata);
        console.log(depschemarows.size);
        for (const s of depschemarows.keys()) {
            //if (setupviewde.has(s)) {
            console.log("doing " + s);
            this.depschemarows.set(s, (_b = depschemarows.get(s)) !== null && _b !== void 0 ? _b : []);
            //}
        }
        console.log(this.depschemarows);
        let ritems = [];
        for (const it of sh.items) {
            if (it.type === SchemaItemType.Remote) {
                ritems.push(it);
            }
            else if (it.type === SchemaItemType.List) {
                const lit = it;
                if (lit.items) {
                    for (const li of lit.items) {
                        if (li.item.type === SchemaItemType.Remote) {
                            ritems.push(li.item);
                        }
                    }
                }
            }
        }
        ritems.forEach((it) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            if (it.type === SchemaItemType.Remote) {
                const srit = it;
                if (srit.did && srit.sid && srit.cid) {
                    const dp = mapofdpsh.get(srit.sid);
                    if (dp !== undefined && dp.schemaopen !== undefined) {
                        const items = (_a = dp.schemaopen.items) !== null && _a !== void 0 ? _a : [];
                        let ischoice = false;
                        for (const item of items) {
                            if (item.id === srit.cid) {
                                // found it 
                                const enmap = new Map();
                                for (const en of dp.entries) {
                                    if (!enmap.has(en.cellid)) {
                                        enmap.set(en.cellid, []);
                                    }
                                    (_b = enmap.get(en.cellid)) === null || _b === void 0 ? void 0 : _b.push(en);
                                }
                                if (item.type === SchemaItemType.Choice) {
                                    // ohh all we need here is choice
                                    ischoice = true;
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    // this.rtdependentdata.set(id, []);
                                    const centries = enmap.get(item.id);
                                    let chmap = new Map();
                                    if (centries !== undefined) {
                                        centries.forEach((en) => {
                                            var _a;
                                            if (dp.schemaopen !== undefined) {
                                                if (!en.decrypted) {
                                                    GDecryptcell(en, dp.schemaopen);
                                                }
                                                if (chmap.has(en.celldata)) {
                                                    (_a = chmap.get(en.celldata)) === null || _a === void 0 ? void 0 : _a.push(en);
                                                }
                                                else {
                                                    chmap.set(en.celldata, [en]);
                                                }
                                            }
                                        });
                                    }
                                    item.items.forEach((it) => {
                                        const ens = chmap.get(it.id);
                                        if (ens !== undefined) {
                                            let rowids = [];
                                            ens.map((en) => {
                                                rowids.push(en.rowid);
                                            });
                                            // this.rtdependentdata.get(id)?.push({
                                            //     id: it.id,
                                            //     rowid: rowids,
                                            //     ischoice: true,
                                            //     value: it.name
                                            // })
                                        }
                                    });
                                    item.items.forEach((it) => {
                                        var _a;
                                        (_a = this.dependentdata.get(id)) === null || _a === void 0 ? void 0 : _a.push({
                                            id: it.id,
                                            value: it.name,
                                            ischoice: true
                                        });
                                    });
                                }
                                else {
                                    // not an choice 
                                    // we need to check conditions and parse the rules here!
                                    if (srit.conds && srit.conds.length > 0) {
                                        // lets chekc if any rules apply to my entries we can open them up!
                                        for (const con of srit.conds) {
                                            for (const cp of con.params) {
                                                // now we have this 
                                                if (cp.leftcond) {
                                                    const ens = enmap.get(cp.leftcond);
                                                    if (ens) {
                                                        for (const e of ens) {
                                                            if (e.ruleopen) {
                                                                parser([e], dp.schemaopen, depschemarows, mapofschema);
                                                            }
                                                            else if (!e.decrypted) {
                                                                GDecryptcell(e, dp.schemaopen);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    const id = srit.id + "---" + srit.sid + "---" + srit.cid;
                                    this.dependentdata.set(id, []);
                                    // this.rtdependentdata.set(id, []);
                                    const entries = dp.entries;
                                    for (const en of entries) {
                                        if (!en.decrypted) {
                                            GDecryptcell(en, dp.schemaopen);
                                        }
                                        if (en.cellid !== item.id)
                                            continue;
                                        // now we can do some clever filtering and we done!!
                                        let cons = srit.conds;
                                        if (cons && cons.length > 0) {
                                            // cons = filterInvalidConsitions(cons);
                                        }
                                        if (cons && cons.length > 0) {
                                            const rows = depschemarows.get(srit.sid);
                                            if (!rows)
                                                continue;
                                            const myens = [];
                                            const rind = en.rowid;
                                            for (const r of rows) {
                                                if (r.rowid === rind) {
                                                    for (const e1 of r.entry) {
                                                        myens.push(e1);
                                                    }
                                                }
                                            }
                                            if (!canShowRemoteEntry(en, cons, myens)) {
                                                continue;
                                            }
                                        }
                                        if (en.rowbarcode && en.rowbarcode.startsWith("crypt-")) {
                                            en.rowbarcode = (_c = this.decryptBCWithKeyNonde(en.rowbarcode, dp.schemaopen.accesskey, dp.schemaopen.nonce)) !== null && _c !== void 0 ? _c : '';
                                        }
                                        if (item.type === SchemaItemType.Text) {
                                            (_d = this.dependentdata.get(id)) === null || _d === void 0 ? void 0 : _d.push({
                                                id: en.id,
                                                rowid: en.rowid,
                                                rowbarcode: en.rowbarcode,
                                                value: (_e = LWStripHTML(en.celldata)) !== null && _e !== void 0 ? _e : '',
                                            });
                                            // this.rtdependentdata.get(id)?.push({
                                            //     id: en.id,
                                            //     rowid: [en.rowid],
                                            //     value: stripHTML(en.celldata) ?? '',
                                            //     rowbarcode: en.rowbarcode,
                                            // });
                                        }
                                        else if (item.type === SchemaItemType.Date) {
                                            (_f = this.dependentdata.get(id)) === null || _f === void 0 ? void 0 : _f.push({
                                                id: en.id,
                                                rowid: en.rowid,
                                                rowbarcode: en.rowbarcode,
                                                value: DateLib.displayDateWIthFormat(en.celldata, item.inlcudetime, (_g = item.excludedate) !== null && _g !== void 0 ? _g : false),
                                            });
                                            // this.rtdependentdata.get(id)?.push({
                                            //     id: en.id,
                                            //     rowid: [en.rowid],
                                            //     rowbarcode: en.rowbarcode,
                                            //     value: DateLib.displayDateWIthFormat(en.celldata,
                                            //         (item as DateItem).inlcudetime, (item as DateItem).excludedate ?? false)
                                            // });
                                        }
                                        else {
                                            (_h = this.dependentdata.get(id)) === null || _h === void 0 ? void 0 : _h.push({
                                                id: en.id,
                                                rowid: en.rowid,
                                                rowbarcode: en.rowbarcode,
                                                value: en.celldata,
                                            });
                                            // this.rtdependentdata.get(id)?.push({
                                            //     id: en.id,
                                            //     rowid: [en.rowid],
                                            //     rowbarcode: en.rowbarcode,
                                            //     value: en.celldata
                                            // });
                                        }
                                    }
                                }
                                break;
                            }
                        }
                        const rtextra = srit.rtextra;
                        if (rtextra !== undefined && rtextra.length > 0) {
                            for (const ext of rtextra) {
                                const extid = ext.cid;
                                if (ext.cid) {
                                    for (const item of items) {
                                        if (item.id === ext.cid) {
                                            // found it 
                                            const enmap = new Map();
                                            for (const en of dp.entries) {
                                                if (!enmap.has(en.cellid)) {
                                                    enmap.set(en.cellid, []);
                                                }
                                                (_j = enmap.get(en.cellid)) === null || _j === void 0 ? void 0 : _j.push(en);
                                            }
                                            if (item.type === SchemaItemType.Choice) {
                                            }
                                            else {
                                                // not an choice 
                                                // we need to check conditions and parse the rules here!
                                                if (srit.conds && srit.conds.length > 0) {
                                                    // lets chekc if any rules apply to my entries we can open them up!
                                                    for (const con of srit.conds) {
                                                        for (const cp of con.params) {
                                                            // now we have this 
                                                            if (cp.leftcond) {
                                                                const ens = enmap.get(cp.leftcond);
                                                                if (ens) {
                                                                    for (const e of ens) {
                                                                        if (e.ruleopen) {
                                                                            parser([e], dp.schemaopen, depschemarows, mapofschema);
                                                                        }
                                                                        else if (!e.decrypted) {
                                                                            GDecryptcell(e, dp.schemaopen);
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                const id = srit.id + "---" + srit.sid + "---" + ext.cid;
                                                this.dependentdata.set(id, []);
                                                // this.rtdependentdata.set(id, []);
                                                const entries = dp.entries;
                                                for (const en of entries) {
                                                    if (en.rowbarcode && en.rowbarcode.startsWith("crypt-")) {
                                                        en.rowbarcode = (_k = this.decryptBCWithKeyNonde(en.rowbarcode, dp.schemaopen.accesskey, dp.schemaopen.nonce)) !== null && _k !== void 0 ? _k : '';
                                                    }
                                                    if (!en.decrypted) {
                                                        GDecryptcell(en, dp.schemaopen);
                                                    }
                                                    if (en.cellid !== item.id)
                                                        continue;
                                                    // now we can do some clever filtering and we done!!
                                                    let cons = srit.conds;
                                                    if (cons && cons.length > 0) {
                                                        // cons = filterInvalidConsitions(cons);
                                                    }
                                                    if (cons && cons.length > 0) {
                                                        const rows = depschemarows.get(srit.sid);
                                                        if (!rows)
                                                            continue;
                                                        const myens = [];
                                                        const rind = en.rowid;
                                                        for (const r of rows) {
                                                            if (r.rowid === rind) {
                                                                for (const e1 of r.entry) {
                                                                    myens.push(e1);
                                                                }
                                                            }
                                                        }
                                                        if (!canShowRemoteEntry(en, cons, myens)) {
                                                            continue;
                                                        }
                                                    }
                                                    if (item.type === SchemaItemType.Text) {
                                                        (_l = this.dependentdata.get(id)) === null || _l === void 0 ? void 0 : _l.push({
                                                            id: en.id,
                                                            rowid: en.rowid,
                                                            rowbarcode: en.rowbarcode,
                                                            value: (_m = LWStripHTML(en.celldata)) !== null && _m !== void 0 ? _m : '',
                                                        });
                                                        // this.rtdependentdata.get(id)?.push({
                                                        //     id: en.id,
                                                        //     rowid: [en.rowid],
                                                        //     rowbarcode: en.rowbarcode,
                                                        //     value: stripHTML(en.celldata) ?? '',
                                                        // });
                                                    }
                                                    else if (item.type === SchemaItemType.Date) {
                                                        (_o = this.dependentdata.get(id)) === null || _o === void 0 ? void 0 : _o.push({
                                                            id: en.id,
                                                            rowid: en.rowid,
                                                            rowbarcode: en.rowbarcode,
                                                            value: DateLib.displayDateWIthFormat(en.celldata, item.inlcudetime, (_p = item.excludedate) !== null && _p !== void 0 ? _p : false),
                                                        });
                                                        // this.rtdependentdata.get(id)?.push({
                                                        //     id: en.id,
                                                        //     rowid: [en.rowid],
                                                        //     rowbarcode: en.rowbarcode,
                                                        //     value: DateLib.displayDateWIthFormat(en.celldata,
                                                        //         (item as DateItem).inlcudetime, (item as DateItem).excludedate ?? false)
                                                        // });
                                                    }
                                                    else if (item.type === SchemaItemType.Objects) {
                                                        if (en.linkedids && en.linkedids.length > 0) {
                                                            let obids = [];
                                                            const pmap = new Map();
                                                            (_q = en.objsdec) === null || _q === void 0 ? void 0 : _q.forEach((ob) => pmap.set("objs-" + ob.id, ob));
                                                            const smap = new Map();
                                                            (_r = en.schsdec) === null || _r === void 0 ? void 0 : _r.forEach((sj) => smap.set(sj.id, sj));
                                                            for (const l of en.linkedids) {
                                                                if (l.startsWith("objs-")) {
                                                                    const obj = pmap.get(l);
                                                                    if (obj) {
                                                                        const tds = obj.type === ProjectObjectType.Document ? obj.thumbdetail : undefined;
                                                                        obids.push({
                                                                            id: l,
                                                                            type: 'document',
                                                                            obj: obj,
                                                                            name: obj.name,
                                                                            thumdet: tds
                                                                        });
                                                                    }
                                                                }
                                                                else if (l.startsWith("dch-")) {
                                                                    const parts = l.split("-");
                                                                    if (parts.length > 2) {
                                                                        const did = parts[1];
                                                                        const sid = parts[2];
                                                                        const dh = this.datasheets.get(did);
                                                                        const sh = smap.get(sid);
                                                                        if (dh && sh) {
                                                                            obids.push({
                                                                                id: l,
                                                                                type: 'datasheet',
                                                                                obj: dh.name + " ! " + sh.name,
                                                                                name: dh.name + " ! " + sh.name
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            if (obids.length > 0) {
                                                                (_s = this.dependentdata.get(id)) === null || _s === void 0 ? void 0 : _s.push({
                                                                    id: en.id,
                                                                    rowid: en.rowid,
                                                                    rowbarcode: en.rowbarcode,
                                                                    value: '',
                                                                    objects: obids
                                                                });
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        (_t = this.dependentdata.get(id)) === null || _t === void 0 ? void 0 : _t.push({
                                                            id: en.id,
                                                            rowid: en.rowid,
                                                            rowbarcode: en.rowbarcode,
                                                            value: en.celldata,
                                                        });
                                                        // this.rtdependentdata.get(id)?.push({
                                                        //     id: en.id,
                                                        //     rowid: [en.rowid],
                                                        //     rowbarcode: en.rowbarcode,
                                                        //     value: en.celldata
                                                        // });
                                                    }
                                                }
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }
    setFeatchingDepende(fetch) {
        this.fetchingdepend = fetch;
    }
    setRebuildingCustom(fetch) {
        this.rebuildingcustom = fetch;
    }
    setIgnoreCustomComponentId(re) {
        this.ignorerebuildcustomcomponent.add(re);
    }
    removeIgnoreCustomComponentId(re) {
        this.ignorerebuildcustomcomponent.delete(re);
    }
    setShowRowFilter(show) {
        this.showrowsilter = show;
    }
    setShowChatBot(show) {
        this.showchatbot = show;
    }
    removeSchemaFromRowChList(id, sid) {
        var _a, _b, _c;
        const row = this.rowsMap.get(id);
        if (row) {
            const index = (_a = row.childrenschemalist) === null || _a === void 0 ? void 0 : _a.indexOf(sid);
            if (index !== undefined && index > -1) {
                (_b = row.childrenschemalist) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
                this.updateRow(row.rowid, []);
                if (this.activerowid === row.rowid &&
                    ((_c = row.childrenschemalist) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                    this.setActiveTab("detail");
                }
            }
        }
    }
    setShowPasswordFor(pwd) {
        this.showpasswordfor.add(pwd);
    }
    setBarcodeInput(id, input) {
        this.barcodeinput.set(id, input);
    }
    setCopySchema(sh) {
        this.copyschema = sh;
        this.copyactive = true;
    }
    decryptBC(bc, sid) {
        var _a, _b, _c, _d;
        let key = "";
        let nonce = "";
        if (this.activeschema === sid) {
            const req = this.schemas.get(this.activeschema);
            key = (_a = req === null || req === void 0 ? void 0 : req.accesskey) !== null && _a !== void 0 ? _a : '';
            nonce: (_b = req === null || req === void 0 ? void 0 : req.nonce) !== null && _b !== void 0 ? _b : '';
        }
        else {
            const sh = this.schemasmap.get(sid);
            key = (_c = sh === null || sh === void 0 ? void 0 : sh.accesskey) !== null && _c !== void 0 ? _c : '';
            nonce: (_d = sh === null || sh === void 0 ? void 0 : sh.nonce) !== null && _d !== void 0 ? _d : '';
        }
        if (bc && bc.startsWith("crypt-") && key && nonce) {
            return this.decryptBCWithKeyNonde(bc, key, nonce);
        }
        return undefined;
    }
    decryptBCWithKeyNonde(bc, key, nonce) {
        if (bc && bc.startsWith("crypt-") && key && nonce) {
            bc = bc.substring("crypt-".length);
            const val = LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: bc, nonce: '', publickey: '' }, key, nonce);
            bc = val !== null && val !== void 0 ? val : '';
            return bc;
        }
        return undefined;
    }
    decryptEntry(e, sid, parserule = true) {
        if (e.decrypted)
            return e;
        if (this.activeschema === sid) {
            const req = this.schemas.get(this.activeschema);
            if (req) {
                if (e.ruleopen) {
                    if (parserule) {
                        parser([e], req, this.depschemarows, this.schemasmap);
                    }
                }
                else if (!e.decrypted) {
                    GDecryptcell(e, req);
                }
                e.decrypted = true;
            }
        }
        else {
            const sh = this.schemasmap.get(sid);
            if (sh) {
                if (e.ruleopen) {
                    if (parserule) {
                        parser([e], sh, this.depschemarows, this.schemasmap);
                    }
                }
                else if (!e.decrypted) {
                    GDecryptcell(e, sh);
                }
                e.decrypted = true;
            }
        }
        return e;
    }
    cancelCopySchema() {
        this.copyactive = false;
        this.copyschema = undefined;
    }
    setHidePasswordFor(pwd) {
        this.showpasswordfor.delete(pwd);
    }
    setGanttTaskFieldName(name) {
        this.ganttasknamefieldname = name;
    }
    deleteDatasheet() {
        const req = {
            id: this.activedatasheet,
            letrid: this.activelterid
        };
        this.setDeleting(true);
        Apphandler.sendMessage("deletedatasheet", req);
    }
    setSavingRow(saving) {
        this.savingrow = saving;
    }
    setReadonlyRows(readonly) {
        this.readonlyrows = readonly;
    }
    setDatasheetMenu(show) {
        this.showdtmennu = show;
    }
    setActiveChildSchema(id) {
        this.activechildschema = id;
    }
    saveMetaSchema() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        req.metaschemaids = Array.from(this.activeschemametaids);
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        Apphandler.sendMessage('updateschema', areq);
    }
    execFooterRule(colid, rule) {
        var _a;
        const rows = Array.from(this.rowsMap.values());
        let prevstageres = "";
        let index = -1;
        for (const cr of rule.rule) {
            index++;
            let rowresult = cr.type === RuleType.Multiply
                || cr.type === RuleType.Divide || cr.type === RuleType.Power ? 1 : 0;
            if (cr.type !== RuleType.Number) {
                let validentries = [];
                let conds = undefined;
                if (cr.conds && cr.conds.length > 0) {
                    conds = filterInvalidConsitions(cr.conds);
                }
                if (conds) {
                    const cons = conds;
                    let allentriesid = new Set();
                    if (cons.length > 0) {
                        for (const cn of cons) {
                            for (const cp of cn.params) {
                                allentriesid.add(cp.leftcond);
                                if (cp.rightschemacon) {
                                    allentriesid.add(cp.rightschemacon);
                                }
                            }
                        }
                        for (const r of rows) {
                            if (this.hiddenrows.has(r.rowid))
                                continue;
                            // lets first check if row is valid or now!
                            let cen = undefined;
                            let ruen = [];
                            for (const en of r.entry) {
                                if (allentriesid.has(en.cellid)) {
                                    if (!en.decrypted) {
                                        if (this.checkCellHasRule(en)) {
                                            this.parseCellRule(en);
                                        }
                                        else {
                                            this.decryptCell(en);
                                        }
                                    }
                                    ruen.push(en);
                                }
                                if (en.cellid === colid) {
                                    if (!en.decrypted) {
                                        if (this.checkCellHasRule(en)) {
                                            this.parseCellRule(en);
                                        }
                                        else {
                                            this.decryptCell(en);
                                        }
                                    }
                                    cen = en;
                                }
                            }
                            if (cen) {
                                if (canShowRemoteEntry(cen, conds, ruen)) {
                                    validentries.push(cen);
                                }
                            }
                        }
                    }
                }
                else {
                    // lets just do the arthemic that's all
                    for (const r of rows) {
                        if (this.hiddenrows.has(r.rowid))
                            continue;
                        for (const en of r.entry) {
                            if (en.cellid === colid) {
                                if (!en.decrypted) {
                                    if (this.checkCellHasRule(en)) {
                                        this.parseCellRule(en);
                                    }
                                    else {
                                        this.decryptCell(en);
                                    }
                                }
                                validentries.push(en);
                            }
                        }
                    }
                }
                if (validentries.length === 0)
                    continue;
                let myindex = 0;
                for (const en of validentries) {
                    const num = parseFloat(en.celldata);
                    if (isNaN(num))
                        continue;
                    if (cr.type === RuleType.Add) {
                        rowresult += num;
                    }
                    else if (cr.type === RuleType.Subtract) {
                        if (myindex === 0)
                            rowresult = num;
                        else
                            rowresult -= num;
                    }
                    else if (cr.type === RuleType.Multiply) {
                        if (myindex === 0)
                            rowresult = num;
                        else
                            rowresult *= num;
                    }
                    else if (cr.type === RuleType.Divide && num !== 0) {
                        if (myindex === 0)
                            rowresult = num;
                        else
                            rowresult /= num;
                    }
                    else if (cr.type === RuleType.Power) {
                        if (myindex === 0)
                            rowresult = num;
                        else
                            rowresult ^= num;
                    }
                    myindex++;
                }
            }
            else {
                if (!cr.params || cr.params.length === 0)
                    continue;
                const pp = parseFloat(cr.params[0].value);
                if (isNaN(pp))
                    continue;
                rowresult = pp;
            }
            if (index > 0) {
                const pnum = parseFloat(prevstageres);
                if (!isNaN(pnum)) {
                    const ptype = (_a = cr.prevstageresult) !== null && _a !== void 0 ? _a : cr.type;
                    if (ptype === RuleType.Add)
                        rowresult = pnum + rowresult;
                    else if (ptype === RuleType.Subtract)
                        rowresult = pnum - rowresult;
                    else if (ptype === RuleType.Multiply)
                        rowresult = pnum * rowresult;
                    else if (ptype === RuleType.Divide) {
                        if (rowresult === 0)
                            rowresult = 0;
                        else
                            rowresult = pnum / rowresult;
                    }
                    else if (ptype === RuleType.Power)
                        rowresult = pnum ^ rowresult;
                }
            }
            prevstageres = rowresult + "";
        }
        return prevstageres;
    }
    buildNewRowFromDataRules(ens) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const req = this.schemas.get(this.activeschema);
        if (!req || !req.datarules)
            return ens;
        this.schemasmap.set(this.activeschema, req);
        if (req.apicode) {
            this.schemaapimap.set(req.apicode, req);
        }
        if (req.templateid) {
            this.schematemplatemap.set(req.templateid, req);
        }
        const delentry = [];
        const ret = [];
        let workrules = new Map();
        let pendingrules = new Set();
        let donerules = [];
        const enmap = new Map();
        for (const en of ens) {
            if (!enmap.has(en.cellid)) {
                enmap.set(en.cellid, []);
            }
            (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        req.datarules.forEach((dr) => {
            if (!enmap.has(dr.colid)) {
                workrules.set(dr.colid, dr);
                pendingrules.add(dr.colid);
            }
        });
        const kens = ens.map((en) => (Object.assign({}, toJS(en))));
        const fakerow = {
            rowid: '',
            rowindex: -1,
            entry: kens,
        };
        this.addRuleEntryToRow(fakerow);
        if (!this.depschemarows.has(this.activeschema) ||
            ((_b = this.depschemarows.get(this.activeschema)) === null || _b === void 0 ? void 0 : _b.length) !== this.rowsMap.size) {
            this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex));
        }
        const achema = this.schemas.get(this.activeschema);
        const myindex = (_d = (_c = this.depschemarows.get(this.activeschema)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
        if (achema) {
            (_e = this.depschemarows.get(this.activeschema)) === null || _e === void 0 ? void 0 : _e.push(fakerow);
            if (!this.schemasmap.has(this.activeschema)) {
                this.schemasmap.set(this.activeschema, achema);
                if (achema.apicode) {
                    this.schemaapimap.set(achema.apicode, achema);
                }
                if (achema.templateid) {
                    this.schematemplatemap.set(achema.templateid, achema);
                }
            }
            for (const kn of fakerow.entry) {
                if (!kn.ruleopen) {
                    kn.decrypted = true;
                }
                else {
                    parser([kn], achema, this.depschemarows, this.schemasmap, this.dependentdata);
                    kn.decrypted = true;
                }
            }
            if (myindex > -1) {
                (_f = this.depschemarows.get(this.activeschema)) === null || _f === void 0 ? void 0 : _f.splice(myindex, 1);
            }
        }
        while (pendingrules.size > 0) {
            let startsize = pendingrules.size;
            nextworkruke: for (const rule of workrules.values()) {
                // lets check if this rule can run or no!!
                let canrun = true;
                nextrule: for (const r of rule.rule) {
                    if (r.conds) {
                        for (const con of r.conds) {
                            for (const cp of con.params) {
                                if (pendingrules.has(cp.leftcond)) {
                                    continue nextworkruke; // we cant run this!!
                                }
                            }
                        }
                    }
                    for (const cp of r.params) {
                        const values = cp.value.split("~~~");
                        if (values.length > 2) {
                            const sid = values[1];
                            const cid = values[2];
                            if (this.activeschema === sid) {
                                if (pendingrules.has(cid)) {
                                    continue nextworkruke;
                                }
                            }
                            if (cp.conds) {
                                for (const con of cp.conds) {
                                    for (const cp of con.params) {
                                        if (pendingrules.has(cp.rightcond)) {
                                            continue nextworkruke; // we cant run this!!
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (canrun) {
                    pendingrules.delete(rule.colid);
                    const myrows = this.depschemarows.get(this.activeschema);
                    if (!myrows) {
                        this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex));
                    }
                    // lets add new row
                    const index = this.rowsMap.size;
                    // now lets run this and get the value for this!!
                    const val = textRuleParser(fakerow, rule, this.depschemarows, this.schemasmap, this.activeschema, this.dependentdata, false);
                    if (!val || val.length === 0) {
                        continue;
                    }
                    const entryies = (_g = enmap.get(rule.colid)) !== null && _g !== void 0 ? _g : [];
                    // we need to also get other ones as well
                    // maybe what we need is 
                    const donevals = new Map();
                    const delvals = new Map();
                    const allsubrowindex = [];
                    // we should overrite the existing values too!!
                    if (entryies) {
                        for (const et of entryies) {
                            if (et.ruleopen) {
                                this.parseCellRule(et);
                            }
                            else {
                                this.decryptCell(et);
                            }
                            if (et.celldata) {
                                if (!donevals.has(et.celldata)) {
                                    donevals.set(et.celldata, []);
                                }
                                if (!delvals.has(et.celldata)) {
                                    delvals.set(et.celldata, []);
                                }
                                (_h = donevals.get(et.celldata)) === null || _h === void 0 ? void 0 : _h.push(et);
                                (_j = delvals.get(et.celldata)) === null || _j === void 0 ? void 0 : _j.push(et);
                            }
                            allsubrowindex.push((_k = et.subrowindex) !== null && _k !== void 0 ? _k : '');
                        }
                    }
                    if (rule.colid.indexOf("----") !== -1) {
                        const mapbysubrowindex = new Map();
                        if (entryies) {
                            for (const en of entryies) {
                                mapbysubrowindex.set((_l = en.subrowindex) !== null && _l !== void 0 ? _l : '', en);
                            }
                        }
                        const parentid = rule.colid.split("----")[0];
                        // just make sure all subrowindex are there too!!
                        const listitem = req.items.filter(it => it.id === parentid);
                        if (listitem && listitem.length > 0) {
                            const lit = listitem[0];
                            if (lit.items && lit.items.length > 0) {
                                for (const litem of lit.items) {
                                    if (lit.id + "----" + litem.item.id === rule.colid)
                                        continue; // we already done this!
                                    const lens = enmap.get(lit.id + "----" + litem.item.id);
                                    if (lens && lens.length > 0) {
                                        for (const en of lens) {
                                            const sr = en.subrowindex;
                                            if (sr && allsubrowindex.indexOf(sr) === -1) {
                                                // wee have missing column 
                                                entryies === null || entryies === void 0 ? void 0 : entryies.push({
                                                    celldata: "",
                                                    cellfindstr: '',
                                                    cellid: rule.colid,
                                                    schemaid: this.activeschema,
                                                    rowindex: en.rowindex,
                                                    subrowindex: sr,
                                                    rowid: en.rowid,
                                                    id: "",
                                                    sortstring: Math.random()
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (entryies) {
                        entryies.sort(sortEntriesByRow);
                    }
                    const mycellen = [];
                    for (let i = 0; i < val.length; i++) {
                        const tr = val[i];
                        if (entryies && entryies.length > i) {
                            const en = entryies[i];
                            en.celldata = tr.celldata;
                            fakerow.entry.push(en);
                            mycellen.push(en);
                        }
                        else {
                            const entry = {
                                celldata: tr.celldata,
                                cellfindstr: '',
                                cellid: tr.cellid,
                                schemaid: this.activeschema,
                                rowindex: -1,
                                subrowindex: tr.subrowindex,
                                rowid: '',
                                id: "",
                                sortstring: Math.random()
                            };
                            fakerow.entry.push(entry);
                            mycellen.push(entry);
                        }
                    }
                    enmap.set(rule.colid, mycellen);
                }
            }
            let endsize = pendingrules.size;
            if (startsize === endsize) {
                // we cant run anything break this
                break;
            }
        }
        const res = [];
        for (const en of fakerow.entry) {
            res.push(Object.assign(Object.assign({}, en), { ruleopen: undefined, rule: undefined }));
        }
        return res;
    }
    async buildRowsFromDataRules(colid, activerowid, exop = "append") {
        var _a, _b, _c, _d, _e, _f;
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        this.schemasmap.set(this.activeschema, req);
        if (req.apicode) {
            this.schemaapimap.set(req.apicode, req);
        }
        if (req.templateid) {
            this.schematemplatemap.set(req.templateid, req);
        }
        const delentry = [];
        const ret = [];
        let workrules = new Map();
        if (req.datarules) {
            if (colid === "all") {
                req.datarules.forEach((dr) => workrules.set(dr.colid, dr));
            }
            else {
                req.datarules.filter((r) => r.colid === colid).forEach((dr) => workrules.set(dr.colid, dr));
            }
        }
        if (this.rowsarrids.length > 0 && req.datarules && req.datarules.length > 0) {
            let index = 0;
            let rowids = this.rowsarrids;
            if (activerowid && activerowid.length > 0) {
                rowids = rowids.filter((r) => activerowid.indexOf(r.rowid) !== -1);
            }
            for (const rr of rowids) {
                index++;
                let rowworkrules = new Map(workrules);
                if (index > 1000) {
                    index = 0;
                    await timeout(50);
                }
                const rentry = [];
                const rdelentry = [];
                const emap = new Map();
                for (const en of rr.entry) {
                    if (!emap.has(en.cellid)) {
                        emap.set(en.cellid, []);
                    }
                    (_a = emap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
                }
                const rrules = this.rowDataRules.get(rr.rowid);
                if (rrules && rrules.datarules && rrules.datarules.length > 0) {
                    if (colid === "all") {
                        rrules.datarules.forEach((dr) => rowworkrules.set(dr.colid, dr));
                    }
                    else {
                        rrules.datarules.filter((r) => r.colid === colid).forEach((dr) => rowworkrules.set(dr.colid, dr));
                    }
                }
                for (const rule of rowworkrules.values()) {
                    const val = textRuleParser(rr, rule, this.depschemarows, this.schemasmap, this.activeschema, this.dependentdata, false);
                    if (!val || val.length === 0) {
                        continue;
                    }
                    const entryies = (_b = emap.get(rule.colid)) !== null && _b !== void 0 ? _b : [];
                    // we need to also get other ones as well
                    // maybe what we need is 
                    const donevals = new Map();
                    const delvals = new Map();
                    const allsubrowindex = [];
                    // we should overrite the existing values too!!
                    if (entryies) {
                        for (const et of entryies) {
                            if (et.ruleopen) {
                                this.parseCellRule(et);
                            }
                            else {
                                this.decryptCell(et);
                            }
                            if (et.celldata) {
                                if (!donevals.has(et.celldata)) {
                                    donevals.set(et.celldata, []);
                                }
                                if (!delvals.has(et.celldata)) {
                                    delvals.set(et.celldata, []);
                                }
                                (_c = donevals.get(et.celldata)) === null || _c === void 0 ? void 0 : _c.push(et);
                                (_d = delvals.get(et.celldata)) === null || _d === void 0 ? void 0 : _d.push(et);
                            }
                            allsubrowindex.push((_e = et.subrowindex) !== null && _e !== void 0 ? _e : '');
                        }
                    }
                    let index = 0;
                    if (exop === 'overwrite') {
                        if (rule.colid.indexOf("----") !== -1) {
                            const mapbysubrowindex = new Map();
                            if (entryies) {
                                for (const en of entryies) {
                                    mapbysubrowindex.set((_f = en.subrowindex) !== null && _f !== void 0 ? _f : '', en);
                                }
                            }
                            const parentid = rule.colid.split("----")[0];
                            // just make sure all subrowindex are there too!!
                            const listitem = req.items.filter(it => it.id === parentid);
                            if (listitem && listitem.length > 0) {
                                const lit = listitem[0];
                                if (lit.items && lit.items.length > 0) {
                                    for (const litem of lit.items) {
                                        if (lit.id + "----" + litem.item.id === rule.colid)
                                            continue; // we already done this!
                                        const lens = emap.get(lit.id + "----" + litem.item.id);
                                        if (lens && lens.length > 0) {
                                            for (const en of lens) {
                                                const sr = en.subrowindex;
                                                if (sr && allsubrowindex.indexOf(sr) === -1) {
                                                    // wee have missing column 
                                                    entryies === null || entryies === void 0 ? void 0 : entryies.push({
                                                        celldata: "",
                                                        cellfindstr: '',
                                                        cellid: rule.colid,
                                                        schemaid: this.activeschema,
                                                        rowindex: en.rowindex,
                                                        subrowindex: sr,
                                                        rowid: en.rowid,
                                                        id: "",
                                                        sortstring: Math.random()
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        if (entryies) {
                            entryies.sort(sortEntriesByRow);
                        }
                        for (let i = 0; i < val.length; i++) {
                            const tr = val[i];
                            if (entryies && entryies.length > i) {
                                const en = entryies[i];
                                en.celldata = tr.celldata;
                                rentry.push(toJS(en));
                            }
                            else {
                                const entry = {
                                    celldata: tr.celldata,
                                    cellfindstr: '',
                                    cellid: tr.cellid,
                                    schemaid: this.activeschema,
                                    rowindex: rr.rowindex,
                                    subrowindex: tr.subrowindex,
                                    rowid: rr.rowid,
                                    id: "",
                                    sortstring: Math.random()
                                };
                                rentry.push(entry);
                            }
                        }
                    }
                    else {
                        for (const tr of val) {
                            if (!tr.celldata) {
                                continue;
                            }
                            ;
                            // we need to keep this !!
                            if (donevals.has(tr.celldata)) {
                                delvals.delete(tr.celldata);
                                continue;
                            }
                            // if overwrite we need to use the existing column .. 
                            // we shouldnt do anything else!!
                            // or maybe overwrite we should just do it anyways!
                            const entry = {
                                celldata: tr.celldata,
                                cellfindstr: '',
                                cellid: tr.cellid,
                                schemaid: this.activeschema,
                                rowindex: rr.rowindex,
                                subrowindex: tr.subrowindex,
                                rowid: rr.rowid,
                                id: "",
                                sortstring: Math.random()
                            };
                            rentry.push(entry);
                        }
                    }
                }
                if (rentry.length > 0) {
                    ret.push(rentry);
                }
            }
        }
        if (ret.length > 0 || delentry.length > 0) {
            // now lets do this !!
            const ureq = {
                schema: req,
                letrid: this.activelterid,
                entries: ret,
                delentries: delentry
            };
            Apphandler.sendMessage("updaterows", ureq);
        }
        else {
            APPEvent.publishApperror("Found no changes.");
            this.dataruleexec.setExecuting(false);
        }
    }
    collectRowsAndBuildRulesResult() {
        var _a, _b;
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        // lets do this now
        let entries = [];
        // lets check the rules first 
        let solid = new Set();
        let haverules = false;
        if (req.viewdepentschemas) {
            haverules = true;
        }
        if (req.rules && !haverules) {
            for (const cr of req.rules) {
                for (const pr of cr.rule) {
                    let breakit = false;
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema')
                            continue;
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            const parts = rrv.value.split("~~~");
                            if ((parts[0] !== req.datasheetid || parts[1] !== req.id)) {
                                if (this.depschemarows.has(parts[1])) {
                                    // lets check if the row has the column
                                    const cid = parts[2];
                                    const sh = this.depschemarows.get(parts[1]);
                                    if (sh && sh.length > 0) {
                                        const r1 = sh[0];
                                        let had = false;
                                        for (const re of r1.entry) {
                                            if (re.cellid === cid) {
                                                had = true;
                                                break;
                                            }
                                        }
                                        if (had)
                                            continue;
                                    }
                                }
                                haverules = true;
                                breakit = true;
                                break;
                            }
                        }
                    }
                    if (breakit) {
                        break;
                    }
                }
            }
        }
        if (req.datarules) {
            for (const cr of req.datarules) {
                for (const pr of cr.rule) {
                    let breakit = false;
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema')
                            continue;
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            const parts = rrv.value.split("~~~");
                            if ((parts[0] !== req.datasheetid || parts[1] !== req.id)) {
                                if (this.depschemarows.has(parts[1])) {
                                    // lets check if the row has the column
                                    const cid = parts[2];
                                    const sh = this.depschemarows.get(parts[1]);
                                    if (sh && sh.length > 0) {
                                        const r1 = sh[0];
                                        let had = false;
                                        for (const re of r1.entry) {
                                            if (re.cellid === cid) {
                                                had = true;
                                                break;
                                            }
                                        }
                                        if (had)
                                            continue;
                                    }
                                }
                                haverules = true;
                                breakit = true;
                                break;
                            }
                        }
                    }
                    if (breakit) {
                        break;
                    }
                }
            }
        }
        if (this.rowRules.size > 0 && !haverules) {
            for (const r of this.rowRules.values()) {
                for (const cr of r.data) {
                    for (const pr of cr.rule) {
                        let breakit = false;
                        for (const rrv of pr.params) {
                            if (rrv.type !== 'schema')
                                continue;
                            if (rrv.value && rrv.value.split("~~~").length > 2) {
                                const parts = rrv.value.split("~~~");
                                if (parts[0] !== req.datasheetid || parts[1] !== req.id) {
                                    if (this.depschemarows.has(parts[1])) {
                                        // lets check if the row has the column
                                        const cid = parts[2];
                                        const sh = this.depschemarows.get(parts[1]);
                                        if (sh && sh.length > 0) {
                                            const r1 = sh[0];
                                            let had = false;
                                            for (const re of r1.entry) {
                                                if (re.cellid === cid) {
                                                    had = true;
                                                    break;
                                                }
                                            }
                                            if (had)
                                                continue;
                                        }
                                    }
                                    haverules = true;
                                    breakit = true;
                                    break;
                                }
                            }
                        }
                        if (breakit) {
                            break;
                        }
                    }
                }
            }
        }
        if (this.rowDataRules && !haverules) {
            for (const r of this.rowDataRules.values()) {
                for (const cr of r.data) {
                    for (const pr of cr.rule) {
                        let breakit = false;
                        for (const rrv of pr.params) {
                            if (rrv.type !== 'schema')
                                continue;
                            if (rrv.value && rrv.value.split("~~~").length > 2) {
                                const parts = rrv.value.split("~~~");
                                if (parts[0] !== req.datasheetid || parts[1] !== req.id) {
                                    if (this.depschemarows.has(parts[1])) {
                                        // lets check if the row has the column
                                        const cid = parts[2];
                                        const sh = this.depschemarows.get(parts[1]);
                                        if (sh && sh.length > 0) {
                                            const r1 = sh[0];
                                            let had = false;
                                            for (const re of r1.entry) {
                                                if (re.cellid === cid) {
                                                    had = true;
                                                    break;
                                                }
                                            }
                                            if (had)
                                                continue;
                                        }
                                    }
                                    haverules = true;
                                    breakit = true;
                                    break;
                                }
                            }
                        }
                        if (breakit) {
                            break;
                        }
                    }
                }
            }
        }
        for (const row of this.rowsMap.values()) {
            entries.push(...row.entry);
        }
        // now we have the all the entries that need something to be done!1
        if (haverules) {
            this.setFeatchingDepende(true);
            const donesh = new Set();
            for (const sh of this.mapofdep.keys()) {
                const dd = (_b = (_a = this.mapofdep.get(sh)) === null || _a === void 0 ? void 0 : _a.schemaopen) === null || _b === void 0 ? void 0 : _b.viewdepentschemas;
                if (dd && dd.length > 0) {
                    for (const ddv of dd) {
                        if (this.depschemarows.has(ddv)) {
                            donesh.add(ddv);
                        }
                    }
                }
            }
            // lets get dependnt and we done then 
            const req1 = {
                letrid: this.activelterid,
                schemaid: this.activeschema,
                sh: req,
                alreadydoneschema: Array.from(donesh),
                en: entries,
                rules: [...Array.from(this.rowRules.values()), ...Array.from(this.rowDataRules.values())]
            };
            // this is coole stuff now!!
            Apphandler.sendMessage("dependententries", req1);
        }
        else {
            this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex));
        }
        this.setCollectingData(false);
    }
    saveFooter() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        const rules = this.footerrulebilder.convertRuleUIsToRules();
        // this is rule for only 
        const activecolid = this.footerrulebilder.footercolid;
        const srules = [];
        srules.push(...rules);
        if (req.footers) {
            for (const rf of req.footers) {
                if (rf.colid !== activecolid) {
                    srules.push(rf);
                }
            }
        }
        req.footers = srules;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.footerrulebilder.setSaving(true);
        Apphandler.sendMessage('updateschema', areq);
    }
    saveDataRules() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        const rules = this.datarulebuilder.convertRuleUIsToRules();
        req.datarules = rules;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.datarulebuilder.setSaving(true);
        Apphandler.sendMessage('updateschema', areq);
    }
    saveRules() {
        const req = this.schemas.get(this.activeschema);
        if (!req)
            return;
        const rules = this.rulebuilderstate.convertRuleUIsToRules();
        req.rules = rules;
        const areq = {
            id: Math.random() + "",
            sh: req
        };
        this.rulebuilderstate.setSaving(true);
        Apphandler.sendMessage('updateschema', areq);
    }
    saveComment(com) {
        var _a;
        if (this.editmode && this.editnoteid) {
            const savereq = {
                letrid: this.activelterid,
                objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
                replaceid: com.id,
                text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
                noteid: this.editnoteid
            };
            Apphandler.sendMessage("addcomment", savereq);
        }
    }
    getAnalytics() {
        if (this.anas.size != 0)
            return; //we shou
        if (this.gettinganas)
            return;
        this.setGettingAns(true);
        const req = {
            letrid: this.activelterid,
            floating: false
        };
        Apphandler.sendMessage("schemaanalytics", req);
    }
    saveChat(com) {
        var _a;
        const savereq = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            replaceid: com.id,
            text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
            noteid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid
        };
        Apphandler.sendMessage("addcomment", savereq);
    }
    setShowDerviedSchemaFields(show) {
        this.showdervivedschemafields = show;
        // lets rebuild 
    }
    setAuthor(n) {
        this.authors.set(n.authorid, {
            authorid: n.authorid,
            authorname: n.authorname
        });
    }
    setShowActions(show) {
        this.showactions = show;
    }
    setShowbarcode(show) {
        this.showbacodes = show;
    }
    setDeleting(del) {
        this.deletingschema = del;
    }
    addListItem(id) {
        this.listitems.push(id);
    }
    removeListItem(id) {
        const index = this.listitems.indexOf(id);
        if (index > -1) {
            this.listitems.splice(index, 1);
        }
    }
    resetListItems() {
        this.listitems.splice(0, this.listitems.length);
    }
    removeDeletingNote(dn) {
        this.deletenoteids.delete(dn);
    }
    resetFilter() {
        this.notesbyid.forEach((n, k) => {
            if (n.note !== undefined) {
                n.setVisible(true);
            }
        });
    }
    setEnableAnnotation(enable) {
        this.enableannotation = enable;
    }
    setActiveAction(act) {
        this.activeaction = act;
        this.setShowActions(false);
    }
    deleteLink(link) {
        const id = this.links.indexOf(link);
        if (id !== undefined && id > -1) {
            this.links.splice(id, 1);
        }
    }
    addIdToRemovingCh(id) {
        this.removingrowsfromsh.add(id);
    }
    removeIdToRemovingCh(id) {
        this.removingrowsfromsh.delete(id);
    }
    checkAndAddSoftRowsForItem() {
        var _a;
        const achema = this.schemas.get(this.activeschema);
        if (!achema)
            return;
        const items = achema.items.filter((it) => it.type === SchemaItemType.Remote && it.autoadd);
        if (items.length !== 1 || items[0].type !== SchemaItemType.Remote)
            return;
        const item = items[0];
        const rschid = item.id;
        const remoteid = item.id + "---" + item.sid + "---" + item.cid;
        if (!this.dependentdata.has(remoteid)) {
            return;
        }
        let ent = [];
        // lets now do somethingclever 
        let doneent = new Set();
        for (const row of this.rowsMap.values()) {
            for (const en of row.entry) {
                if (en.cellid === rschid) {
                    if (!en.decrypted) {
                        this.decryptCell(en);
                    }
                    const parts = en.celldata.split(",");
                    for (const p of parts) {
                        doneent.add(p);
                    }
                }
            }
        }
        const vals = (_a = this.dependentdata.get(remoteid)) !== null && _a !== void 0 ? _a : [];
        for (const val of vals) {
            if (!doneent.has(val.id)) {
                let id = Math.random() + "";
                const entry = {
                    celldata: val.id,
                    cellfindstr: '',
                    cellid: rschid,
                    schemaid: this.activeschema,
                    rowindex: this.rowsMap.size,
                    subrowindex: "0",
                    rowid: id,
                    id: Math.random() + "",
                    sortstring: Math.random(),
                    decrypted: true,
                    updatetime: new Date().getTime(),
                    updatedby: ''
                };
                ent.push([entry]);
                const row = {
                    rowindex: this.rowsMap.size,
                    rowid: id,
                    id: id,
                    entry: [entry],
                };
                this.rowsMap.set(id, row);
                this.rowsarrids.push(row);
            }
        }
    }
    addRowsForMissingItems(id, qppuser) {
        var _a;
        const achema = this.schemas.get(this.activeschema);
        if (!achema)
            return;
        const items = achema.items.filter((it) => it.id === id);
        if (items.length !== 1 || items[0].type !== SchemaItemType.Remote)
            return;
        const item = items[0];
        const remoteid = item.id + "---" + item.sid + "---" + item.cid;
        if (!this.dependentdata.has(remoteid)) {
            APPEvent.publishApperror("Sorry, no items found for remote object");
            return;
        }
        this.remoteitembuilder.setAdding(true);
        let ent = [];
        // lets now do somethingclever 
        let doneent = new Set();
        for (const row of this.rowsMap.values()) {
            for (const en of row.entry) {
                if (en.cellid === id) {
                    if (!en.decrypted) {
                        this.decryptCell(en);
                    }
                    const parts = en.celldata.split(",");
                    for (const p of parts) {
                        doneent.add(p);
                    }
                }
            }
        }
        const vals = (_a = this.dependentdata.get(remoteid)) !== null && _a !== void 0 ? _a : [];
        for (const val of vals) {
            if (!doneent.has(val.id)) {
                const entry = {
                    celldata: val.id,
                    cellfindstr: '',
                    cellid: id,
                    schemaid: this.activeschema,
                    rowindex: -1,
                    subrowindex: "0",
                    rowid: "",
                    id: "",
                    sortstring: Math.random()
                };
                ent.push([entry]);
            }
        }
        if (ent.length > 0) {
            this.addEntries(ent, false, achema, qppuser);
        }
        else {
            this.remoteitembuilder.setAdding(false);
            APPEvent.publishApperror("No new row to be added");
        }
    }
    removeRowFromSchema(id, rowid) {
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            childid: id,
            rowids: [rowid],
            readonly: false
        };
        this.addIdToRemovingCh(id);
        Apphandler.sendMessage("removeowfromchildsch", req);
    }
    addSelectedRowsToChildWorksheet() {
        if (this.selectedrows.size === 0 || !this.activechildschema) {
            return;
        }
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            childid: this.activechildschema,
            rowids: Array.from(this.selectedrows.values()),
            readonly: this.readonlyrows
        };
        this.setAddingRowToChildren(true);
        Apphandler.sendMessage("addrowtochildsch", req);
    }
    setNoteLinksDialogLeft(left) {
        this.notelinksdialogleft = left;
    }
    setNoteLinksDialogTop(top) {
        this.notelinksdialogtop = top;
    }
    setSelectedRow(id) {
        this.selectedrows.add(id.rowid);
        this.selrowmap.set(id.rowid, id);
    }
    setUnSelectedRow(id) {
        this.selectedrows.delete(id);
        this.selrowmap.delete(id);
        this.selectallrows = false;
        if (this.selectedrows.size === 0) {
            this.setActiveAction("unknown");
        }
    }
    createEntryFromExcelCol(value, citem, sh) {
        const val = {
            celldata: value,
            cellfindstr: value,
            cellid: citem.id,
            subrowindex: "0",
            schemaid: '',
            rowindex: -1,
            rowid: '',
            id: '',
            sortstring: Math.random()
        };
        if (citem) {
            if (citem.type === SchemaItemType.Number) {
                let sortstring = -1;
                if (val.celldata.indexOf(".") > -1) {
                    sortstring = sh.numberoffset + parseFloat(val.celldata);
                }
                else {
                    sortstring = sh.numberoffset + parseInt(val.celldata);
                }
                val.sortstring = sortstring;
            }
            else if (citem.type === SchemaItemType.Date) {
                if (val.celldata) {
                    val.sortstring = sh.dateoffset + parseInt(val.celldata);
                }
            }
            val.schemaid = this.activeschema;
        }
        return val;
    }
    selectAllRow() {
        this.rowsMap.forEach((rm) => {
            if (!this.hiddenrows.has(rm.rowid)) {
                this.selectedrows.add(rm.rowid);
            }
        });
        this.selectallrows = true;
    }
    unselectAllRow() {
        this.selectedrows.clear();
        this.selrowmap.clear();
        this.setActiveAction("unknown");
        this.selectallrows = false;
    }
    setAddingRowToChildren(adding) {
        this.addingrowtochild = adding;
    }
    setShowLinksForNote(noteid) {
        this.showinoutlinks.add(noteid);
    }
    clearShowLinksForNote() {
        this.showinoutlinks.clear();
    }
    removeShowLinksForNote(noteid) {
        this.showinoutlinks.delete(noteid);
    }
    setLoadingNotes(loading) {
        this.loadingnotes = loading;
    }
    setShowNotesPanel(show) {
        this.shownotespanel = show;
    }
    addNote(note) {
        this.notesbyid.set(note.id, this.convertNoteToNoteUI(note));
    }
    setDeletingNote(dn) {
        this.deletenoteids.add(dn);
    }
    loadChats() {
        if (this.loadingchats) {
            return;
        }
        this.setLoadingChat(true);
        const getcoom = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            noteid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid
        };
        Apphandler.sendMessage("getcomments", getcoom);
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        const getcoom = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            noteid: this.editnoteid
        };
        Apphandler.sendMessage("getcomments", getcoom);
    }
    setEditMode(mode) {
        this.editmode = mode;
        if (!mode) {
            this.activeaccessids = new Set([ALLViewer]);
            this.appliedaclstr = "---";
        }
    }
    deleteComment(id) {
        const req = {
            letrid: this.activelterid,
            objectid: this.editnoteid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
    deleteChat(id) {
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
    setShowFilter(show) {
        this.showfilter = show;
    }
    addLink(link) {
        this.links.splice(0, this.links.length);
        this.links.push(link);
        this.setSavingNote(true);
        this.saveNote();
    }
    saveNote() {
        var _a;
        const marking = "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid;
        const databox = {
            detail: [{ key: 'systemtext', value: '' }],
            notetype: AnnotationType.Freehand,
            boxes: [],
            match: marking,
            color: (_a = this.colorstate.color) !== null && _a !== void 0 ? _a : 'lightgray',
            storekthickness: -1
        };
        const note = {
            id: "",
            data: databox,
            type: NoteType.Note,
            viewer: Array.from(this.activeaccessids),
            parentid: "",
            authorname: "",
            authorid: "",
            updatetime: 0,
            replycount: 0,
            aclstr: "---",
            notereference: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid
        };
        this.activerequestid = Math.random() + "";
        if (this.links.length > 0) {
            note.linkboxes = this.links;
        }
        const req = {
            reqid: this.activerequestid,
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            note: note,
            comment: this.commentstate.getComments()
        };
        Apphandler.sendMessage("savenote", req);
        this.setSavingNote(true);
    }
    saveEdit() {
        if (this.editmode && this.editnoteid) {
            // lets get the new two filed and that's all
            const uinote = this.notesbyid.get(this.editnoteid);
            if (uinote !== undefined) {
                const enote = uinote.note;
                enote.aclstr = this.appliedaclstr;
                enote.viewer = Array.from(this.activeaccessids);
                enote.data.detail = [{ key: 'systemtext', value: '' }];
                this.setSavingNote(true);
                this.activerequestid = enote.id;
                const req = {
                    reqid: this.activerequestid,
                    letrid: this.activelterid,
                    objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
                    note: enote,
                    comment: []
                };
                Apphandler.sendMessage("updatenote", req);
            }
        }
    }
    setSavingNote(saving) {
        this.savingnote = saving;
    }
    setEditNoteId(id) {
        this.editnoteid = id;
        this.setLoadingComments(false);
        this.commentstate.clear();
        this.loadComments();
        this.lastcommenttime = -1;
    }
    deleteEditNote(nid) {
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            id: nid
        };
        this.setDeletingNote(nid);
        Apphandler.sendMessage("deletenote", req);
    }
    deleteSchema(id) {
        const req = {
            id: id,
            letrid: this.activelterid
        };
        this.deletingschid = id;
        this.setDeleting(true);
        Apphandler.sendMessage("deleteschema", req);
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    setLoadingChat(loading) {
        this.loadingchats = loading;
    }
    getAllNotes() {
        if (this.loadingnotes) {
            return;
        }
        this.lastnotesupdatetime = -1;
        this.activeloadednotesref = "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid;
        this.setLoadingNotes(true);
        const req = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            ischooser: false
        };
        Apphandler.sendMessage("getnotes", req);
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
    }
    convertNoteToNoteUI(note) {
        const noteui = new DraftNoteUI(note);
        noteui.setNote(note);
        noteui.setVisible(true);
        return noteui;
    }
    clearLinks() {
        this.links.splice(0, this.links.length);
    }
    removeNote(nid) {
        this.notesbyid.delete(nid);
    }
    setAppliedAclString(str) {
        this.appliedaclstr = str;
    }
    selectAccessids(ids) {
        this.activeaccessids.clear();
        for (const id of ids) {
            this.addActiveAccessId(id);
        }
    }
    addActiveAccessId(id) {
        this.activeaccessids.add(id);
    }
    getChatUpdate() {
        if (this.loadingchats || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid) {
            return;
        }
        const comms = this.chatstate.getComments();
        if (this.lastchattime == -1) {
            this.lastchattime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastchattime,
            noteid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getCommentUpdate() {
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid
            || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loadingnotes || !this.activelterid || !this.activedatasheet || !this.activeschema
            || !this.activerowid) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activelterid,
            objectid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            referencid: "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid,
            since: this.lastnotesupdatetime,
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    setStartNotes(start) {
        this.startnotes = start;
    }
    updateRow(id, entry, updateui = true) {
        var _a, _b, _c;
        let rindex = -1;
        const row = this.rowsMap.get(id);
        if (row) {
            this.changedrowsid.add(row.rowid);
            for (const en of entry) {
                let eindex = -1;
                for (let i = 0; i < row.entry.length; i++) {
                    const ren = row.entry[i];
                    if (ren.id === en.id) {
                        eindex = i;
                    }
                }
                if (eindex > -1) {
                    row.entry.splice(eindex, 1, en);
                }
                else {
                    row.entry.push(en);
                }
            }
            for (const en of this.deleteentries) {
                let eindex = -1;
                for (let i = 0; i < row.entry.length; i++) {
                    const ren = row.entry[i];
                    if (ren.id === en.id) {
                        eindex = i;
                    }
                }
                if (eindex > -1) {
                    row.entry.splice(eindex, 1);
                }
            }
            this.addRuleEntryToRow(row);
            this.redoRowRule(row);
            this.rowsMap.set(id, row);
            this.cacheui.delete(id);
            if (this.activeview === 'card') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildCardItem(row, achema, this.activecardsttaus, this.activecardgroupby);
                    if (item) {
                        this.kanbanstatus.updateCard(item);
                    }
                }
                // lets build this card now!
            }
            else if (this.activeview === 'calendar') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildCalendarCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                    if (item) {
                        item.extraprop = (_a = this.calendarstate.elements.get(item.id)) === null || _a === void 0 ? void 0 : _a.extraprop;
                        this.calendarstate.updateElement(item.id, item);
                    }
                }
            }
            else if (this.activeview === 'gantt') {
                const achema = this.schemas.get(this.activeschema);
                if (achema) {
                    const item = this.buildGanttCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                    if (item) {
                        item.extraprop = (_b = this.timelinestatus.timelinecards.get(item.id)) === null || _b === void 0 ? void 0 : _b.extraprop;
                        this.timelinestatus.updateElement(item.id, item);
                    }
                }
            }
            else if (this.activeview === 'chart') {
                if (this.chartstate.size > 0) {
                    for (const ct of Array.from(this.chartstate.values())) {
                        this.buildChart(ct.id, ct.xid, ct.yid, ct.ctype, ct.colorfield);
                    }
                }
            }
        }
        (_c = this.updatesb) === null || _c === void 0 ? void 0 : _c.call(this, row !== undefined ? [row] : []);
    }
    setActiveTab(tab) {
        this.setActiveCustomTab("");
        this.activedetailtab = tab;
        if ((tab === 'notes' || tab === 'inbound') &&
            this.activeloadednotesref !== "datasheet-" + this.activedatasheet + "-" + this.activeschema + "-" + this.activerowid) {
            this.getAllNotes();
        }
    }
    setShowLinkDialog(show) {
        this.showlinkdialog = show;
    }
    setFilter(filter) {
        for (const n of this.notesbyid.values()) {
            if (n.note !== undefined) {
                if (filter.toDate !== undefined && filter.toDate > 0) {
                    if (n.note.updatetime <= filter.toDate) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromDate !== undefined && filter.fromDate > 0) {
                    if (n.note.updatetime >= filter.fromDate - 1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.toPage !== undefined && filter.toPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg <= filter.toPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.fromPage !== undefined && filter.fromPage > 0) {
                    const parts = n.note.data.match.split(":");
                    if (parts.length > 1) {
                        const stpg = parseInt(parts[1]);
                        if (stpg >= filter.fromPage - 1) {
                        }
                        else {
                            n.setVisible(false);
                            continue;
                        }
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.type != undefined && filter.type.length > 0) {
                    if (filter.type.indexOf(n.note.data.notetype) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.authors != undefined && filter.authors.length > 0) {
                    if (filter.authors.indexOf(n.note.authorid) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.notetype.length > 0) {
                    if (n.note.linkboxes !== undefined && n.note.linkboxes.length > 0 && filter.notetype.indexOf(n.note.type) !== -1) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                if (filter.notetype != undefined && filter.filterlinknote) {
                    if (n.note.linkboxes === undefined) {
                    }
                    else {
                        n.setVisible(false);
                        continue;
                    }
                }
                n.setVisible(true);
            }
        }
    }
    setNotesLoading(load) {
        this.schemanotesloading = load;
    }
    async saveActiveRowEdits(appuser) {
        var _a, _b, _c, _d;
        let arow = this.rowsMap.get(this.activerowid);
        if (!this.activeschema || !arow) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        if (this.editrowproperty.size === 0 && this.deleteentries.length === 0) {
            return;
        }
        this.setSavingRow(true);
        // now lets just save thes evalues and we done hurraty!!
        const cellmap = new Map();
        for (const shi of (_b = (_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) {
            cellmap.set(shi.id, shi);
            if (shi.type === SchemaItemType.List) {
                const litem = shi;
                if (litem.items && litem.items.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                        for (const id of this.changedlistitems) {
                            if (id.indexOf(litem.id + "----" + item.id) !== -1) {
                                cellmap.set(id, item.item); // we have sitem for this now!
                                if (item.item.required) {
                                    const val = this.formentry.get(id);
                                    if (val === undefined || val === null || val.celldata === undefined ||
                                        val.celldata === null || val.celldata.trim() === '') {
                                        APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is  a mandatory field.");
                                        this.setStoringForm(false);
                                        return;
                                    }
                                }
                                if (item.item.type === SchemaItemType.URL) {
                                    // lets hyst 
                                    const val = this.formentry.get(id);
                                    if (val === null || val === void 0 ? void 0 : val.celldata) {
                                        try {
                                            const ud = JSON.parse(val.celldata);
                                            if (!ud.url.trim()) {
                                                APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is missing url.");
                                                this.setStoringForm(false);
                                                return;
                                            }
                                        }
                                        catch (ex) {
                                            APPEvent.publishApperror(shi.name + " is missing url.");
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                }
                                if (item.item.type === SchemaItemType.Number) {
                                    const val = this.editrowproperty.get(id);
                                    if (val === null || val === void 0 ? void 0 : val.celldata) {
                                        try {
                                            const it = item.item;
                                            const num = parseFloat(val.celldata);
                                            if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                                APPEvent.publishApperror(((_c = achema.parentschema) === null || _c === void 0 ? void 0 : _c.name) + "Please enter a number between " + it.minvalue +
                                                    ' and ' + it.maxvalue + ' field ' + it.name + ' of dervied item ' + shi.name);
                                                this.setSavingRow(false);
                                                return;
                                            }
                                            else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                                APPEvent.publishApperror(((_d = achema.parentschema) === null || _d === void 0 ? void 0 : _d.name) + "Please enter a number between " + it.minvalue +
                                                    ' and ' + it.maxvalue + ' field ' + it.name + ' of dervied item ' + shi.name);
                                                this.setSavingRow(false);
                                                return;
                                            }
                                        }
                                        catch (ex) {
                                            APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    ;
                }
            }
            const sentry = this.editrowproperty.get(shi.id);
            if (shi.required && sentry && !sentry.celldata) {
                APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                this.setSavingRow(false);
                return;
            }
            if (shi.type === SchemaItemType.URL) {
                // lets hyst 
                const val = this.editrowproperty.get(shi.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const ud = JSON.parse(val.celldata);
                        if (!ud.url.trim()) {
                            APPEvent.publishApperror(shi.name + " is missing url.");
                            this.setSavingRow(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror(shi.name + " is missing url.");
                        this.setSavingRow(false);
                        return;
                    }
                }
            }
            if (shi.type === SchemaItemType.Number) {
                const val = this.editrowproperty.get(shi.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const it = shi;
                        const num = parseFloat(val.celldata);
                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for dervied item ' + it.name);
                            this.setSavingRow(false);
                            return;
                        }
                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for dervied item ' + it.name);
                            this.setSavingRow(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                        this.setStoringForm(false);
                        return;
                    }
                }
            }
        }
        for (const shi of achema.items) {
            cellmap.set(shi.id, shi);
            if (shi.type === SchemaItemType.List) {
                const litem = shi;
                if (litem.items && litem.items.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                        for (const id of this.changedlistitems) {
                            if (id.indexOf(litem.id + "----" + item.id) !== -1) {
                                cellmap.set(id, item.item); //save we have sitem for this now!
                                if (item.item.required) {
                                    // const val = this.formentry.get(id);
                                    const val = this.editrowproperty.get(id);
                                    if (val === undefined || val === null || val.celldata === undefined ||
                                        val.celldata === null || val.celldata.trim() === '') {
                                        APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is  a mandatory field.");
                                        this.setSavingRow(false);
                                        return;
                                    }
                                }
                                if (item.item.type === SchemaItemType.URL) {
                                    // lets hyst 
                                    // const val = this.formentry.get(id);
                                    const val = this.editrowproperty.get(id);
                                    if (val === null || val === void 0 ? void 0 : val.celldata) {
                                        try {
                                            const ud = JSON.parse(val.celldata);
                                            if (!ud.url.trim()) {
                                                APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is missing url.");
                                                this.setSavingRow(false);
                                                return;
                                            }
                                        }
                                        catch (ex) {
                                            APPEvent.publishApperror(shi.name + " is missing url.");
                                            this.setSavingRow(false);
                                            return;
                                        }
                                    }
                                }
                                if (item.item.type === SchemaItemType.Number) {
                                    const val = this.editrowproperty.get(id);
                                    if ((val === null || val === void 0 ? void 0 : val.celldata) && ((val === null || val === void 0 ? void 0 : val.celldata) + "") !== '') {
                                        try {
                                            const it = item.item;
                                            const num = parseFloat(val.celldata);
                                            if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                                APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                    ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + shi.name);
                                                this.setSavingRow(false);
                                                return;
                                            }
                                            else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                                APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                    ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + shi.name);
                                                this.setSavingRow(false);
                                                return;
                                            }
                                        }
                                        catch (ex) {
                                            APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                            this.setSavingRow(false);
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    ;
                }
            }
            const sentry = this.editrowproperty.get(shi.id);
            if (shi.required && sentry && !sentry.celldata) {
                APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                this.setSavingRow(false);
                return;
            }
            if (shi.type === SchemaItemType.URL) {
                // lets hyst 
                const val = this.editrowproperty.get(shi.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const ud = JSON.parse(val.celldata);
                        if (!ud.url.trim()) {
                            APPEvent.publishApperror(shi.name + " is missing url.");
                            this.setSavingRow(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror(shi.name + " is missing url.");
                        this.setSavingRow(false);
                        return;
                    }
                }
            }
            if (shi.type === SchemaItemType.Number) {
                const val = this.editrowproperty.get(shi.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const it = shi;
                        const num = parseFloat(val.celldata);
                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setSavingRow(false);
                            return;
                        }
                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setSavingRow(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                        this.setSavingRow(false);
                        return;
                    }
                }
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                for (const shi of sh.items) {
                    cellmap.set(shi.id, shi);
                    if (shi.type === SchemaItemType.List) {
                        const litem = shi;
                        if (litem.items && litem.items.length > 0) {
                            for (const item of litem.items) {
                                cellmap.set(litem.id + "----" + item.id, item.item);
                                for (const id of this.changedlistitems) {
                                    if (id.indexOf(litem.id + "----" + item.id) !== -1) {
                                        cellmap.set(id, item.item); // we have sitem for this now!
                                        if (item.item.required) {
                                            const val = this.formentry.get(id);
                                            if (val === null || val === undefined || val.celldata === undefined
                                                || val.celldata === null || val.celldata.trim() === '') {
                                                APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is  a mandatory field.");
                                                this.setSavingRow(false);
                                                return;
                                            }
                                        }
                                        if (item.item.type === SchemaItemType.URL) {
                                            // lets hyst 
                                            // const val = this.formentry.get(id);
                                            const val = this.editrowproperty.get(id);
                                            if (val === null || val === void 0 ? void 0 : val.celldata) {
                                                try {
                                                    const ud = JSON.parse(val.celldata);
                                                    if (!ud.url.trim()) {
                                                        APPEvent.publishApperror(item.item.name + " field of " + shi.name + " is missing url.");
                                                        this.setSavingRow(false);
                                                        return;
                                                    }
                                                }
                                                catch (ex) {
                                                    APPEvent.publishApperror(shi.name + " is missing url.");
                                                    this.setSavingRow(false);
                                                    return;
                                                }
                                            }
                                        }
                                        if (item.item.type === SchemaItemType.Number) {
                                            const val = this.editrowproperty.get(id);
                                            if (val === null || val === void 0 ? void 0 : val.celldata) {
                                                try {
                                                    const it = item.item;
                                                    const num = parseFloat(val.celldata);
                                                    if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                                        APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                            ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + shi.name);
                                                        this.setSavingRow(false);
                                                        return;
                                                    }
                                                    else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                                        APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                            ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + shi.name);
                                                        this.setSavingRow(false);
                                                        return;
                                                    }
                                                }
                                                catch (ex) {
                                                    APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                                    this.setSavingRow(false);
                                                    return;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            ;
                        }
                    }
                    const sentry = this.editrowproperty.get(shi.id);
                    if (shi.required && sentry && !sentry.celldata) {
                        APPEvent.publishApperror(shi.name + " is  a mandatory field.");
                        this.setSavingRow(false);
                        return;
                    }
                    if (shi.type === SchemaItemType.URL) {
                        // lets hyst 
                        const val = this.editrowproperty.get(shi.id);
                        if (val === null || val === void 0 ? void 0 : val.celldata) {
                            try {
                                const ud = JSON.parse(val.celldata);
                                if (!ud.url.trim()) {
                                    APPEvent.publishApperror(shi.name + " is missing url.");
                                    this.setSavingRow(false);
                                    return;
                                }
                            }
                            catch (ex) {
                                APPEvent.publishApperror(shi.name + " is missing url.");
                                this.setSavingRow(false);
                                return;
                            }
                        }
                    }
                    if (shi.type === SchemaItemType.Number) {
                        const val = this.editrowproperty.get(shi.id);
                        if (val === null || val === void 0 ? void 0 : val.celldata) {
                            try {
                                const it = shi;
                                const num = parseFloat(val.celldata);
                                if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                    APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                        ' and ' + it.maxvalue + ' for ' + it.name);
                                    this.setSavingRow(false);
                                    return;
                                }
                                else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                    APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                        ' and ' + it.maxvalue + ' for ' + it.name);
                                    this.setSavingRow(false);
                                    return;
                                }
                            }
                            catch (ex) {
                                APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                this.setSavingRow(false);
                                return;
                            }
                        }
                    }
                }
            }
        }
        const sh = achema;
        const sentries = [];
        for (const [k, val] of this.editrowproperty) {
            const citem = cellmap.get(k);
            val.decrypted = true;
            if (citem) {
                if (citem.type === SchemaItemType.Number) {
                    let sortstring = -1;
                    if (val.celldata.indexOf(".") > -1) {
                        sortstring = sh.numberoffset + parseFloat(val.celldata);
                    }
                    else {
                        sortstring = sh.numberoffset + parseInt(val.celldata);
                    }
                    val.sortstring = sortstring;
                }
                else if (citem.type === SchemaItemType.Date) {
                    if (val.celldata) {
                        val.sortstring = sh.dateoffset + parseInt(val.celldata);
                    }
                }
                sentries.push(val);
            }
        }
        let key = sh.accesskey;
        let nonce = sh.nonce;
        if (arow.entry[0].schemaid !== this.activeschema) {
            if (!sh.parentschema) {
                return;
            }
            key = sh.parentschema.accesskey;
            nonce = sh.parentschema.nonce;
        }
        if (sentries.length > 0 || this.deleteentries.length > 0) {
            let custompackets = [];
            if (achema.custompostaction) {
                const actionfn = new Function("config", achema.custompostaction);
                const actionconfig = {
                    getschemarows: (sid) => {
                        let apish = this.schemaapimap.get(sid);
                        let tid = this.schematemplatemap.get(sid);
                        if (apish) {
                            sid = apish.id;
                        }
                        else if (tid) {
                            sid = tid.id;
                        }
                        return this.getDependSchemaRows(sid);
                    },
                    decryptCell: (entry, sid) => {
                        if (!entry.decrypted) {
                            this.decryptEntry(entry, sid);
                        }
                        return entry;
                    },
                    getactiveuserid: () => this.userid,
                    stripHTML: (msg) => LWStripHTML(msg),
                    saveentrytoworksheet: async (entry, worksheetid, subrowind, cb) => {
                        cb(entry, []);
                    },
                };
                const bui = actionfn(actionconfig);
                if (bui.notificationpackets !== undefined) {
                    custompackets = await new Promise((ac, rej) => {
                        var _a;
                        bui.notificationpackets(sentries, false, (_a = arow === null || arow === void 0 ? void 0 : arow.entry) !== null && _a !== void 0 ? _a : [], (msg) => {
                            ac(msg);
                        });
                    });
                }
            }
            const reqid = Math.random() + "";
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                reqid: reqid,
                entries: sentries,
                accesskey: key,
                nonce: nonce,
                rowid: this.activerowid,
                duplicaterequest: false,
                schemaitems: Array.from(cellmap.values()),
                deleteentries: this.deleteentries.map((en) => (Object.assign(Object.assign({}, en), { celldata: '', cellfindstr: '' }))),
                assigns: this.checkRowNeedsAutoAssignment(sentries, appuser),
                nvs: this.checkWithViewNeedNotification(sentries),
                custompackets: custompackets
            };
            this.activereqid = reqid;
            Apphandler.sendMessage("updaterow", req);
        }
        else {
            this.setSavingRow(false);
        }
    }
    async addMultiEntries() {
        //
        var _a;
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        if (this.newformmap.size === 0) {
            return;
        }
        if (this.activeformid) {
            this.newformmap.set(this.activeformid, this.formentry);
        }
        // now we  can validate the new form
        //mandatory fields
        // defualt values
        // dates
        let manfields = new Set();
        let datefields = new Map();
        for (const item of achema.items) {
            if (item.type === SchemaItemType.List) {
                let litem = item;
                for (const ll of litem.items) {
                    if (ll.item.required) {
                        manfields.add(item.id + "----" + ll.id);
                    }
                    if (ll.item.type === SchemaItemType.Date) {
                        datefields.set(item.id + "----" + ll.id, new Date().getTime() + "");
                    }
                }
            }
            else {
                if (item.required) {
                    manfields.add(item.id);
                }
                if (item.type === SchemaItemType.Date) {
                    datefields.set(item.id, new Date().getTime() + "");
                }
            }
        }
        //now we just  check each form for mand fields and we done then!!
        let entr = [];
        let nots = [];
        for (const [id, val] of this.newformmap) {
            // now we have val!!
            let row = [];
            let foundids = new Set();
            let listidindex = new Map();
            let entryids = new Set();
            for (const [myid, entry] of val) {
                let checkid = myid;
                if (myid.indexOf("----") !== -1) {
                    let myidparts = myid.split("----");
                    checkid = myidparts[0] + "----" + myidparts[1];
                }
                entryids.add(checkid);
            }
            for (const mf of manfields) {
                if (!entryids.has(mf)) {
                    APPEvent.publishApperror("Please make sure to fill all required/ mandatory items");
                    return;
                }
            }
            for (const [myid, entry] of val) {
                // now lets go ijto this!!
                if (myid.indexOf("----") !== -1) {
                    let myidparts = myid.split("----");
                    let checkid = myidparts[0] + "----" + myidparts[1];
                    if (!listidindex.has(checkid)) {
                        listidindex.set(checkid, -1);
                    }
                    let va = listidindex.get(checkid);
                    if (!va) {
                        va = 0;
                    }
                    else {
                        va++;
                    }
                    listidindex.set(checkid, va);
                    if (checkid && manfields.has(checkid) && !entry.celldata) {
                        APPEvent.publishApperror("Please make sure to fill all required/ mandatory items");
                        return;
                    }
                    entry.cellid = checkid;
                    entry.subrowindex = va + "----" + myidparts[2];
                }
                else {
                    if (manfields.has(myid) && !entry.celldata) {
                        APPEvent.publishApperror("Please make sure to fill all required/ mandatory items");
                        return;
                    }
                }
                row.push(entry);
            }
            let customPackets = [];
            if (achema.custompostaction) {
                const actionfn = new Function("config", achema.custompostaction);
                const actionconfig = {
                    getschemarows: (sid) => {
                        let apish = this.schemaapimap.get(sid);
                        let tid = this.schematemplatemap.get(sid);
                        if (apish) {
                            sid = apish.id;
                        }
                        else if (tid) {
                            sid = tid.id;
                        }
                        return this.getDependSchemaRows(sid);
                    },
                    decryptCell: (entry, sid) => {
                        if (!entry.decrypted) {
                            this.decryptEntry(entry, sid);
                        }
                        return entry;
                    },
                    getactiveuserid: () => this.userid,
                    stripHTML: (msg) => LWStripHTML(msg),
                    saveentrytoworksheet: async (entry, worksheetid, subrowind, cb) => {
                        cb(entry, []);
                    },
                };
                const bui = actionfn(actionconfig);
                if (bui.notificationpackets !== undefined) {
                    customPackets = await new Promise((ac, rej) => {
                        bui.notificationpackets(row, true, [], (msg) => {
                            ac(msg);
                        });
                    });
                }
            }
            nots.push(customPackets);
            entr.push(row);
        }
        let sh = achema;
        let key = sh.accesskey;
        let nonce = sh.nonce;
        let cellmap = new Map();
        for (const shi of achema.items) {
            cellmap.set(shi.id, shi);
            if (shi.type === SchemaItemType.List) {
                let lsh = shi;
                for (const lii of lsh.items) {
                    cellmap.set(shi.id + "----" + lii.id, lii.item);
                }
            }
        }
        this.setStoringForm(true);
        // now we are through lets just add this now and we done!!
        // just need to create saving patterns here
        let mentries = {
            letrid: this.activelterid,
            sid: this.activeschema,
            accesskey: key,
            sitems: Array.from(cellmap.values()),
            nonce: nonce,
            entries: entr,
            nots: nots
        };
        let index = 0;
        for (const en of entr) {
            let not = mentries.nots[index];
            const row = await BSchemaStore.storeEntry(en, mentries.letrid, mentries.sid, mentries.accesskey, mentries.nonce, "", mentries.sitems, [], [], not);
            if (row) {
                this.changedrowsid.add(row.rowid);
                this.addRow(row);
                this.insertRowsAtEnd([row]);
                // maybe we should scroll too 
                this.setActiveRowId("");
                (_a = this.tableref) === null || _a === void 0 ? void 0 : _a.scrollToIndex(this.rowsMap.size - 1);
            }
            index++;
        }
        this.setShowForm(false);
        this.setStoringForm(false);
    }
    saveDataRowRules() {
        var _a, _b;
        const rules = this.rowdatarulebuilderstate.convertRuleUIsToRules();
        this.rowdatarulebuilderstate.setSaving(true);
        // also lets get the 
        const rr = {
            id: this.activeschema + "~~~" + this.activerowid,
            letrid: this.activelterid,
            schemaid: this.activeschema,
            data: (_b = (_a = this.rowRules.get(this.activeschema + "~~~" + this.activerowid)) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [],
            datarules: rules,
            rowid: this.activerowid,
        };
        Apphandler.sendMessage("addrowrule", rr);
    }
    saveRowRules() {
        var _a, _b;
        const rules = this.rowrulebuilderstate.convertRuleUIsToRules();
        this.rowrulebuilderstate.setSaving(true);
        // also lets get the 
        const rr = {
            id: this.activeschema + "~~~" + this.activerowid,
            letrid: this.activelterid,
            schemaid: this.activeschema,
            data: rules,
            datarules: (_b = (_a = this.rowDataRules.get(this.activeschema + "~~~" + this.activerowid)) === null || _a === void 0 ? void 0 : _a.datarules) !== null && _b !== void 0 ? _b : [],
            rowid: this.activerowid,
        };
        Apphandler.sendMessage("addrowrule", rr);
    }
    async addExcelEntries(ent, updatesh, sh, appuseropen, updatents) {
        if (updatents.length > 0) {
            const ureq = {
                schema: sh,
                letrid: this.activelterid,
                entries: updatents,
                delentries: ent
            };
            Apphandler.sendMessage("updateandaddrows", ureq);
        }
        else {
            this.addEntries(ent, updatesh, sh, appuseropen);
        }
    }
    async addEntries(ent, updatesh, sh, appuseropen) {
        var _a, _b;
        const reqid = Math.random() + "";
        this.activeentriesid = reqid;
        let key = sh.accesskey;
        let nonce = sh.nonce;
        const cellmap = new Map();
        const defaultvalue = new Map();
        let count = 0;
        const sens = [];
        const assigns = [];
        const nvs = [];
        for (const rn of ent) {
            const newens = this.buildNewRowFromDataRules(rn);
            sens.push(newens);
            assigns.push(this.checkRowNeedsAutoAssignment(newens, appuseropen));
            nvs.push(this.checkWithViewNeedNotification(newens));
            if (count > 100) {
                await timeout(10);
                count = 0;
            }
            count++;
        }
        for (const sh1 of (_b = (_a = sh.parentschema) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) {
            cellmap.set(sh1.id, sh1);
            if (sh1.defaultvalue) {
                defaultvalue.set(sh1.id, sh1.defaultvalue);
            }
        }
        for (const sh1 of sh.items) {
            cellmap.set(sh1.id, sh1);
            if (sh1.defaultvalue) {
                defaultvalue.set(sh1.id, sh1.defaultvalue);
            }
        }
        const req = {
            letrid: this.activelterid,
            sid: this.activeschema,
            reqid: reqid,
            entries: ent,
            accesskey: key,
            nonce: nonce,
            rowid: "",
            duplicaterequest: false,
            schemaitems: Array.from(cellmap.values()),
            nvs: nvs,
            assigns: assigns
        };
        if (updatesh) {
            req.schemaupdate = sh;
        }
        Apphandler.sendMessage("addentries", req);
    }
    setDeleteingRows(del) {
        this.deleteingrows = del;
    }
    deleteRows() {
        if (this.selectedrows.size > 0) {
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                rids: []
            };
            if (this.selectallrows && this.hiddenrows.size === 0) {
                req['deleteall'] = true;
            }
            else {
                const dids = Array.from(this.selectedrows.keys()).filter((id) => !this.hiddenrows.has(id));
                req['rids'] = dids;
            }
            this.setDeleteingRows(true);
            console.log(req);
            Apphandler.sendMessage("deleterows", req);
        }
    }
    setShowGanttStartDate(show) {
        this.showganttstartdate = show;
    }
    setShowChartMenu(show) {
        this.showchartmenu = show;
    }
    setShowGanttStartDateName(show) {
        this.showganttstartdatename = show;
    }
    setShowGanttEndDateName(show) {
        this.showganttenddatename = show;
    }
    setShowGanttEndDate(show) {
        this.showganttenddate = show;
    }
    setShowColorField(show) {
        this.showcolorfield = show;
    }
    setColorFieldId(id) {
        this.colorfieldid = id;
    }
    setColorFieldName(id) {
        this.colorfieldname = id;
    }
    addEntryForDeletion(en) {
        this.deleteentries.push(en);
    }
    setShowinfopanelshow(show) {
        this.showinfopanelshow = show;
    }
    setCurrentActiveRowId(id) {
        this.currentactiverowid = id;
    }
    buildCustomColumnJs(id, js, cb) {
        var _a;
        if (this.customcolbuilder.has(id)) {
            return this.customcolbuilder.get(id);
        }
        if (!this.customcolcb.has(id)) {
            this.customcolcb.set(id, []);
        }
        (_a = this.customcolcb.get(id)) === null || _a === void 0 ? void 0 : _a.push(cb);
        if (!this.buildingcolns.has(id)) {
            this.buildingcolns.add(id);
            // we need to revisit this in fiuture!!
        }
    }
    setActiveRowId(id) {
        if (id) {
            Router.setActiveRowid(id);
        }
        this.setActiveCustomTab("");
        this.showpasswordfor.clear();
        this.removingrowsfromsh.clear();
        this.editrowslistitems.splice(0, this.editrowslistitems.length);
        this.activeloadednotesref = "";
        this.activerowid = id;
        this.chatstate.clear();
        this.editrowproperty.clear();
        this.setSavingRow(false);
        this.setActiveTab(this.defaultdetailtab);
        this.setLoadingChat(false);
        this.deleteentries.splice(0, this.deleteentries.length);
        this.changedlistitems.clear();
        if (id) {
            const row = this.rowsMap.get(id);
            if (row) {
                // lets check if the active schema has list items!
                const ash = this.schemas.get(this.activeschema);
            }
        }
        if (id) {
            this.loadChats();
        }
        this.resetNotes();
    }
    removePropertiesFromActiveRow(id) {
        this.editrowproperty.delete(id);
    }
    setPropertiesForActiveRow(id, entry, ignorerebuilding = false, forceids) {
        this.editrowproperty.set(id, entry);
        if (ignorerebuilding && !forceids)
            return;
        if (!ignorerebuilding) {
            this.setIgnoreCustomComponentId(id);
            this.setRebuildingCustom(true);
            setTimeout(() => {
                this.removeIgnoreCustomComponentId(id);
                this.setRebuildingCustom(false);
            }, 50);
        }
        else if (forceids) {
            console.log(forceids);
            for (const fc of forceids) {
                this.addRebuildId(fc);
            }
            setTimeout(() => {
                for (const fc of forceids) {
                    this.removeRebuildId(fc);
                }
            }, 50);
        }
    }
    addRebuildId(id) {
        this.forcerebuildcustom.add(id);
    }
    removeRebuildId(id) {
        this.forcerebuildcustom.delete(id);
    }
    buildNewRowFromNewEntries() {
        const srowui = {
            id: '',
            rowid: this.newrowindex,
            rowindex: -1,
            entry: [],
        };
        const newnes = [];
        for (const [_, en] of this.formentry) {
            newnes.push(toJS(Object.assign(Object.assign({}, en), { decrypted: true })));
        }
        srowui.entry = newnes;
        return srowui;
    }
    buildNewRowFromEdits() {
        if (!this.activerowid)
            return undefined;
        const row = this.rowsMap.get(this.activerowid);
        if (!row)
            return undefined;
        const srowui = Object.assign({}, row);
        const newnes = [];
        const donekeys = new Set();
        for (const en of srowui.entry) {
            let id = en.cellid;
            if (en.subrowindex && en.subrowindex.indexOf("----") !== -1) {
                id += "----" + en.subrowindex;
            }
            const een = this.editrowproperty.get(id);
            if (een) {
                donekeys.add(id);
                newnes.push(toJS(Object.assign(Object.assign({}, een), { decrypted: true })));
            }
            else {
                newnes.push(toJS(Object.assign(Object.assign({}, en), { decrypted: true })));
            }
        }
        for (const k of this.editrowproperty.values()) {
            let id = k.cellid;
            if (k.subrowindex && k.subrowindex.indexOf("----") !== -1) {
                id += "----" + k.subrowindex;
            }
            if (!donekeys.has(id)) {
                newnes.push(toJS(Object.assign(Object.assign({}, k), { decrypted: true })));
            }
        }
        srowui.entry = newnes;
        return srowui;
    }
    setShowDescField(show) {
        this.showdescfield = show;
    }
    setDescFieldId(id) {
        this.descfieldid = id;
    }
    setDescFieldName(id) {
        this.descfieldname = id;
    }
    setGanttStartDate(show) {
        this.ganttstartid = show;
    }
    removeChartState(id) {
        this.chartstate.delete(id);
    }
    setGanttEndDate(show) {
        this.ganttendid = show;
    }
    setActiveGroupByMenu(show) {
        this.showgroupbymenu = show;
    }
    setShowStatusesMenu(show) {
        this.showstatuesmenu = show;
    }
    setActiveCardStatusName(st) {
        this.activecardstatusname = st;
    }
    setActiveCardGroupName(st) {
        this.activecardgroupname = st;
    }
    setActiveCardStatus(st) {
        if (this.activecardsttaus === st) {
            return;
        }
        this.activecardsttaus = st;
        setTimeout(() => this.updateCardView(), 10);
        // lets set these infomration and we done
    }
    setActiveCardGroup(st) {
        if (this.activecardgroupby === st || !this.activecardsttaus) {
            return;
        }
        this.activecardgroupby = st;
        setTimeout(() => this.updateCardView(), 10);
    }
    updateCardView() {
        this.kanbanstatus.clear();
        this.kanbanstatus.setBuildingView(true);
        const cards = this.buildCardView(this.activecardsttaus, this.activecardgroupby);
        const statuses = this.getAllFieldsForItem(this.activecardsttaus);
        this.kanbanstatus.setStatuses(statuses.map((st) => {
            const ret = {
                id: st.id,
                label: st.name
            };
            return ret;
        }));
        if (this.activecardgroupby && this.activecardgroupby !== this.activecardsttaus) {
            const grps = this.getAllFieldsForItem(this.activecardgroupby);
            this.kanbanstatus.setGroupBy(grps.map((st) => {
                const ret = {
                    id: st.id,
                    label: st.name
                };
                return ret;
            }));
        }
        cards === null || cards === void 0 ? void 0 : cards.forEach((cd) => this.kanbanstatus.addCard(cd));
        this.kanbanstatus.setBuildingView(false);
    }
    setActiveDatasheet(did) {
        this.reset();
        this.activedatasheet = did;
        Router.setActiveDatasheet(did);
        this.setLoading(true);
        this.loadSchemas();
    }
    checkAndUpdateRouter() {
        if (!this.activedatasheet)
            return;
        Router.setActiveDatasheet(this.activedatasheet);
        if (this.activeschema) {
            Router.setActiveSchemaid(this.activeschema);
            if (this.activerowid) {
                Router.setActiveRowid(this.activerowid);
            }
        }
    }
    loadSchemas() {
        const req = {
            letrid: this.activelterid,
            datasheetid: this.activedatasheet
        };
        Apphandler.sendMessage("getschemas", req);
    }
    decryptRule(fitem) {
        var _a;
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        if (fitem.rule) {
            try {
                const val = fitem.rule.encryptmsg; //LetrwingCrypto.decryptSecretBox(fitem.rule, key);
                if (val) {
                    const rv = JSON.parse(val);
                    if (rv) {
                        let validrule = false;
                        for (const pr of rv.rule) {
                            for (const rrv of pr.params) {
                                if (rrv.value && rrv.value.split("~~~").length > 2) {
                                    validrule = true;
                                    break;
                                }
                            }
                        }
                        if (validrule) {
                            fitem.ruleopen = rv;
                        }
                    }
                }
            }
            catch (ex) { }
        }
    }
    checkSchemaCellHasRule(cellid) {
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return false;
        }
        if (achema.rules) {
            for (const ar of achema.rules) {
                if (ar.colid === cellid) {
                    return true;
                }
            }
        }
        return false;
    }
    checkRowCellhasRule(rowid, cellid) {
        const rules = this.rowRules.get(this.activeschema + "~~~" + rowid);
        if (rules) {
            for (const ru of rules.data) {
                if (ru.colid === cellid) {
                    return true;
                }
            }
        }
        return this.checkSchemaCellHasRule(cellid);
    }
    checkCellHasRule(fitem) {
        return this.checkRowCellhasRule(fitem.rowid, fitem.cellid);
    }
    redoRowRule(row) {
        for (const en of row.entry) {
            if (en.ruleopen) {
                en.decrypted = false;
            }
        }
    }
    parseCellRule(fitem) {
        var _a;
        if (!this.activeschema) {
            return;
        }
        if (this.parsingentry.has(fitem.id) || fitem.decrypted) {
            return;
        }
        // we should now add this entry in the parsing stuff
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        this.parsingentry.add(fitem.id);
        if (fitem.ruleopen) {
            const wen = Object.assign({}, fitem);
            // lets now rebuild this rule now
            if (!this.depschemarows.has(this.activeschema) ||
                ((_a = this.depschemarows.get(this.activeschema)) === null || _a === void 0 ? void 0 : _a.length) !== this.rowsMap.size) {
                this.depschemarows.set(this.activeschema, Array.from(this.rowsMap.values()).sort((r1, r2) => r1.rowindex - r2.rowindex));
            }
            if (!this.schemasmap.has(this.activeschema)) {
                this.schemasmap.set(this.activeschema, achema);
                if (achema.apicode) {
                    this.schemaapimap.set(achema.apicode, achema);
                }
                if (achema.templateid) {
                    this.schematemplatemap.set(achema.templateid, achema);
                }
            }
            parser([wen], achema, this.depschemarows, this.schemasmap, this.dependentdata);
            // now we have this cell done we just need to remove this cell from the 
            fitem.celldata = wen.celldata;
            fitem.decrypted = true;
            const frow = this.rowsMap.get(fitem.rowid);
            if (frow) {
                for (const en of frow.entry) {
                    if (en.id === fitem.id) {
                        en.decrypted = true;
                        en.celldata = wen.celldata;
                        break;
                    }
                }
            }
        }
        this.removeIdfromParsing(fitem.id);
    }
    getDependentSchemaRowsByName(schemaname) {
        let sh = undefined;
        for (const lsh of this.schemasmap.values()) {
            if (lsh.name === schemaname) {
                sh = lsh;
                break;
            }
        }
        if (sh) {
            return this.getDependSchemaRows(sh.id);
        }
        return [];
    }
    getDependSchemaRows(sid) {
        var _a;
        if (sid === this.activeschema) {
            return this.rowsarrids;
        }
        console.log(sid + " ");
        console.log(this.depschemarows);
        return (_a = this.depschemarows.get(sid)) !== null && _a !== void 0 ? _a : [];
    }
    removeIdfromParsing(id) {
        this.parsingentry.delete(id);
    }
    decryptCellInnline(fitem) {
        if (fitem.decrypted) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        const hasrule = this.checkCellHasRule(fitem);
        if (hasrule) {
            this.parseCellRule(fitem);
            return;
        }
        this.decryptCell(fitem);
    }
    decryptCell(fitem) {
        var _a, _b, _c;
        if (fitem.decrypted) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        const hasrule = this.checkCellHasRule(fitem);
        if (this.fetchingdepend && hasrule) {
            this.waitingentries.push(fitem); // mark it so we can rebuild this once we ready with data
            return; // we cant do much here yet
        }
        if (hasrule) {
            if (!this.parsingentry.has(fitem.id)) {
                // if we have rule then we should just parse this now!!
                setTimeout(() => {
                    this.parseCellRule(fitem);
                }, 0);
            }
            return;
        }
        if (!this.activeschema) {
            return;
        }
        let myitem = undefined;
        for (const si of achema.items) {
            if (si.type === SchemaItemType.List) {
                const lsi = si;
                for (const ssi of lsi.items) {
                    if (ssi.item.id === fitem.cellid) {
                        myitem = ssi.item;
                        break;
                    }
                }
            }
            else {
                if (si.id === fitem.cellid) {
                    myitem = si;
                    break;
                }
            }
        }
        if ((myitem === null || myitem === void 0 ? void 0 : myitem.type) === SchemaItemType.ID) {
            fitem.decrypted = true;
            return fitem;
        }
        if ((myitem === null || myitem === void 0 ? void 0 : myitem.type) === SchemaItemType.SquenceNumber) {
            fitem.decrypted = true;
            fitem.celldata = fitem.celldata.substring("sqn-".length);
            return fitem;
        }
        if (fitem.celldata && fitem.celldata.startsWith("pbk---")) {
            if (!achema.schemaintegrationbox) {
                return;
            }
            let pk = "";
            try {
                const dstr = LetrwingCrypto.decryptSecretBox(achema.schemaintegrationbox, achema.accesskey);
                if (dstr) {
                    const djs = JSON.parse(dstr);
                    pk = djs.privatkey;
                }
            }
            catch (ex) { }
            if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
                pk = achema.parentschema.webformkeys.priavatekey;
            }
            if (!pk) {
                fitem.celldata = '';
                console.log("missing key for rule parsing");
                return;
            }
            try {
                const emsg = fitem.celldata.substring("pbk---".length);
                const jsonstring = LetrwingCrypto.getUTF8FromBase64(emsg);
                const js = JSON.parse(jsonstring);
                const rawdata = LetrwingCrypto.decryptRSABoxRawString(js, { privatkey: pk, publickey: '' });
                fitem.celldata = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.cellfindstr = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.decrypted = true;
            }
            catch (ex) {
                console.log(ex);
            }
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_b = achema.parentschema) === null || _b === void 0 ? void 0 : _b.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        const val = fitem.celldata; //LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.celldata, nonce: '', publickey: '' },
        //key, nonce);
        fitem.celldata = val !== null && val !== void 0 ? val : '';
        if (fitem.cellfindstr) {
            const val = fitem.cellfindstr; //LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.cellfindstr, nonce: '', publickey: '' },
            //key, nonce);
            fitem.cellfindstr = val !== null && val !== void 0 ? val : '';
        }
        else {
            fitem.cellfindstr = '';
        }
        if (myitem && myitem.type === SchemaItemType.Remote) {
            const srit = myitem;
            const id = srit.id + "---" + srit.sid + "---" + srit.cid;
            const dens = this.dependentdata.get(id);
            if (dens) {
                const mit = fitem.celldata.split(",");
                for (const vk of dens) {
                    if (mit.indexOf(vk.id) !== -1) {
                        if (!fitem.remotevalue)
                            fitem.remotevalue = [];
                        (_c = fitem.remotevalue) === null || _c === void 0 ? void 0 : _c.push(vk.value);
                    }
                }
            }
        }
        //lets also attach display value here!!
        fitem.decrypted = true;
    }
    setView(view) {
        console.log(view);
        this.schemaviews.set(view.id, view);
    }
    removeView(view) {
        this.schemaviews.delete(view);
    }
    clearAllViews() {
        this.schemaviews.clear();
    }
    loadAllTriggers() {
        if (!this.activeschema)
            return;
        const achema = this.schemas.get(this.activeschema);
        if (!achema)
            return;
        this.triggersbyCols.clear();
        const req = {
            columnid: '',
            schemaid: this.activeschema,
            letrid: this.activelterid,
            comparevalue: '',
            conds: [],
            id: '',
            triggertype: TriggerType.Equal,
            reminderunit: ReminderUnit.days,
            name: '',
            itemdecriptioncol: '',
            tos: []
        };
        Apphandler.sendMessage("gettriggers", req);
    }
    loadAllViews() {
        if (this.loadingviews)
            return;
        const achema = this.schemas.get(this.activeschema);
        if (!achema)
            return;
        this.setLoadingViews(true);
        const req = {
            id: '',
            schemaid: this.activeschema,
            letrid: this.activelterid,
            sh: achema
        };
        Apphandler.sendMessage("getwebviews", req);
    }
    decryptRemoteCell(fitem) {
        var _a, _b, _c;
        if (fitem.decrypted) {
            return;
        }
        const hasrule = this.checkCellHasRule(fitem);
        if (this.fetchingdepend && hasrule) {
            this.waitingentries.push(fitem); // mark it so we can rebuild this once we ready with data
            return; // we cant do much here yet
        }
        if (hasrule) {
            if (!this.parsingentry.has(fitem.id)) {
                // if we have rule then we should just parse this now!!
                setTimeout(() => {
                    this.parseCellRule(fitem);
                }, 0);
            }
            return;
        }
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        let myitem = undefined;
        for (const si of achema.items) {
            if (si.type === SchemaItemType.List) {
                const lsi = si;
                for (const ssi of lsi.items) {
                    if (ssi.item.id === fitem.cellid) {
                        myitem = ssi.item;
                        break;
                    }
                }
            }
            else {
                if (si.id === fitem.cellid) {
                    myitem = si;
                    break;
                }
            }
        }
        if (fitem.celldata.startsWith("pbk---")) {
            if (!achema.schemaintegrationbox) {
                return;
            }
            let pk = "";
            try {
                const dstr = LetrwingCrypto.decryptSecretBox(achema.schemaintegrationbox, achema.accesskey);
                if (dstr) {
                    const djs = JSON.parse(dstr);
                    pk = djs.privatkey;
                }
            }
            catch (ex) { }
            if (fitem.schemaid === ((_a = achema.parentschema) === null || _a === void 0 ? void 0 : _a.id)) {
                pk = achema.parentschema.webformkeys.priavatekey;
            }
            if (!pk) {
                fitem.celldata = '';
                console.log("missing key for rule parsing");
                return;
            }
            try {
                const emsg = fitem.celldata.substring("pbk---".length);
                const jsonstring = LetrwingCrypto.getUTF8FromBase64(emsg);
                const js = JSON.parse(jsonstring);
                const rawdata = LetrwingCrypto.decryptRSABoxRawString(js, { privatkey: pk, publickey: '' });
                fitem.celldata = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.cellfindstr = rawdata !== null && rawdata !== void 0 ? rawdata : '';
                fitem.decrypted = true;
            }
            catch (ex) {
                console.log(ex);
            }
            return;
        }
        let key = achema.accesskey;
        let nonce = achema.nonce;
        if (fitem.schemaid === ((_b = achema.parentschema) === null || _b === void 0 ? void 0 : _b.id)) {
            key = achema.parentschema.accesskey;
            nonce = achema.parentschema.nonce;
        }
        const val = fitem.celldata; //LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.celldata, nonce: '', publickey: '' },
        //key, nonce);
        fitem.celldata = val !== null && val !== void 0 ? val : '';
        if (fitem.cellfindstr) {
            const val = fitem.cellfindstr; //LetrwingCrypto.decryptBoxWithNonceToStr({ encryptmsg: fitem.cellfindstr, nonce: '', publickey: '' },
            //key, nonce);
            fitem.cellfindstr = val !== null && val !== void 0 ? val : '';
        }
        else {
            fitem.cellfindstr = '';
        }
        if (myitem && myitem.type === SchemaItemType.Remote) {
            const srit = myitem;
            const id = srit.id + "---" + srit.sid + "---" + srit.cid;
            const dens = this.dependentdata.get(id);
            if (dens) {
                const mit = fitem.celldata.split(",");
                for (const vk of dens) {
                    if (mit.indexOf(vk.id) !== -1) {
                        if (!fitem.remotevalue)
                            fitem.remotevalue = [];
                        (_c = fitem.remotevalue) === null || _c === void 0 ? void 0 : _c.push(vk.value);
                    }
                }
            }
        }
        //lets also attach display value here!!
        fitem.decrypted = true;
    }
    buildCalendarTask(sd, render, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.calendarstate.clear();
        this.setActiveRowId("");
        this.calendarstate.setBuilding(true);
        if (isIpadScreen()) {
            this.calendarstate.setWidth(window.innerWidth - 200);
            this.calendarstate.setHeight(window.innerHeight - 400);
        }
        else {
            this.calendarstate.setWidth(window.innerWidth - 700);
            this.calendarstate.setHeight(window.innerHeight - 200);
        }
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let index = 0;
        for (const [k, item] of this.rowsMap) {
            const citem = new CardItem();
            let use = false;
            const epopr = new Map();
            epopr.set("rowindex", index++ + '');
            if (this.hiddenrows.has(item.rowid))
                continue;
            let cevent = {
                id: item.rowid,
                rangedates: [],
                displayItem: citem,
                extraprop: epopr,
                color: this.colors[Math.floor(Math.random() * 3)],
            };
            for (const fitem of item.entry) {
                if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                    && (!desfield || fitem.cellid !== desfield)
                    && (!colorfield || fitem.cellid !== colorfield)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === sd) {
                    try {
                        cevent.rangedates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (ed && fitem.cellid === ed) {
                    try {
                        cevent.rangedates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (colorfield && fitem.cellid === colorfield) {
                    cevent.color = value;
                    continue;
                }
                const sitem = sitemmap.get(fitem.cellid);
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                }
                citem.addDisplayField(fitem.cellid, {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                    sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                    columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                    isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false,
                    isColor: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Color ? true : false
                });
            }
            if (use) {
                this.calendarstate.addElement(cevent.id, cevent);
            }
        }
        this.calendarstate.setBuilding(false);
    }
    buildGanttCard(item, sd, achema, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.timelinestatus.setBuildingView(true);
        if (isIpadScreen()) {
            this.timelinestatus.setWidth(window.innerWidth - 200);
            this.timelinestatus.setHeight(window.innerHeight - 400);
        }
        else {
            this.timelinestatus.setWidth(window.innerWidth - 700);
            this.timelinestatus.setHeight(window.innerHeight - 200);
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let use = false;
        const citem = new CardItem();
        const tlitem = {
            id: item.rowid,
            displayitems: citem,
            displaydate: '',
            rangeDates: [],
            color: this.colors[Math.floor(Math.random() * 3)],
        };
        for (const fitem of item.entry) {
            if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                && (!desfield || fitem.cellid !== desfield)
                && (!colorfield || fitem.cellid !== colorfield)) {
                continue;
            }
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (!value) {
                continue;
            }
            if (fitem.cellid === sd) {
                try {
                    tlitem.rangeDates.push(parseInt(value));
                    const sitem = sitemmap.get(fitem.cellid);
                    if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                        const dit = sitem;
                        if (dit.inlcudetime) {
                            tlitem.displaydate = DateLib.displayDate(parseInt(value));
                        }
                        else {
                            tlitem.displaydate = DateLib.displayOnlyDate(parseInt(value));
                        }
                    }
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (ed && fitem.cellid === ed) {
                try {
                    tlitem.rangeDates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (colorfield && fitem.cellid === colorfield) {
                tlitem.color = value;
                continue;
            }
            const sitem = sitemmap.get(fitem.cellid);
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
            }
            tlitem.displayitems.addDisplayField(fitem.cellid, {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false,
                isColor: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Color ? true : false
            });
        }
        this.timelinestatus.setBuildingView(false);
        if (use) {
            return tlitem;
        }
        return undefined;
    }
    buildCalendarCard(item, sd, achema, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        const citem = new CardItem();
        let use = false;
        let cevent = {
            id: item.rowid,
            rangedates: [],
            displayItem: citem,
            color: this.colors[Math.floor(Math.random() * 3)],
        };
        for (const fitem of item.entry) {
            let multitag = false;
            if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                && (!desfield || fitem.cellid !== desfield)
                && (!colorfield || fitem.cellid !== colorfield)) {
                continue;
            }
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (!value) {
                continue;
            }
            if (fitem.cellid === sd) {
                try {
                    cevent.rangedates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (ed && fitem.cellid === ed) {
                try {
                    cevent.rangedates.push(parseInt(value));
                    use = true;
                    continue;
                }
                catch (ex) { }
            }
            if (colorfield && fitem.cellid === colorfield) {
                cevent.color = value;
                continue;
            }
            const sitem = sitemmap.get(fitem.cellid);
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                let parts = fitem.celldata.split(",");
                if (parts.length > 0) {
                    if (!sitem.multiselect) {
                        parts = [parts[0]];
                    }
                    const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                    if (items.length > 0) {
                        value = items.map((it) => it.name).join(", ");
                        multitag = sitem.multiselect;
                    }
                    else {
                        value = "";
                    }
                }
                else {
                    value = "";
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                let parts = fitem.celldata.split(",");
                if (parts.length > 0) {
                    if (!sitem.multiselect) {
                        parts = [parts[0]];
                    }
                    const items = this.activeusers.filter((it) => parts.indexOf(it.id) !== -1);
                    if (items.length > 0) {
                        value = items.map((it) => it.name).join(", ");
                        multitag = sitem.multiselect;
                    }
                    else {
                        value = "";
                    }
                }
                else {
                    value = "";
                }
            }
            citem.addDisplayField(fitem.cellid, {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                multitag: multitag,
                isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false,
                isColor: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Color ? true : false
            });
        }
        if (use) {
            return cevent;
        }
        return undefined;
    }
    async buildGanTTTask(sd, ed, desfield, colorfield) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.timelinestatus.setBuildingView(true);
        await timeout(10);
        this.timelinestatus.clear();
        this.setActiveRowId("");
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => sitemmap.set(item.id, item));
            }
        }
        let index = 0;
        for (const [k, item] of this.rowsMap) {
            let use = false;
            const citem = new CardItem();
            const epopr = new Map();
            epopr.set("rowindex", index++ + '');
            if (this.hiddenrows.has(item.rowid))
                continue;
            const tlitem = {
                id: item.rowid,
                displayitems: citem,
                displaydate: '',
                rangeDates: [],
                color: this.colors[Math.floor(Math.random() * 3)],
                extraprop: epopr
            };
            for (const fitem of item.entry) {
                let multitag = false;
                if (fitem.cellid !== sd && (!ed || fitem.cellid !== ed)
                    && (!desfield || fitem.cellid !== desfield)
                    && (!colorfield || fitem.cellid !== colorfield)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === sd) {
                    try {
                        tlitem.rangeDates.push(parseInt(value));
                        const sitem = sitemmap.get(fitem.cellid);
                        if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                            const dit = sitem;
                            if (dit.inlcudetime) {
                                tlitem.displaydate = DateLib.displayDate(parseInt(value));
                            }
                            else {
                                tlitem.displaydate = DateLib.displayOnlyDate(parseInt(value));
                            }
                        }
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (ed && fitem.cellid === ed) {
                    try {
                        tlitem.rangeDates.push(parseInt(value));
                        use = true;
                        continue;
                    }
                    catch (ex) { }
                }
                if (colorfield && fitem.cellid === colorfield) {
                    tlitem.color = value;
                    continue;
                }
                const sitem = sitemmap.get(fitem.cellid);
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                    try {
                        tlitem.displayitems.sortnumvalue = parseInt(fitem.celldata);
                    }
                    catch (ex) { }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                    let parts = fitem.celldata.split(",");
                    if (parts.length > 0) {
                        if (!sitem.multiselect) {
                            parts = [parts[0]];
                        }
                        const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                        if (items.length > 0) {
                            value = items.map((it) => it.name).join(", ");
                            multitag = sitem.multiselect;
                        }
                        else {
                            value = "";
                        }
                    }
                    else {
                        value = "";
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                    value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                    let parts = fitem.celldata.split(",");
                    if (parts.length > 0) {
                        if (!sitem.multiselect) {
                            parts = [parts[0]];
                        }
                        const items = this.activeusers.filter((it) => parts.indexOf(it.id) !== -1);
                        if (items.length > 0) {
                            value = items.map((it) => it.name).join(", ");
                            multitag = sitem.multiselect;
                        }
                        else {
                            value = "";
                        }
                    }
                    else {
                        value = "";
                    }
                }
                tlitem.displayitems.addDisplayField(fitem.cellid, {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    multitag: multitag,
                    alignment: ((_c = sitemmap.get(fitem.cellid)) === null || _c === void 0 ? void 0 : _c.type) === SchemaItemType.Number ? AlignMent.Right : (_d = AlignMent.Left) !== null && _d !== void 0 ? _d : AlignMent.Left,
                    sortindex: (_f = (_e = sitemmap.get(fitem.cellid)) === null || _e === void 0 ? void 0 : _e.orderindex) !== null && _f !== void 0 ? _f : -1,
                    columnname: (_h = (_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '',
                    isHtml: ((_j = sitemmap.get(fitem.cellid)) === null || _j === void 0 ? void 0 : _j.type) === SchemaItemType.Text ? true : false,
                    isColor: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Color ? true : false
                });
            }
            if (use) {
                this.timelinestatus.setTimelineCard(tlitem);
            }
        }
        this.timelinestatus.setBuildingView(false);
    }
    getAllFieldsForItem(itemid) {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let csitems = [];
        if (achema.parentschema) {
            csitems.push(...achema.parentschema.items);
        }
        csitems.push(...achema.items);
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                csitems.push(...sh.items);
            }
        }
        const sitems = csitems.find((ite) => ite.id === itemid);
        if (!sitems) {
            return [];
        }
        if (sitems.type === SchemaItemType.UserChoice) {
            return this.activeusers;
        }
        return sitems.items;
    }
    getAllNumberFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Number) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Number) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllFormInputFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.FormInput) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.FormInput) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    checkAnyRowHasFieldSet(field) {
        for (const row of this.rowsMap.values()) {
            for (const en of row.entry) {
                if (en.cellid === field.id) {
                    if (!en.decrypted) {
                        this.decryptCell(en);
                    }
                    if (en.celldata) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getAllTextFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Text) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Text) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllColorFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const sitems = this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Color) {
                const fieldtype = field;
                ret.push(fieldtype);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Color) {
                        const fieldtype = field;
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    getAllFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex).map(f => (Object.assign(Object.assign({}, f), { isparent: true }))));
        }
        const myitems = achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        for (const citem of myitems) {
            if (citem.type === SchemaItemType.List) {
                sitems.push(citem);
                for (const lit of citem.items) {
                    sitems.push(Object.assign(Object.assign({}, lit.item), { id: citem.id + "----" + lit.id, name: citem.name + "!" + lit.item.name }));
                }
            }
            else {
                sitems.push(citem);
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const items = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                sitems.push(...items);
            }
        }
        return sitems;
    }
    getAllDateFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        sitems.push(...this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Date) {
                const fieldtype = field;
                if (!fieldtype.excludedate) {
                    ret.push(fieldtype);
                }
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                const sitems = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
                for (const field of sitems) {
                    if (field.type === SchemaItemType.Date) {
                        const fieldtype = field;
                        if (!fieldtype.excludedate) {
                            ret.push(fieldtype);
                        }
                    }
                }
            }
        }
        return ret;
    }
    getAllCardViewChoiceFields() {
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        let sitems = [];
        if (achema.parentschema) {
            sitems.push(...achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        sitems.push(...this.getAllFields().filter((it) => !this.hiddencolumns.has(it.id)).slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        const ret = [];
        for (const field of sitems) {
            if (field.type === SchemaItemType.Choice) {
                const fieldtype = field;
                if (!fieldtype.multiselect && fieldtype.items && fieldtype.items.length > 0) {
                    ret.push(fieldtype);
                }
            }
            else if (field.type === SchemaItemType.UserChoice) {
                const fieldtype = field;
                if (!fieldtype.multiselect) {
                    ret.push(fieldtype);
                }
            }
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const field of sitems) {
                if (field.type === SchemaItemType.Choice) {
                    const fieldtype = field;
                    if (!fieldtype.multiselect && fieldtype.items && fieldtype.items.length > 0) {
                        ret.push(fieldtype);
                    }
                }
                else if (field.type === SchemaItemType.UserChoice) {
                    const fieldtype = field;
                    if (!fieldtype.multiselect) {
                        ret.push(fieldtype);
                    }
                }
            }
        }
        return ret;
    }
    buildCardItem(item, achema, fieldid, groupby) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const users = this.activeusers;
        const sitemmap = new Map();
        const dname = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => {
                    sitemmap.set(item.id, item);
                    dname.set(item.id, sh.name);
                });
            }
        }
        const activestatusfields = new Map();
        const activegroupfields = new Map();
        const fields = sitemmap.get(this.activecardsttaus);
        if (fields) {
            if (fields.type === SchemaItemType.Choice) {
                fields.items.forEach((it) => activestatusfields.set(it.id, it.name));
            }
            else if (fields.type === SchemaItemType.UserChoice) {
                users.forEach((us) => activestatusfields.set(us.id, us.name));
            }
        }
        const grous = sitemmap.get(this.activecardgroupby);
        if (grous) {
            if (grous.type === SchemaItemType.Choice) {
                grous.items.forEach((it) => activestatusfields.set(it.id, it.name));
            }
            else if (grous.type === SchemaItemType.UserChoice) {
                users.forEach((us) => activestatusfields.set(us.id, us.name));
            }
        }
        let use = true;
        const itemcard = new CardItem();
        itemcard.cradid = item.rowid;
        const emap = new Map();
        for (const en of item.entry) {
            if (!en.decrypted) {
                this.decryptCell(en);
            }
            let id = en.cellid;
            if (en.cellid.indexOf("----") !== -1) {
                id = en.cellid.split("----")[0];
            }
            if (!emap.has(id)) {
                emap.set(id, []);
            }
            (_a = emap.get(id)) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        for (const [k, sm] of sitemmap) {
            const ens = emap.get(sm.id);
            if (ens === undefined) {
                continue;
            }
            const fitem = ens[0];
            let multitag = false;
            if (!fitem.decrypted) {
                this.decryptCell(fitem);
            }
            let value = fitem.celldata;
            if (fitem.cellid === fieldid) {
                // okay good
                if (!fitem.celldata) {
                    use = false;
                    break;
                }
                itemcard.setStatus(fitem.celldata);
            }
            else if (groupby && groupby !== fieldid && fitem.cellid === groupby) {
                itemcard.setGroupid(fitem.celldata);
            }
            let lditems = null;
            let isSecret = false;
            const sitem = sm;
            if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                const sitem = sitemmap.get(fitem.cellid);
                value = (_c = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_b = sitem.excludedate) !== null && _b !== void 0 ? _b : false)) !== null && _c !== void 0 ? _c : '';
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                let parts = fitem.celldata.split(",");
                if (parts.length > 0) {
                    if (!sitem.multiselect) {
                        parts = [parts[0]];
                    }
                    const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                    if (items.length > 0) {
                        value = items.map((it) => it.name).join(", ");
                        multitag = sitem.multiselect;
                    }
                    else {
                        value = "";
                    }
                }
                else {
                    value = "";
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                let parts = fitem.celldata.split(",");
                if (parts.length > 0) {
                    if (!sitem.multiselect) {
                        parts = [parts[0]];
                    }
                    const items = users.filter((it) => parts.indexOf(it.id) !== -1);
                    if (items.length > 0) {
                        value = items.map((it) => it.name).join(", ");
                        multitag = sitem.multiselect;
                    }
                    else {
                        value = "";
                    }
                }
                else {
                    value = "";
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.Objects) {
                let parts = fitem.celldata.split(",");
                if (fitem.linkedids && fitem.linkedids.length > 0) {
                    let obids = [];
                    const pmap = new Map();
                    (_d = fitem.objsdec) === null || _d === void 0 ? void 0 : _d.forEach((ob) => pmap.set("objs-" + ob.id, ob));
                    const smap = new Map();
                    (_e = fitem.schsdec) === null || _e === void 0 ? void 0 : _e.forEach((sj) => smap.set(sj.id, sj));
                    multitag = true;
                    for (const l of fitem.linkedids) {
                        if (l.startsWith("objs-")) {
                            const obj = pmap.get(l);
                            if (obj) {
                                const tds = obj.type === ProjectObjectType.Document ? obj.thumbdetail : undefined;
                                obids.push({
                                    id: l,
                                    type: 'document',
                                    obj: obj,
                                    name: obj.name,
                                    thumdet: tds
                                });
                            }
                        }
                        else if (l.startsWith("dch-")) {
                            const parts = l.split("-");
                            if (parts.length > 2) {
                                const did = parts[1];
                                const sid = parts[2];
                                const dh = this.datasheets.get(did);
                                const sh = smap.get(sid);
                                if (dh && sh) {
                                    obids.push({
                                        id: l,
                                        type: 'datasheet',
                                        obj: dh.name + " ! " + sh.name,
                                        name: dh.name + " ! " + sh.name
                                    });
                                }
                            }
                        }
                    }
                    value = obids.map(c => { var _a; return (_a = c.name) !== null && _a !== void 0 ? _a : ''; }).join(", ");
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Remote) {
                const uent = sitem;
                let remotevals = [];
                const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                const vals = this.dependentdata.get(id);
                multitag = true;
                if (vals) {
                    // now we have this
                    const bits = fitem.celldata.split(",");
                    if (bits && bits.length > 0) {
                        remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1);
                        if (remotevals.length > 0) {
                            value = remotevals.map((val) => val.value).join(", ");
                        }
                    }
                }
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.URL) {
                value = fitem.celldata;
            }
            else if (sitem.type === SchemaItemType.List) {
                lditems = this.buildListItemForCard(ens, sm);
            }
            else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.FormInput) {
                const uent = sitem;
                if (uent.enablesecret) {
                    isSecret = true;
                }
            }
            let cname = (_f = sm.name) !== null && _f !== void 0 ? _f : '';
            const shname = dname.get(fitem.cellid);
            if (shname) {
                cname += " (" + shname + ")";
            }
            let displayItem = {
                id: item.rowid + fitem.cellid,
                value: value,
                alignment: ((_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.type) === SchemaItemType.Number ? AlignMent.Right : (_h = AlignMent.Left) !== null && _h !== void 0 ? _h : AlignMent.Left,
                sortindex: (_j = sitem.orderindex) !== null && _j !== void 0 ? _j : -1,
                columnname: cname,
                multitag: multitag,
                isHtml: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Text ? true : false,
                isColor: ((_l = sitemmap.get(fitem.cellid)) === null || _l === void 0 ? void 0 : _l.type) === SchemaItemType.Color ? true : false,
                isObject: ((_m = sitemmap.get(fitem.cellid)) === null || _m === void 0 ? void 0 : _m.type) === SchemaItemType.Objects ? true : false,
                isURL: ((_o = sitemmap.get(fitem.cellid)) === null || _o === void 0 ? void 0 : _o.type) === SchemaItemType.URL ? true : false,
                isList: sm.type === SchemaItemType.List ? true : false,
                isSecret: isSecret
            };
            if (lditems !== null) {
                displayItem['listItem'] = lditems;
            }
            itemcard.addDisplayField(fitem.cellid, displayItem);
        }
        if (use) {
            return itemcard;
        }
        return undefined;
    }
    buildListItemForCard(en, item) {
        var _a, _b, _c, _d;
        const displayfields = new Map();
        const totalrows = this.arrangeListCells(en);
        const entrymap = new Map();
        const emap = new Map();
        for (const ei of item.items) {
            emap.set(item.id + "----" + ei.id, ei.item);
        }
        for (const ent of en) {
            if (!ent.subrowindex)
                continue;
            entrymap.set(ent.cellid + "----" + ent.subrowindex, ent);
        }
        const users = this.activeusers;
        for (let i = 0; i < totalrows.length; i++) {
            const row = totalrows[i];
            let lditem = [];
            for (const [_, entry] of emap) {
                const en = entrymap.get(item.id + "----" + entry.id + "----" + row);
                if (en !== undefined) {
                    const sitem = entry;
                    const fitem = en;
                    let value = fitem.celldata;
                    let multitag = false;
                    let isSecret = false;
                    if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                        value = (_b = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_a = sitem.excludedate) !== null && _a !== void 0 ? _a : false)) !== null && _b !== void 0 ? _b : '';
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                        let parts = fitem.celldata.split(",");
                        if (parts.length > 0) {
                            if (!sitem.multiselect) {
                                parts = [parts[0]];
                            }
                            const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                            if (items.length > 0) {
                                value = items.map((it) => it.name).join(", ");
                                multitag = sitem.multiselect;
                            }
                            else {
                                value = "";
                            }
                        }
                        else {
                            value = "";
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                        value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                        let parts = fitem.celldata.split(",");
                        if (parts.length > 0) {
                            if (!sitem.multiselect) {
                                parts = [parts[0]];
                            }
                            const items = users.filter((it) => parts.indexOf(it.id) !== -1);
                            if (items.length > 0) {
                                value = items.map((it) => it.name).join(", ");
                                multitag = sitem.multiselect;
                            }
                            else {
                                value = "";
                            }
                        }
                        else {
                            value = "";
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.Objects) {
                        let parts = fitem.celldata.split(",");
                        if (fitem.linkedids && fitem.linkedids.length > 0) {
                            let obids = [];
                            const pmap = new Map();
                            (_c = fitem.objsdec) === null || _c === void 0 ? void 0 : _c.forEach((ob) => pmap.set("objs-" + ob.id, ob));
                            const smap = new Map();
                            (_d = fitem.schsdec) === null || _d === void 0 ? void 0 : _d.forEach((sj) => smap.set(sj.id, sj));
                            multitag = true;
                            for (const l of fitem.linkedids) {
                                if (l.startsWith("objs-")) {
                                    const obj = pmap.get(l);
                                    if (obj) {
                                        const tds = obj.type === ProjectObjectType.Document ? obj.thumbdetail : undefined;
                                        obids.push({
                                            id: l,
                                            type: 'document',
                                            obj: obj,
                                            name: obj.name,
                                            thumdet: tds
                                        });
                                    }
                                }
                                else if (l.startsWith("dch-")) {
                                    const parts = l.split("-");
                                    if (parts.length > 2) {
                                        const did = parts[1];
                                        const sid = parts[2];
                                        const dh = this.datasheets.get(did);
                                        const sh = smap.get(sid);
                                        if (dh && sh) {
                                            obids.push({
                                                id: l,
                                                type: 'datasheet',
                                                obj: dh.name + " ! " + sh.name,
                                                name: dh.name + " ! " + sh.name
                                            });
                                        }
                                    }
                                }
                            }
                            value = obids.map(c => { var _a; return (_a = c.name) !== null && _a !== void 0 ? _a : ''; }).join(", ");
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Remote) {
                        const uent = sitem;
                        let remotevals = [];
                        const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                        const vals = this.dependentdata.get(id);
                        multitag = true;
                        if (vals) {
                            // now we have this
                            const bits = fitem.celldata.split(",");
                            if (bits && bits.length > 0) {
                                remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1);
                                if (remotevals.length > 0) {
                                    value = remotevals.map((val) => val.value).join(", ");
                                }
                            }
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.URL) {
                        value = fitem.celldata;
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.FormInput) {
                        const uent = sitem;
                        if (uent.enablesecret) {
                            isSecret = true;
                        }
                    }
                    let cname = entry.name;
                    lditem.push({
                        id: item.id + "----" + entry.id + "----" + row,
                        columnname: cname,
                        value: value,
                        multitag: multitag,
                        isHtml: entry.type === SchemaItemType.Text ? true : false,
                        isObject: entry.type === SchemaItemType.Objects ? true : false,
                        isSecret: isSecret
                    });
                }
            }
            displayfields.set(i + "", lditem);
        }
        return displayfields;
    }
    // if no groupby then we can just really build anything
    buildCardView(fieldid, groupby) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!this.activeschema) {
            return [];
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return [];
        }
        const users = this.activeusers;
        const sitemmap = new Map();
        const dname = new Map();
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => {
                sitemmap.set(item.id, item);
            });
        }
        if (this.showdervivedschemafields && achema.childrenschema && achema.childrenschema.length > 0) {
            for (const sh of achema.childrenschema) {
                sh.items.forEach((item) => {
                    sitemmap.set(item.id, item);
                    dname.set(item.id, sh.name);
                });
            }
        }
        this.activebuilingid = Math.random();
        const activestatusfields = new Map();
        const activegroupfields = new Map();
        const fields = sitemmap.get(this.activecardsttaus);
        if (fields) {
            if (fields.type === SchemaItemType.Choice) {
                fields.items.forEach((it) => activestatusfields.set(it.id, it.name));
            }
            else if (fields.type === SchemaItemType.UserChoice) {
                users.forEach((us) => activestatusfields.set(us.id, us.name));
            }
        }
        if (this.activecardgroupby) {
            const grous = sitemmap.get(this.activecardgroupby);
            if (grous) {
                if (grous.type === SchemaItemType.Choice) {
                    grous.items.forEach((it) => activestatusfields.set(it.id, it.name));
                }
                else if (grous.type === SchemaItemType.UserChoice) {
                    users.forEach((us) => activestatusfields.set(us.id, us.name));
                }
            }
        }
        const buildid = this.activebuilingid;
        const cards = [];
        let index = 0;
        for (const [k, item] of this.rowsMap) {
            // this should never happen but lets keep it for now
            // if we do closure in future
            if (this.activebuilingid !== buildid) {
                return;
            }
            let use = true;
            const itemcard = new CardItem();
            itemcard.cardindex = index++;
            itemcard.cradid = item.rowid;
            let isSecret = false;
            if (this.hiddenrows.has(item.rowid))
                continue;
            const emap = new Map();
            for (const en of item.entry) {
                if (!en.decrypted) {
                    this.decryptCell(en);
                }
                let id = en.cellid;
                if (en.cellid.indexOf("----") !== -1) {
                    id = en.cellid.split("----")[0];
                }
                if (!emap.has(id)) {
                    emap.set(id, []);
                }
                (_a = emap.get(id)) === null || _a === void 0 ? void 0 : _a.push(en);
            }
            for (const [k, sm] of sitemmap) {
                const ens = emap.get(sm.id);
                if (ens === undefined) {
                    continue;
                }
                const fitem = ens[0];
                let multitag = false;
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (fitem.cellid === fieldid) {
                    // okay good
                    if (!fitem.celldata) {
                        use = false;
                        break;
                    }
                    itemcard.setStatus(fitem.celldata);
                }
                else if (groupby && groupby !== fieldid && fitem.cellid === groupby) {
                    itemcard.setGroupid(fitem.celldata);
                }
                let lditems = null;
                const sitem = sm;
                if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                    const sitem = sitemmap.get(fitem.cellid);
                    value = (_c = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_b = sitem.excludedate) !== null && _b !== void 0 ? _b : false)) !== null && _c !== void 0 ? _c : '';
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                    let parts = fitem.celldata.split(",");
                    if (parts.length > 0) {
                        if (!sitem.multiselect) {
                            parts = [parts[0]];
                        }
                        const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                        if (items.length > 0) {
                            value = items.map((it) => it.name).join(", ");
                            multitag = sitem.multiselect;
                        }
                        else {
                            value = "";
                        }
                    }
                    else {
                        value = "";
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                    value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                    let parts = fitem.celldata.split(",");
                    if (parts.length > 0) {
                        if (!sitem.multiselect) {
                            parts = [parts[0]];
                        }
                        const items = users.filter((it) => parts.indexOf(it.id) !== -1);
                        if (items.length > 0) {
                            value = items.map((it) => it.name).join(", ");
                            multitag = sitem.multiselect;
                        }
                        else {
                            value = "";
                        }
                    }
                    else {
                        value = "";
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.Objects) {
                    let parts = fitem.celldata.split(",");
                    if (fitem.linkedids && fitem.linkedids.length > 0) {
                        let obids = [];
                        const pmap = new Map();
                        (_d = fitem.objsdec) === null || _d === void 0 ? void 0 : _d.forEach((ob) => pmap.set("objs-" + ob.id, ob));
                        const smap = new Map();
                        (_e = fitem.schsdec) === null || _e === void 0 ? void 0 : _e.forEach((sj) => smap.set(sj.id, sj));
                        multitag = true;
                        for (const l of fitem.linkedids) {
                            if (l.startsWith("objs-")) {
                                const obj = pmap.get(l);
                                if (obj) {
                                    const tds = obj.type === ProjectObjectType.Document ? obj.thumbdetail : undefined;
                                    obids.push({
                                        id: l,
                                        type: 'document',
                                        obj: obj,
                                        name: obj.name,
                                        thumdet: tds
                                    });
                                }
                            }
                            else if (l.startsWith("dch-")) {
                                const parts = l.split("-");
                                if (parts.length > 2) {
                                    const did = parts[1];
                                    const sid = parts[2];
                                    const dh = this.datasheets.get(did);
                                    const sh = smap.get(sid);
                                    if (dh && sh) {
                                        obids.push({
                                            id: l,
                                            type: 'datasheet',
                                            obj: dh.name + " ! " + sh.name,
                                            name: dh.name + " ! " + sh.name
                                        });
                                    }
                                }
                            }
                        }
                        value = obids.map(c => { var _a; return (_a = c.name) !== null && _a !== void 0 ? _a : ''; }).join(", ");
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Remote) {
                    const uent = sitem;
                    let remotevals = [];
                    const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                    const vals = this.dependentdata.get(id);
                    multitag = true;
                    if (vals) {
                        // now we have this
                        const bits = fitem.celldata.split(",");
                        if (bits && bits.length > 0) {
                            remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1);
                            if (remotevals.length > 0) {
                                value = remotevals.map((val) => val.value).join(", ");
                            }
                        }
                    }
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.URL) {
                    value = fitem.celldata;
                }
                else if (sitem.type === SchemaItemType.List) {
                    lditems = this.buildListItemForCard(ens, sm);
                }
                else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.FormInput) {
                    const uent = sitem;
                    if (uent.enablesecret) {
                        isSecret = true;
                    }
                }
                let cname = (_f = sm.name) !== null && _f !== void 0 ? _f : '';
                const shname = dname.get(fitem.cellid);
                if (shname) {
                    cname += " (" + shname + ")";
                }
                let displayItem = {
                    id: item.rowid + fitem.cellid,
                    value: value,
                    alignment: ((_g = sitemmap.get(fitem.cellid)) === null || _g === void 0 ? void 0 : _g.type) === SchemaItemType.Number ? AlignMent.Right : (_h = AlignMent.Left) !== null && _h !== void 0 ? _h : AlignMent.Left,
                    sortindex: (_j = sitem.orderindex) !== null && _j !== void 0 ? _j : -1,
                    columnname: cname,
                    multitag: multitag,
                    isHtml: ((_k = sitemmap.get(fitem.cellid)) === null || _k === void 0 ? void 0 : _k.type) === SchemaItemType.Text ? true : false,
                    isColor: ((_l = sitemmap.get(fitem.cellid)) === null || _l === void 0 ? void 0 : _l.type) === SchemaItemType.Color ? true : false,
                    isObject: ((_m = sitemmap.get(fitem.cellid)) === null || _m === void 0 ? void 0 : _m.type) === SchemaItemType.Objects ? true : false,
                    isURL: ((_o = sitemmap.get(fitem.cellid)) === null || _o === void 0 ? void 0 : _o.type) === SchemaItemType.URL ? true : false,
                    isList: sm.type === SchemaItemType.List ? true : false,
                    isSecret: isSecret
                };
                if (lditems !== null) {
                    displayItem['listItem'] = lditems;
                }
                itemcard.addDisplayField(fitem.cellid, displayItem);
            }
            if (use) {
                cards.push(itemcard);
            }
        }
        return cards;
    }
    setShowActiveView(show) {
        this.showactiveviewmenu = show;
    }
    setShowWorksheetAttach(show) {
        this.showworksheetattach = show;
    }
    setShowWebView(show) {
        this.showwebview = show;
        this.setStartActiveNewView(false);
    }
    setBuildingView(building) {
        this.buildingview = building;
    }
    setActiveView(view) {
        this.activeview = view;
        this.setActiveRowId("");
        this.unselectAllRow();
    }
    updateSchema(sch) {
        this.schemas.set(sch.id, sch);
        const msh = this.anas.get(sch.id);
        if (msh) {
            msh.schemaopen = sch;
        }
        if (sch.apicode) {
            this.schemaapimap.set(sch.apicode, sch);
        }
        if (sch.templateid) {
            this.schematemplatemap.set(sch.templateid, sch);
        }
    }
    addSchema(sch) {
        this.schemas.set(sch.id, sch);
        if (sch.apicode) {
            this.schemaapimap.set(sch.apicode, sch);
        }
        if (sch.templateid) {
            this.schematemplatemap.set(sch.templateid, sch);
        }
        const dh = this.datasheets.get(sch.datasheetid);
        if (dh) {
            const an = {
                schemaopen: sch,
                dhopen: dh,
                totalrows: -1
            };
            this.addAns(an);
        }
        console.log(sch);
    }
    removeSchema(sch) {
        this.schemas.delete(sch);
        if (this.activeschema === sch) {
            const sha = Array.from(this.schemas.values());
            if (sha.length > 0) {
                this.setActiveSchema(sha[0].id);
            }
            else {
                this.setActiveSchema("");
            }
        }
    }
    async addRowInline(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.rowsMap.set(r.rowid, r);
            if (index > 0 && index % 1000 == 0) {
                await timeout(100);
            }
            ;
            index++;
        }
        await timeout(10);
    }
    async addRemoteRows(row, clear = true) {
        if (clear) {
            this.remoteRowsMap.clear();
        }
        for (const r of row) {
            this.remoteRowsMap.set(r.rowid, r);
        }
    }
    async addRows(row, clear = true) {
        if (clear) {
            this.rowsMap.clear();
            this.rowsarrids.splice(0, this.rowsarrids.length);
        }
        let index = 0;
        for (const r of row) {
            this.addRow(r);
            if (index > 0 && index % 1000 === 0) {
                await timeout(10);
            }
            index++;
        }
    }
    arrangeListCells(en) {
        // the way to arrange these will be via the 
        var _a;
        en.sort((en1, en2) => {
            var _a, _b;
            const s1 = (_a = en1.subrowindex) !== null && _a !== void 0 ? _a : -1;
            const s2 = (_b = en2.subrowindex) !== null && _b !== void 0 ? _b : -1;
            if (s1 === -1 && s2 === -1) {
                return 0;
            }
            if (s1 === -1) {
                return 1;
            }
            if (s2 === -1) {
                return -1;
            }
            const parts1 = s1.split("----");
            const parts2 = s2.split("----");
            if (parts1[0] === parts2[0]) {
                // if(parts1.length < 2 || parts2.length < 2) {
                //     return -1;
                // }
                let p1 = parts1[0];
                let p2 = parts2[0];
                if (parts1.length > 1) {
                    p1 = parts1[1];
                }
                if (parts1.length > 1) {
                    p2 = parts2[1];
                }
                return p1.localeCompare(p2);
            }
            return parseInt(parts1[0]) - parseInt(parts2[0]);
        });
        let trow = [];
        const rows = [];
        for (const e of en) {
            const s1 = (_a = e.subrowindex) !== null && _a !== void 0 ? _a : -1;
            if (s1 !== -1) {
                if (trow.indexOf(s1) === -1) {
                    trow.push(s1);
                }
            }
        }
        return trow;
    }
    createSoftRowForMissing() {
    }
    addRuleEntryToRow(row) {
        var _a;
        const rulebycellid = new Map();
        const sh = this.schemas.get(this.activeschema);
        let addschemasoftrowid = "";
        if (sh && sh.rules) {
            for (const rule of sh.rules) {
                rulebycellid.set(rule.colid, rule);
            }
        }
        const customcols = new Set();
        if (sh) {
            for (const item of sh.items) {
                if (item.type === SchemaItemType.CustomDisplayCol) {
                    customcols.add(item.id);
                }
                else if (item.type === SchemaItemType.List) {
                    const listItem = item;
                    for (const ei of listItem.items) {
                        if (ei.item.type === SchemaItemType.CustomDisplayCol) {
                            customcols.add(listItem.id + "----" + ei.id);
                        }
                    }
                }
                else if (item.type === SchemaItemType.Remote && item.autoadd) {
                    addschemasoftrowid = item.id;
                }
            }
        }
        const rowrules = this.rowRules.get(this.activeschema + "~~~" + row.rowid);
        const rowrmap = new Map();
        if (rowrules) {
            for (const r of rowrules.data) {
                rowrmap.set(r.colid, r);
            }
        }
        for (const [k, v] of rulebycellid) {
            if (!rowrmap.has(k)) {
                rowrmap.set(k, v);
            }
        }
        const emap = new Map();
        for (const en of row.entry) {
            const id = en.cellid.split("----");
            if (!emap.has(id[0])) {
                emap.set(id[0], []);
            }
            let colrule = rulebycellid.get(en.cellid);
            if (colrule)
                colrule.isshrule = true;
            if (rowrmap.size > 0) {
                let cr = rowrmap.get(en.cellid);
                if (cr) {
                    colrule = cr;
                }
            }
            if (en.ruleopen) {
                //if this already had it
                en.decrypted = false;
            }
            en.ruleopen = colrule;
            if (en.ruleopen) {
                // new rule 
                en.decrypted = false;
            }
            (_a = emap.get(id[0])) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        for (const k of customcols) {
            if (k.indexOf("----") !== -1) {
                // lets add entry to this as well now!
                const parts = k.split("----");
                const ens = emap.get(parts[0]);
                if (!ens || (ens === null || ens === void 0 ? void 0 : ens.length) === 0)
                    continue;
                // we have subrows lets add entry for each
                const subrows = this.arrangeListCells(ens);
                const entrymap = new Map();
                // now we have these subrows lets see if we can make sense of this now
                for (const en of ens) {
                    if (!en.subrowindex)
                        continue;
                    entrymap.set(en.cellid + "----" + en.subrowindex, en);
                }
                for (const sr of subrows) {
                    const sid = k + "----" + sr;
                    if (!entrymap.has(sid)) {
                        let en = {
                            celldata: '',
                            cellfindstr: '',
                            cellid: k,
                            schemaid: this.activeschema,
                            rowindex: row.rowindex,
                            rowid: row.rowid,
                            subrowindex: sr,
                            id: LetrwingCrypto.getUUID(),
                            sortstring: Math.random(),
                            decrypted: true
                        };
                        const id = en.cellid.split("----");
                        if (!emap.has(id[0])) {
                            emap.set(id[0], []);
                        }
                        row.entry.push(en);
                    }
                }
            }
            else {
                if (!emap.has(k)) {
                    let en = {
                        celldata: '',
                        cellfindstr: '',
                        cellid: k,
                        schemaid: this.activeschema,
                        rowindex: row.rowindex,
                        rowid: row.rowid,
                        subrowindex: "",
                        id: LetrwingCrypto.getUUID(),
                        sortstring: Math.random(),
                        decrypted: true
                    };
                    const id = en.cellid.split("----");
                    if (!emap.has(id[0])) {
                        emap.set(id[0], []);
                    }
                    row.entry.push(en);
                }
            }
        }
        // now lets go over all cells needing rule
        for (const [k, v] of rowrmap) {
            if (k.indexOf("----") !== -1) {
                // lets add entry to this as well now!
                const parts = k.split("----");
                const ens = emap.get(parts[0]);
                if (!ens || (ens === null || ens === void 0 ? void 0 : ens.length) === 0)
                    continue;
                // we have subrows lets add entry for each
                const subrows = this.arrangeListCells(ens);
                const entrymap = new Map();
                // now we have these subrows lets see if we can make sense of this now
                for (const en of ens) {
                    if (!en.subrowindex)
                        continue;
                    entrymap.set(en.cellid + "----" + en.subrowindex, en);
                }
                for (const sr of subrows) {
                    const sid = k + "----" + sr;
                    if (!entrymap.has(sid)) {
                        let en = {
                            celldata: '',
                            cellfindstr: '',
                            cellid: k,
                            schemaid: this.activeschema,
                            rowindex: row.rowindex,
                            rowid: row.rowid,
                            subrowindex: sr,
                            id: LetrwingCrypto.getUUID(),
                            sortstring: Math.random(),
                            decrypted: false
                        };
                        const id = en.cellid.split("----");
                        if (!emap.has(id[0])) {
                            emap.set(id[0], []);
                        }
                        let colrule = rulebycellid.get(en.cellid);
                        if (colrule) {
                            colrule.isshrule = true;
                        }
                        if (rowrmap.size > 0) {
                            let cr = rowrmap.get(en.cellid);
                            if (cr) {
                                colrule = cr;
                            }
                        }
                        en.ruleopen = colrule;
                        row.entry.push(en);
                    }
                }
            }
            else {
                if (!emap.has(k)) {
                    let en = {
                        celldata: '',
                        cellfindstr: '',
                        cellid: k,
                        schemaid: this.activeschema,
                        rowindex: row.rowindex,
                        rowid: row.rowid,
                        subrowindex: "",
                        id: LetrwingCrypto.getUUID(),
                        sortstring: Math.random(),
                        decrypted: false
                    };
                    const id = en.cellid.split("----");
                    if (!emap.has(id[0])) {
                        emap.set(id[0], []);
                    }
                    let colrule = rulebycellid.get(en.cellid);
                    if (colrule) {
                        colrule.isshrule = true;
                    }
                    if (rowrmap.size > 0) {
                        let cr = rowrmap.get(en.cellid);
                        if (cr) {
                            colrule = cr;
                        }
                    }
                    en.ruleopen = colrule;
                    row.entry.push(en);
                }
            }
        }
    }
    addRuleEntryToRemoteRow(row) {
        var _a;
        const rulebycellid = new Map();
        const sh = this.schemas.get(this.activeschema);
        if (sh && sh.rules) {
            for (const rule of sh.rules) {
                rulebycellid.set(rule.colid, rule);
            }
        }
        const rowrules = this.rowRules.get(this.activeschema + "~~~" + row.rowid);
        const rowrmap = new Map();
        if (rowrules) {
            for (const r of rowrules.data) {
                rowrmap.set(r.colid, r);
            }
        }
        for (const [k, v] of rulebycellid) {
            if (!rowrmap.has(k)) {
                rowrmap.set(k, v);
            }
        }
        const emap = new Map();
        for (const en of row.entry) {
            const id = en.cellid.split("----");
            if (!emap.has(id[0])) {
                emap.set(id[0], []);
            }
            let colrule = rulebycellid.get(en.cellid);
            if (colrule)
                colrule.isshrule = true;
            if (rowrmap.size > 0) {
                let cr = rowrmap.get(en.cellid);
                if (cr) {
                    colrule = cr;
                }
            }
            if (en.ruleopen) {
                //if this already had it
                en.decrypted = false;
            }
            en.ruleopen = colrule;
            if (en.ruleopen) {
                // new rule 
                en.decrypted = false;
            }
            (_a = emap.get(id[0])) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        // now lets go over all cells needing rule
        for (const [k, v] of rowrmap) {
            if (k.indexOf("----") !== -1) {
                // lets add entry to this as well now!
                const parts = k.split("----");
                const ens = emap.get(parts[0]);
                if (!ens || (ens === null || ens === void 0 ? void 0 : ens.length) === 0)
                    continue;
                // we have subrows lets add entry for each
                const subrows = this.arrangeListCells(ens);
                const entrymap = new Map();
                // now we have these subrows lets see if we can make sense of this now
                for (const en of ens) {
                    if (!en.subrowindex)
                        continue;
                    entrymap.set(en.cellid + "----" + en.subrowindex, en);
                }
                for (const sr of subrows) {
                    const sid = k + "----" + sr;
                    if (!entrymap.has(sid)) {
                        let en = {
                            celldata: '',
                            cellfindstr: '',
                            cellid: k,
                            schemaid: this.activeschema,
                            rowindex: row.rowindex,
                            rowid: row.rowid,
                            subrowindex: sr,
                            id: LetrwingCrypto.getUUID(),
                            sortstring: Math.random(),
                            decrypted: false
                        };
                        const id = en.cellid.split("----");
                        if (!emap.has(id[0])) {
                            emap.set(id[0], []);
                        }
                        let colrule = rulebycellid.get(en.cellid);
                        if (colrule)
                            colrule.isshrule = true;
                        if (rowrmap.size > 0) {
                            let cr = rowrmap.get(en.cellid);
                            if (cr) {
                                colrule = cr;
                            }
                        }
                        en.ruleopen = colrule;
                        row.entry.push(en);
                    }
                }
            }
            else {
                if (!emap.has(k)) {
                    let en = {
                        celldata: '',
                        cellfindstr: '',
                        cellid: k,
                        schemaid: this.activeschema,
                        rowindex: row.rowindex,
                        rowid: row.rowid,
                        subrowindex: "",
                        id: LetrwingCrypto.getUUID(),
                        sortstring: Math.random(),
                        decrypted: false
                    };
                    const id = en.cellid.split("----");
                    if (!emap.has(id[0])) {
                        emap.set(id[0], []);
                    }
                    let colrule = rulebycellid.get(en.cellid);
                    if (colrule)
                        colrule.isshrule = true;
                    if (rowrmap.size > 0) {
                        let cr = rowrmap.get(en.cellid);
                        if (cr) {
                            colrule = cr;
                        }
                    }
                    en.ruleopen = colrule;
                    row.entry.push(en);
                }
            }
        }
    }
    async addRuleEntryToRows() {
        let i = 0;
        for (const row of this.rowsMap.values()) {
            this.addRuleEntryToRow(row);
            if (i > 0 && i % 1000 === 0)
                await timeout(50);
            i++;
        }
    }
    addRow(row) {
        this.addRuleEntryToRow(row);
        this.rowsMap.set(row.rowid, row);
        if (this.selectallrows) {
            this.setSelectedRow(row);
        }
        if (this.activeview === 'card') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildCardItem(row, achema, this.activecardsttaus, this.activecardgroupby);
                if (item) {
                    item.cardindex = this.rowsMap.size - 1;
                    this.kanbanstatus.addCard(item);
                }
            }
            // lets build this card now!
        }
        else if (this.activeview === 'calendar') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildCalendarCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                if (item) {
                    const epopr = new Map();
                    epopr.set("rowindex", (this.rowsMap.size - 1) + '');
                    item.extraprop = epopr;
                    this.calendarstate.addElement(item.id, item);
                }
            }
        }
        else if (this.activeview === 'gantt') {
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const item = this.buildGanttCard(row, this.ganttstartid, achema, this.ganttendid, this.descfieldid, this.colorfieldid);
                if (item) {
                    const epopr = new Map();
                    epopr.set("rowindex", (this.rowsMap.size - 1) + '');
                    item.extraprop = epopr;
                    this.timelinestatus.setTimelineCard(item);
                }
            }
        }
        else if (this.activeview === 'chart') {
            if (this.chartstate.size > 0) {
                for (const ct of Array.from(this.chartstate.values())) {
                    this.buildChart(ct.id, ct.xid, ct.yid, ct.ctype, ct.colorfield);
                }
            }
        }
    }
    addNewRow(nrow) {
        this.newrowsmap.push(nrow);
    }
    removeRow(index) {
        const rr = this.rowsMap.get(index);
        if (rr) {
            const rindex = this.binary_search_iterative(rr.rowindex);
            if (rindex != null) {
                this.rowsarrids.splice(rindex, 1);
            }
        }
        this.rowsMap.delete(index);
    }
    binary_search_iterative(rowindex) {
        let lo = 0, hi = this.rowsarrids.length - 1, mid = 0;
        while (lo <= hi) {
            mid = Math.floor((lo + hi) / 2);
            if (this.rowsarrids[mid].rowindex > rowindex)
                hi = mid - 1;
            else if (this.rowsarrids[mid].rowindex < rowindex)
                lo = mid + 1;
            else
                return mid;
        }
        return null;
    }
    removeNewRow(index) {
        let nrin = -1;
        for (let i = 0; i < this.newrowsmap.length; i++) {
            const nr = this.newrowsmap[i];
            if (nr.rowindex === index) {
                nrin = i;
                break;
            }
        }
        this.newrowsmap.splice(nrin, 1);
    }
    setStoringForm(storing) {
        this.storingform = storing;
    }
    setCollectingData(col) {
        this.checkingandcollecting = col;
    }
    setLoadingContent(loading) {
        this.loadingcontent = loading;
    }
    setLoadmore(loading) {
        this.loadmore = loading;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    loadMoreRows() {
    }
    async addNextDuplicate() {
        var _a, _b;
        const nextrow = this.drows[this.duplicatingcount];
        const sh = this.schemas.get(this.activeschema);
        // now we can store the form
        if (!sh) {
            return;
        }
        const cellmap = new Map();
        const requiredfields = new Set();
        for (const sh1 of (_b = (_a = sh.parentschema) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) {
            cellmap.set(sh1.id, sh1);
            if (sh1.type === SchemaItemType.List) {
                const litem = sh1;
                if (litem.items && litem.items.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                    }
                    ;
                }
            }
        }
        for (const sh1 of sh.items) {
            cellmap.set(sh1.id, sh1);
            if (sh1.type === SchemaItemType.List) {
                const litem = sh1;
                if (litem.items && litem.items.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                    }
                    ;
                }
            }
        }
        const sentries = [];
        for (const ent of nextrow.entry) {
            if (!ent.decrypted) {
                this.decryptCell(ent);
            }
            const citem = cellmap.get(ent.cellid);
            if (!citem) {
                continue;
            }
            if (citem.type === SchemaItemType.Number) {
                let sortstring = -1;
                if ((ent.celldata + "").indexOf(".") > -1) {
                    sortstring = sh.numberoffset + parseFloat(ent.celldata);
                }
                else {
                    sortstring = sh.numberoffset + parseInt(ent.celldata);
                }
                ent.sortstring = sortstring;
            }
            else if (citem.type === SchemaItemType.Date) {
                if (ent.celldata) {
                    ent.sortstring = sh.dateoffset + parseInt(ent.celldata);
                }
            }
            ent.schemaid = this.activeschema;
            ent.rowid = '';
            ent.rowindex = -1;
            sentries.push(ent);
        }
        const reqid = Math.random() + "";
        const req = {
            letrid: this.activelterid,
            sid: this.activeschema,
            reqid: reqid,
            entries: sentries,
            accesskey: sh.accesskey,
            nonce: sh.nonce,
            duplicaterequest: true,
            schemaitems: Array.from(cellmap.values()),
            assigns: [],
            nvs: []
        };
        this.activereqid = reqid;
        Apphandler.sendMessage("addentry", req);
    }
    async addEntry(appuser) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const sh = this.schemas.get(this.activeschema);
        // now we can store the form
        if (!sh) {
            return;
        }
        this.setStoringForm(true);
        const cellmap = new Map();
        const requiredfields = new Set();
        for (const sh1 of (_b = (_a = sh.parentschema) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []) {
            cellmap.set(sh1.id, sh1);
            if (sh1.type === SchemaItemType.List) {
                const litem = sh1;
                const listitems = (_c = this.newlistitemsmap.get(sh1.id)) !== null && _c !== void 0 ? _c : [];
                if (litem.items && litem.items.length > 0 && listitems.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                        for (const uid of listitems) {
                            cellmap.set(litem.id + "----" + item.id + "----" + uid, item.item);
                        }
                        if (item.item.required && !this.checkSchemaCellHasRule(item.item.id)) {
                            for (const uid of listitems) {
                                cellmap.set(litem.id + "----" + item.id + "----" + uid, item.item);
                                const val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (!val) {
                                    APPEvent.publishApperror(item.item.name + " field of " + sh1.name + " is  a mandatory field.");
                                    this.setStoringForm(false);
                                    return;
                                }
                            }
                        }
                        if (item.item.type === SchemaItemType.URL) {
                            // lets hyst 
                            const listitems = (_d = this.newlistitemsmap.get(sh1.id)) !== null && _d !== void 0 ? _d : [];
                            for (const uid of listitems) {
                                const val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (val === null || val === void 0 ? void 0 : val.celldata) {
                                    try {
                                        const ud = JSON.parse(val.celldata);
                                        if (!ud.url.trim()) {
                                            APPEvent.publishApperror(item.item.name + " field of " + sh1.name + " is missing url.");
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                    catch (ex) {
                                        APPEvent.publishApperror(sh1.name + " is missing url.");
                                        this.setStoringForm(false);
                                        return;
                                    }
                                }
                            }
                        }
                        if (item.item.type === SchemaItemType.Number) {
                            // lets hyst 
                            const listitems = (_e = this.newlistitemsmap.get(sh1.id)) !== null && _e !== void 0 ? _e : [];
                            for (const uid of listitems) {
                                const val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (val === null || val === void 0 ? void 0 : val.celldata) {
                                    try {
                                        const it = item.item;
                                        const num = parseFloat(val.celldata);
                                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + sh1.name);
                                            this.setStoringForm(false);
                                            return;
                                        }
                                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + sh1.name);
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                    catch (ex) {
                                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                        this.setStoringForm(false);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    ;
                }
            }
            if (sh1.required && !this.checkSchemaCellHasRule(sh1.id)) {
                const val = this.formentry.get(sh1.id);
                // no empty text
                if (val === undefined) {
                    APPEvent.publishApperror(sh1.name + " is  a mandatory field.");
                    this.setStoringForm(false);
                    return;
                }
            }
            if (sh1.type === SchemaItemType.URL) {
                // lets hyst 
                const val = this.formentry.get(sh1.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const ud = JSON.parse(val.celldata);
                        if (!ud.url.trim()) {
                            APPEvent.publishApperror(sh1.name + " is missing url.");
                            this.setStoringForm(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror(sh1.name + " is missing url.");
                        this.setStoringForm(false);
                        return;
                    }
                }
            }
            if (sh1.type === SchemaItemType.Number) {
                const val = this.formentry.get(sh1.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const it = sh1;
                        const num = parseFloat(val.celldata);
                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setStoringForm(false);
                            return;
                        }
                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setStoringForm(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                        this.setStoringForm(false);
                        return;
                    }
                }
            }
        }
        for (const sh1 of sh.items) {
            cellmap.set(sh1.id, sh1);
            if (sh1.type === SchemaItemType.List) {
                const litem = sh1;
                const listitems = (_f = this.newlistitemsmap.get(sh1.id)) !== null && _f !== void 0 ? _f : [];
                if (litem.items && litem.items.length > 0 && listitems.length > 0) {
                    for (const item of litem.items) {
                        cellmap.set(litem.id + "----" + item.id, item.item);
                        for (const uid of listitems) {
                            cellmap.set(litem.id + "----" + item.id + "----" + uid, item.item);
                            let val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                            if (!val && this.viewdefaultvalue.has(litem.id + "----" + item.id)) {
                                this.formentry.set(litem.id + "----" + item.id + "----" + uid, {
                                    celldata: (_g = this.viewdefaultvalue.get(litem.id + "----" + item.id)) !== null && _g !== void 0 ? _g : '',
                                    cellfindstr: '',
                                    rowid: '',
                                    rowindex: -1,
                                    cellid: litem.id + "----" + item.id,
                                    subrowindex: uid,
                                    schemaid: sh.id,
                                    id: '',
                                    sortstring: -1
                                });
                                val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                            }
                        }
                        if (item.item.required && !this.checkSchemaCellHasRule(item.item.id)) {
                            for (const uid of listitems) {
                                cellmap.set(litem.id + "----" + item.id + "----" + uid, item.item);
                                let val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (!val && this.viewdefaultvalue.has(litem.id + "----" + item.id)) {
                                    this.formentry.set(litem.id + "----" + item.id + "----" + uid, {
                                        celldata: (_h = this.viewdefaultvalue.get(litem.id + "----" + item.id)) !== null && _h !== void 0 ? _h : '',
                                        cellfindstr: '',
                                        rowid: '',
                                        rowindex: -1,
                                        cellid: litem.id + "----" + item.id,
                                        subrowindex: uid,
                                        schemaid: sh.id,
                                        id: '',
                                        sortstring: -1
                                    });
                                    val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                }
                                if (!val) {
                                    APPEvent.publishApperror(item.item.name + " field of " + sh1.name + " is  a mandatory field.");
                                    this.setStoringForm(false);
                                    return;
                                }
                            }
                        }
                        else {
                        }
                        if (item.item.type === SchemaItemType.URL) {
                            // lets hyst 
                            const listitems = (_j = this.newlistitemsmap.get(sh1.id)) !== null && _j !== void 0 ? _j : [];
                            for (const uid of listitems) {
                                const val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (val === null || val === void 0 ? void 0 : val.celldata) {
                                    try {
                                        const ud = JSON.parse(val.celldata);
                                        if (!ud.url.trim()) {
                                            APPEvent.publishApperror(item.item.name + " field of " + sh1.name + " is missing url.");
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                    catch (ex) {
                                        APPEvent.publishApperror(sh1.name + " is missing url.");
                                        this.setStoringForm(false);
                                        return;
                                    }
                                }
                            }
                        }
                        if (item.item.type === SchemaItemType.Number) {
                            // lets hyst 
                            const listitems = (_k = this.newlistitemsmap.get(sh1.id)) !== null && _k !== void 0 ? _k : [];
                            for (const uid of listitems) {
                                const val = this.formentry.get(litem.id + "----" + item.id + "----" + uid);
                                if (val === null || val === void 0 ? void 0 : val.celldata) {
                                    try {
                                        const it = item.item;
                                        const num = parseFloat(val.celldata);
                                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + sh1.name);
                                            this.setStoringForm(false);
                                            return;
                                        }
                                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                                ' and ' + it.maxvalue + ' for field ' + it.name + ' of ' + sh1.name);
                                            this.setStoringForm(false);
                                            return;
                                        }
                                    }
                                    catch (ex) {
                                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                                        this.setStoringForm(false);
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    ;
                }
            }
            else {
                let val = this.formentry.get(sh1.id);
                if (!val && this.viewdefaultvalue.has(sh1.id)) {
                    this.formentry.set(sh1.id, {
                        celldata: (_l = this.viewdefaultvalue.get(sh1.id)) !== null && _l !== void 0 ? _l : '',
                        cellfindstr: '',
                        rowid: '',
                        rowindex: -1,
                        cellid: sh1.id,
                        subrowindex: '',
                        schemaid: sh.id,
                        id: '',
                        sortstring: -1
                    });
                    val = this.formentry.get(sh1.id);
                }
            }
            if (sh1.type === SchemaItemType.Number) {
                let val = this.formentry.get(sh1.id);
                if (val === null || val === void 0 ? void 0 : val.celldata) {
                    try {
                        const it = sh1;
                        const num = parseFloat(val.celldata);
                        if (num && it.minvalue !== undefined && it.minvalue !== null && num < it.minvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setStoringForm(false);
                            return;
                        }
                        else if (num && it.maxvalue !== undefined && it.maxvalue !== null && num > it.maxvalue) {
                            APPEvent.publishApperror("Please enter a number between " + it.minvalue +
                                ' and ' + it.maxvalue + ' for ' + it.name);
                            this.setStoringForm(false);
                            return;
                        }
                    }
                    catch (ex) {
                        APPEvent.publishApperror((val === null || val === void 0 ? void 0 : val.celldata) + " is not a number.");
                        this.setStoringForm(false);
                        return;
                    }
                }
            }
            else {
            }
            if (sh1.required && !this.checkSchemaCellHasRule(sh1.id)) {
                if (!this.formentry.has(sh1.id)) {
                    APPEvent.publishApperror(sh1.name + " is  a mandatory field.");
                    this.setStoringForm(false);
                    return;
                }
            }
        }
        const sentries = [];
        for (const [k, val] of this.formentry) {
            const citem = cellmap.get(k);
            val.decrypted = true;
            if (citem) {
                if (citem.type === SchemaItemType.Number) {
                    let sortstring = -1;
                    if (val.celldata.indexOf(".") > -1) {
                        sortstring = sh.numberoffset + parseFloat(val.celldata);
                    }
                    else {
                        sortstring = sh.numberoffset + parseInt(val.celldata);
                    }
                    val.sortstring = sortstring;
                }
                else if (citem.type === SchemaItemType.Date) {
                    if (val.celldata) {
                        val.sortstring = sh.dateoffset + parseInt(val.celldata);
                    }
                }
                val.schemaid = this.activeschema;
                if (k.indexOf("----") != -1) {
                    const parts = k.split("----");
                    const listitems = (_m = this.newlistitemsmap.get(parts[0])) !== null && _m !== void 0 ? _m : [];
                    const index = listitems.indexOf(parts[2]);
                    val.subrowindex = index + "----" + parts[2];
                }
                sentries.push(val);
            }
        }
        if (sentries.length > 0) {
            // lets run some rules here too!!
            const newentr = this.buildNewRowFromDataRules(sentries);
            // lets just check if any view need auto assignment?
            let customPackets = [];
            if (sh.custompostaction) {
                const actionfn = new Function("config", sh.custompostaction);
                const actionconfig = {
                    getschemarows: (sid) => {
                        let apish = this.schemaapimap.get(sid);
                        let tid = this.schematemplatemap.get(sid);
                        if (apish) {
                            sid = apish.id;
                        }
                        if (tid) {
                            sid = tid.id;
                        }
                        return this.getDependSchemaRows(sid);
                    },
                    decryptCell: (entry, sid) => {
                        if (!entry.decrypted) {
                            this.decryptEntry(entry, sid);
                        }
                        return entry;
                    },
                    getactiveuserid: () => this.userid,
                    stripHTML: (msg) => LWStripHTML(msg),
                    saveentrytoworksheet: async (entry, worksheetid, subrowind, cb) => {
                        cb(entry, []);
                    },
                };
                const bui = actionfn(actionconfig);
                if (bui.notificationpackets !== undefined) {
                    customPackets = await new Promise((ac, rej) => {
                        bui.notificationpackets(sentries, true, [], (msg) => {
                            ac(msg);
                        });
                    });
                }
            }
            const reqid = Math.random() + "";
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                reqid: reqid,
                entries: newentr,
                accesskey: sh.accesskey,
                nonce: sh.nonce,
                duplicaterequest: false,
                schemaitems: Array.from(cellmap.values()),
                assigns: this.checkRowNeedsAutoAssignment(sentries, appuser),
                nvs: this.checkWithViewNeedNotification(sentries),
                custompackets: customPackets
            };
            this.activereqid = reqid;
            Apphandler.sendMessage("addentry", req);
        }
        else {
            APPEvent.publishApperror("Please add atleast one entry.");
            this.setStoringForm(false);
        }
    }
    convertViewFilterToAcFilter(sv) {
        var _a, _b, _c, _d;
        const items = new Map();
        const achema = this.schemas.get(this.activeschema);
        if (achema) {
            for (const it of achema.items) {
                if (it.type == SchemaItemType.List) {
                    const lit = it;
                    if (lit.items) {
                        for (const li of lit.items) {
                            items.set(it.id + "----" + li.item.id, li.item);
                        }
                    }
                }
                else {
                    items.set(it.id, it);
                }
            }
        }
        const ret = [];
        if (sv.filters && sv.filters.length > 0) {
            for (const fl of sv.filters) {
                const fd = fl.data;
                const csi = items.get(fl.columnid);
                if (csi) {
                    const v1 = (_a = fd.value) !== null && _a !== void 0 ? _a : '';
                    const v2 = (_b = fd.value2) !== null && _b !== void 0 ? _b : '';
                    let v1f = -1;
                    let v2f = -1;
                    if (csi.type === SchemaItemType.Date) {
                        if (v1 !== '') {
                            try {
                                v1f = parseInt(v1);
                            }
                            catch (ex) { }
                        }
                        if (v2 !== '') {
                            try {
                                v2f = parseInt(v2);
                            }
                            catch (ex) { }
                        }
                    }
                    else if (csi.type === SchemaItemType.Number) {
                        if (v1 !== '') {
                            try {
                                v1f = parseFloat(v1);
                            }
                            catch (ex) { }
                        }
                        if (v2 !== '') {
                            try {
                                v2f = parseFloat(v2);
                            }
                            catch (ex) { }
                        }
                    }
                    const sm = {
                        id: fl.columnid,
                        value: (_c = fd === null || fd === void 0 ? void 0 : fd.value) !== null && _c !== void 0 ? _c : '',
                        fielditem: csi,
                        value2: (_d = fd === null || fd === void 0 ? void 0 : fd.value2) !== null && _d !== void 0 ? _d : '',
                        v2float: v1f,
                        vfloat: v2f,
                        optype: fd.op,
                        numbercompare: (csi.type === SchemaItemType.Date || csi.type === SchemaItemType.Number)
                    };
                    ret.push(sm);
                }
            }
        }
        return ret;
    }
    checkWithViewNeedNotification(entries) {
        // we need first check if any view matches with this entry if they do then we just need to notify them!!
        const nvs = [];
        for (const v of this.schemaviews.values()) {
            if (this.canShowRow(entries, this.convertViewFilterToAcFilter(v))) {
                // also ask the js code
                if (v.customfilerjs) {
                    const f = new Function("config", v.customfilerjs);
                    let config = {
                        getschemarows: (sid) => {
                            let apish = this.schemaapimap.get(sid);
                            let tid = this.schematemplatemap.get(sid);
                            if (apish) {
                                sid = apish.id;
                            }
                            else if (tid) {
                                sid = tid.id;
                            }
                            return this.getDependSchemaRows(sid);
                        },
                        decryptcell: (entry, sid, pr) => {
                            if (!entry.decrypted) {
                                this.decryptEntry(entry, sid, pr);
                            }
                            return entry;
                        }
                    };
                    const builder = f(config);
                    if (!builder || !builder.canShowRow(entries)) {
                        continue;
                    }
                }
                nvs.push(v.id);
            }
        }
        return nvs;
    }
    checkRowNeedsAutoAssigmentForView(entries, appuser, views, checkdecrypt = false) {
        var _a;
        const apmap = new Map();
        for (const ap of appuser) {
            apmap.set("appcontact-" + ap.id, ap);
        }
        const ret = [];
        const enmap = new Map();
        for (const en of entries) {
            if (!enmap.has(en.cellid)) {
                enmap.set(en.cellid, []);
            }
            (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        for (const view of views) {
            if (!this.canShowRow(entries, this.convertViewFilterToAcFilter(view)))
                continue;
            if (view.customfilerjs) {
                const f = new Function("config", view.customfilerjs);
                let config = {
                    getschemarows: (sid) => {
                        let apish = this.schemaapimap.get(sid);
                        let tid = this.schematemplatemap.get(sid);
                        if (apish) {
                            sid = apish.id;
                        }
                        else if (tid) {
                            sid = tid.id;
                        }
                        return this.getDependSchemaRows(sid);
                    },
                    decryptcell: (entry, sid, pr) => {
                        if (!entry.decrypted) {
                            this.decryptEntry(entry, sid, pr);
                        }
                        return entry;
                    }
                };
                const buil = f(config);
                if (!buil || !buil.canShowRow(entries))
                    continue;
            }
            if (view.appformbox) {
                for (const abox of view.appformbox) {
                    if (abox.id.startsWith("schem-")) {
                        const col = abox.autocolumnid;
                        if (col) {
                            const ens = enmap.get(col);
                            if (ens) {
                                for (const en of ens) {
                                    if (checkdecrypt && !en.decrypted) {
                                        this.decryptCell(en);
                                    }
                                    const parts = en.celldata.split(",");
                                    const userboxes = [];
                                    for (const pp of parts) {
                                        const appuser = apmap.get(pp);
                                        if (appuser) {
                                            userboxes.push({
                                                id: appuser.id,
                                                databox: LetrwingCrypto.box(view.code, appuser.publickey),
                                                mypermissions: abox.mypermissions,
                                                readonlyfields: abox.readonlyfields,
                                            });
                                        }
                                        ret.push({
                                            rowid: en.rowid,
                                            columid: en.cellid,
                                            schemaid: this.activeschema,
                                            userboxes: userboxes,
                                            userids: parts,
                                            viewid: view.id,
                                            id: ''
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return ret;
    }
    checkRowNeedsAutoAssignment(entries, appuser) {
        return this.checkRowNeedsAutoAssigmentForView(entries, appuser, Array.from(this.schemaviews.values()));
    }
    resetNotes() {
        this.notesbyid.clear();
        this.showinoutlinks.clear();
        if (this.notestimeout) {
            clearTimeout(this.notestimeout);
        }
        this.setLoadingNotes(false);
        this.setAppliedAclString("");
        this.selectAccessids([ALLViewer]);
        this.setShowComments(false);
        this.commentstate.clear();
    }
    setShowComments(dn) {
        this.showcomments = dn;
    }
    hideColumn(id) {
        this.hiddencolumns.add(id);
        if (id.indexOf("----") != -1) {
            const parent = id.split("----")[0];
            const achema = this.schemas.get(this.activeschema);
            if (achema) {
                const its = achema.items.filter((it) => it.id === parent);
                if (its.length > 0) {
                    const aitem = its[0].items;
                    let hasallhid = true;
                    for (const ai of aitem) {
                        if (!this.hiddencolumns.has(parent + "----" + ai.item.id)) {
                            hasallhid = false;
                            break;
                        }
                    }
                    if (hasallhid) {
                        this.hiddencolumns.add(parent);
                    }
                }
            }
        }
    }
    setDuplicatingRows(dupl) {
        this.duplicating = dupl;
    }
    setDuplicatedCount(ct) {
        this.duplicatingcount = ct;
    }
    duplicateRows_old() {
        if (this.selectedrows.size > 0) {
            this.setDuplicatingRows(true);
            this.setDuplicatedCount(0);
            // lets build the rows entries now!!
            const srows = Array.from(this.selectedrows.values());
            if (srows.length === 0) {
                this.setDuplicatingRows(false);
                return;
            }
            this.totalduplicatecount = srows.length;
            // this.addNextDuplicate();
        }
    }
    duplicateRows() {
        if (this.selectedrows.size > 0) {
            this.setDuplicatingRows(true);
            this.setDuplicatedCount(0);
            const req = {
                letrid: this.activelterid,
                sid: this.activeschema,
                rids: [],
                rows: []
            };
            if (this.selectallrows && this.hiddenrows.size === 0) {
                req['duplicateall'] = true;
            }
            else {
                const rids = Array.from(this.selectedrows.keys()).filter((id) => !this.hiddenrows.has(id));
                req['rids'] = rids;
                req['duplicateall'] = false;
            }
            Apphandler.sendMessage("duplicaterows", req);
        }
    }
    showColumn(id) {
        this.hiddencolumns.delete(id);
        if (id.indexOf("----") != -1) {
            this.hiddencolumns.delete(id.split("----")[0]);
        }
    }
    setShowColumns(cols) {
        this.showcolumnview = cols;
    }
    hideRow(id) {
        this.hiddenrows.add(id);
    }
    unhideRow(id) {
        this.hiddenrows.delete(id);
    }
    async buildRowsArray() {
        const arr = [];
        let i = 0;
        for (const row of this.rowsMap) {
            arr.push(row[1]);
            if (i > 0 && i % 5000 == 0)
                await timeout(50);
            i++;
        }
        this.rowsarrids = arr;
        this.rowsarrids.sort((r1, r2) => r1.rowindex - r2.rowindex);
        // lets find the rowindex as well!
        if (this.activerowid) {
            for (let i = 0; i < this.rowsarrids.length; i++) {
                const r = this.rowsarrids[i];
                if (r.rowid === this.activerowid) {
                    this.setInitialTopMostItemIndex(i);
                    break;
                }
                if (i > 0 && i % 5000 == 0)
                    await timeout(50);
            }
        }
        await timeout(50);
    }
    setInitialTopMostItemIndex(index) {
        this.initialTopMostItemIndex = index;
    }
    getRows() {
        return this.rowsarrids;
    }
    getAllValuesForRows(id) {
        let rows = this.getRows();
        let vl = new Set();
        for (const r of rows) {
            for (const en of r.entry) {
                if (en.cellid === id) {
                    if (!en.decrypted) {
                        this.decryptCell(en);
                    }
                    vl.add(en.celldata.trim());
                }
            }
        }
        return Array.from(vl);
    }
    getSelectedRow() {
    }
    clearMetadataSchema() {
        this.activeschemametaids.clear();
    }
    addMetadataSchema(id) {
        this.activeschemametaids.add(id);
    }
    deleteMetadataSchema(id) {
        this.activeschemametaids.delete(id);
    }
    addRemoteRowRule(rule) {
        this.remoteRowRules.set(rule.id, rule);
    }
    addRowRule(rule) {
        if (rule.data && rule.data.length > 0) {
            this.rowRules.set(rule.id, rule);
        }
        if (rule.datarules && rule.datarules.length > 0) {
            this.rowDataRules.set(rule.id, rule);
        }
    }
    cleaRowRule() {
        this.rowRules.clear();
    }
    setLoadedRows(count) {
        this.loadedentry = count;
    }
    setActiveRemoteSchema(id) {
        this.activeremoteschema = id;
    }
    setRerunning(run) {
        this.rerunning = run;
    }
    rowSorterFun(r1, r2) {
        const std = this.rowsorter;
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return -1;
        }
        if (std === 'orig') {
            return r1.rowindex - r2.rowindex;
        }
        const mits = achema.items.filter((it) => it.id === std);
        if (!mits || mits.length !== 1)
            return -1;
        const myitem = mits[0];
        let s1 = undefined;
        for (const en of r1.entry) {
            if (en.cellid === std) {
                if (!en.decrypted) {
                    this.decryptCellInnline(en);
                }
                s1 = en;
                break;
            }
        }
        let s2 = undefined;
        for (const en of r2.entry) {
            if (en.cellid === std) {
                if (!en.decrypted) {
                    this.decryptCellInnline(en);
                }
                s2 = en;
                break;
            }
        }
        if (s1 && s2) {
            if (myitem.type === SchemaItemType.Number || myitem.type === SchemaItemType.Date) {
                const sf1 = parseFloat(s1.celldata);
                const sf2 = parseFloat(s2.celldata);
                if (isNaN(sf2))
                    return -1;
                if (isNaN(sf1))
                    return 1;
                return sf1 - sf2;
            }
            else if (myitem.type === SchemaItemType.Remote) {
                const sf1 = s1.celldata;
                const sf2 = s2.celldata;
                const sparts = sf1.split(",");
                const s2parts = sf2.split(",");
                if (s2parts.length === 0)
                    return -1;
                if (sparts.length === 0)
                    return 1;
                const uent = myitem;
                const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                const vals = this.dependentdata.get(id);
                if (vals) {
                    // now we have this
                    const bits = sf1.split(",");
                    let val1 = "";
                    let val2 = "";
                    if (bits && bits.length > 0) {
                        let remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1);
                        if (remotevals.length > 0)
                            val1 = remotevals[0].value;
                    }
                    const sbits = sf2.split(",");
                    if (sbits && sbits.length > 0) {
                        let remotevals = vals.filter((val) => sbits.indexOf(val.id) !== -1);
                        if (remotevals.length > 0)
                            val2 = remotevals[0].value;
                    }
                    if (!val2)
                        return -1;
                    if (!val1)
                        return 1;
                    return expandNumbers10(LWStripHTML(val1).trim().toLowerCase())
                        .localeCompare(expandNumbers10(LWStripHTML(val2)).trim().toLowerCase());
                }
                else {
                    return -1;
                }
            }
            return expandNumbers10(LWStripHTML(s1.celldata).trim().toLowerCase()).localeCompare(expandNumbers10(LWStripHTML(s2.celldata).trim().toLowerCase()));
            // now lets compare them one by one!!
            // multi choice what shal we do??
            // maybe first first value?
        }
        else {
            console.log("we here misisng some data?");
        }
        if (!s1) {
            return 1;
        }
        return -1;
    }
    checkAndAddRowEntriesToAlert(row) {
        for (const en of row.entry) {
        }
    }
    buildActiveSchemaCustomChecks() {
    }
    saveSchemaState(id, data, cb) {
        this.savingstate.set(id, cb);
        const req = {
            schemaid: this.activeschema,
            letrid: this.activelterid,
            id: id,
            data: data
        };
        Apphandler.sendMessage("storeschemastatedata", req);
    }
    removeSchemaState(id) {
        this.gettingstate.delete(id);
    }
    removeSchemaSaveState(id) {
        this.savingstate.delete(id);
    }
    getSchemaState(id, cb) {
        this.gettingstate.set(id, cb);
        const req = {
            schemaid: this.activeschema,
            letrid: this.activelterid,
            id: id,
            data: ''
        };
        Apphandler.sendMessage("getschemastatedata", req);
    }
    setRebuildFormCom(id) {
        this.rebuildformcompo.add(id);
    }
    removeRebuildFormCom(id) {
        this.rebuildformcompo.delete(id);
    }
    clearHist() {
        this.chathis.splice(0, this.chathis.length);
    }
    addChatHis(his) {
        this.chathis.push(his);
        return this.chathis.length - 1;
    }
    updateChatHit(ch, index) {
        this.chathis.splice(index, 1, ch);
    }
    setActiveSchema(id) {
        var _a, _b, _c;
        this.setLoadingViews(false);
        if (id !== this.activeschema) {
            this.changedrowsid.clear();
            this.chathis.splice(0, this.chathis.length);
            this.customchecks.clear();
            this.schmeapostactionfunc = undefined;
            this.setActiveWebView("");
            this.customcolshareddataforrows = new Map();
            this.setShowWebView(false);
            this.rebuildformcompo.clear();
            this.viewjs = "";
            this.mapofdep.clear();
            this.showalertforentries.clear();
            this.shownormaldispaly = false;
            this.customrowjs = "";
            (_a = this.customgetupdatessince) === null || _a === void 0 ? void 0 : _a.clear();
            this.gettingstate.clear();
            this.savingstate.clear();
            this.expandlistitem.clear();
            this.expandlistrow.clear();
            this.readListState(id);
        }
        this.columnwidths.clear();
        this.forcerebuildcustom.clear();
        this.cacheui.clear();
        this.vieweditid = "";
        this.dviews.clear();
        this.setAddingView(false);
        this.schemaviews.clear();
        this.setUpdateItemCount(0);
        this.setFeatchingDepende(false);
        this.depschemarows.clear();
        this.cleaRowRule();
        this.loadedentry = 0;
        this.waitingentries = [];
        this.schemadep = undefined;
        this.buildingrulefor.clear();
        this.buildingruleforscol.clear();
        this.colwithschemarules.clear();
        this.hiddenrows.clear();
        this.activeschemametaids.clear();
        this.storeschemaids.clear();
        this.enableallsel = false;
        this.removingrowsfromsh.clear();
        this.selectedrows.clear();
        this.selrowmap.clear();
        this.setDeleteingRows(false);
        this.filterdialogstate.clear();
        this.setShowRowFilter(false);
        this.setDuplicatingRows(false);
        this.setDuplicatedCount(0);
        this.drows = [];
        this.hiddencolumns.clear();
        this.setShowColumns(false);
        this.setActiveAction("unknown");
        this.setAddingRowToChildren(false);
        this.selectallrows = false;
        this.selectedrows.clear();
        this.resetNotes();
        this.activeschema = id;
        this.setActiveRowId("");
        this.formentry.clear();
        this.setActiveTab('detail');
        this.setActiveView("grid");
        this.kanbanstatus.clear();
        this.timelinestatus.clear();
        this.chartstate.clear();
        this.calendarstate.clear();
        this.activeloadednotesref = "";
        this.notesbyid.clear();
        this.setNotesLoading(false);
        this.setSavingRow(false);
        this.rowsMap.clear();
        this.rowsarrids.splice(0, this.rowsarrids.length);
        this.newrowsmap.splice(0, this.newrowsmap.length);
        let items = [];
        const achema = this.schemas.get(id);
        if (achema === null || achema === void 0 ? void 0 : achema.parentschema) {
            items.push(...achema === null || achema === void 0 ? void 0 : achema.parentschema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        if (achema) {
            items.push(...achema.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex));
        }
        if (achema === null || achema === void 0 ? void 0 : achema.metaschemaids) {
            achema.metaschemaids.forEach(id => {
                this.activeschemametaids.add(id);
                this.storeschemaids.add(id);
            });
        }
        if (achema === null || achema === void 0 ? void 0 : achema.custompanels) {
            this.customrowjs = (_b = achema.custompanels) !== null && _b !== void 0 ? _b : '';
        }
        if (achema === null || achema === void 0 ? void 0 : achema.apicode) {
            this.schemaapimap.set(achema.apicode, achema);
        }
        if (achema === null || achema === void 0 ? void 0 : achema.templateid) {
            this.schematemplatemap.set(achema.templateid, achema);
        }
        if (achema === null || achema === void 0 ? void 0 : achema.colwidths) {
            for (const cl of achema.colwidths) {
                this.columnwidths.set(cl.colid, cl.width);
            }
        }
        if (achema) {
            for (const itm of (_c = achema === null || achema === void 0 ? void 0 : achema.items) !== null && _c !== void 0 ? _c : []) {
                if (!this.columnwidths.has(itm.id)) {
                    const lst = localStorage.getItem(achema.id + itm.id);
                    if (lst) {
                        const lstg = parseFloat(lst);
                        if (!isNaN(lstg) && lstg > 0) {
                            this.columnwidths.set(itm.id, lstg);
                            continue;
                        }
                    }
                    this.columnwidths.set(itm.id, 300);
                }
            }
            console.log(JSON.stringify(achema));
        }
        const orderby = localStorage.getItem(this.activeschema + "_sortby");
        if (orderby) {
            this.setRowSorter(orderby);
        }
        else {
            this.setRowSorter('orig');
        }
        const order = localStorage.getItem(this.activeschema + "_sortasc");
        if (order && order === 'asc') {
            this.setRowSorterOrder(true);
        }
        else if (order && order === 'dec') {
            this.setRowSorterOrder(false);
        }
        this.sortedschemaitems = items;
        if (!this.schemabuilderstate.saving) {
            this.loadSchemaEntries(true);
            this.loadAllViews();
            this.loadAllTriggers();
        }
        if ((achema === null || achema === void 0 ? void 0 : achema.parentschema) && achema.parentschema.rules) {
            for (const cr of achema.parentschema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
        if (achema === null || achema === void 0 ? void 0 : achema.rules) {
            // lets go over them now!!
            for (const cr of achema.rules) {
                let isvalid = false;
                for (const pr of cr.rule) {
                    for (const rrv of pr.params) {
                        if (rrv.type !== 'schema') {
                            isvalid = true;
                            break;
                        }
                        if (rrv.value && rrv.value.split("~~~").length > 2) {
                            isvalid = true;
                            break;
                        }
                    }
                }
                if (isvalid) {
                    this.colwithschemarules.add(cr.colid);
                }
            }
        }
        if (id) {
            Router.setActiveSchemaid(id);
            Router.setActiveRowid("");
        }
        if (id && achema !== undefined) {
            this.lastschemaupdatetime = new Date().getTime();
            if (this.schematimeout) {
                clearTimeout(this.schematimeout);
            }
            this.schematimeout = setTimeout(() => this.getSchemaUpdate(), 5000);
        }
    }
    setColWidth(id, wd) {
        this.columnwidths.set(id, wd);
        localStorage.setItem(this.activeschema + id, wd + '');
    }
    loadSchemaEntries(force = false) {
        var _a, _b;
        if (this.loadingcontent && !force) {
            return;
        }
        const sh = this.schemas.get(this.activeschema);
        if (!sh) {
            return;
        }
        this.setLoadingContent(true);
        const cids = [];
        if (sh.items && sh.items.length > 0) {
            for (let i = 0; i < sh.items.length; i++) {
                const item = sh.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
        }
        if (sh.parentschema && sh.parentschema.items && sh.parentschema.items.length > 0) {
            for (let i = 0; i < sh.parentschema.items.length; i++) {
                const item = sh.parentschema.items[i];
                cids.push(item.id);
                if (item.type === SchemaItemType.List) {
                    const litem = item;
                    if (litem.items && litem.items.length > 0) {
                        cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                    }
                }
            }
            // we should also add some of the things like 
        }
        if (sh.childrenschema && sh.childrenschema.length > 0) {
            for (const ch of sh.childrenschema) {
                if (ch.items && ch.items.length > 0) {
                    for (let i = 0; i < ch.items.length; i++) {
                        const item = ch.items[i];
                        cids.push(item.id);
                        if (item.type === SchemaItemType.List) {
                            const litem = item;
                            if (litem.items && litem.items.length > 0) {
                                cids.push(...litem.items.map((il) => litem.id + "----" + il.id));
                            }
                        }
                    }
                }
            }
        }
        const req = {
            letrid: this.activelterid,
            schemaid: this.activeschema,
            dataids: cids,
            privatekey: (_b = (_a = sh.webformkeys) === null || _a === void 0 ? void 0 : _a.priavatekey) !== null && _b !== void 0 ? _b : '',
            schamenonce: sh.nonce,
            schemakey: sh.accesskey,
            sitems: sh.items
        };
        Apphandler.sendMessage("getrows", req);
    }
    resetSchemaForm() {
        this.formentry.clear();
        this.resetListItems();
    }
    setShowForm(show) {
        if (show !== this.showform && show) {
            this.newrowindex = LetrwingCrypto.getUUID();
            this.newformmap.clear();
            this.activeformid = "";
            this.addnforms = "";
            this.addNewForm();
        }
        this.showform = show;
    }
    addFormEntry(id, val, ignorerebuilding = false, forceids) {
        console.log(val);
        this.formentry.set(id, val);
        console.log(this.formentry);
        if (ignorerebuilding && !forceids)
            return;
        if (!ignorerebuilding) {
            this.setIgnoreCustomComponentId(id);
            this.setRebuildingCustom(true);
            setTimeout(() => {
                this.removeIgnoreCustomComponentId(id);
                this.setRebuildingCustom(false);
            }, 10);
        }
        else if (forceids) {
            for (const fc of forceids) {
                this.addRebuildId(fc);
            }
            setTimeout(() => {
                for (const fc of forceids) {
                    this.removeRebuildId(fc);
                }
            }, 10);
        }
    }
    getDatapointsForChart(yfield, colorid) {
        const ydata = [];
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return ydata;
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        const yfd = sitemmap.get(yfield);
        if (!yfd) {
            return ydata;
        }
        let index = 0;
        for (const [_, item] of this.rowsMap) {
            if (this.hiddenrows.has(item.rowid))
                continue;
            index++;
            let mycolor = this.colors[(index % 3 === 0 ? 2 : index % 2 === 0 ? 1 : 0)];
            let doneyset = false;
            for (const fitem of item.entry) {
                if (fitem.cellid !== yfield && (colorid &&
                    fitem.cellid !== colorid)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === yfield) {
                    ydata.push({
                        val: value,
                        color: mycolor,
                        id: item.rowid
                    });
                }
                else if (fitem.cellid === colorid) {
                    mycolor = fitem.celldata;
                    if (doneyset) {
                        ydata[ydata.length - 1].color = mycolor;
                    }
                }
            }
        }
        return ydata;
    }
    buildChart(id, xfield, yfield, ctype, colorid) {
        var _a, _b, _c;
        const cstate = this.chartstate.get(id);
        if (!cstate) {
            return;
        }
        if (!this.activeschema) {
            return;
        }
        const achema = this.schemas.get(this.activeschema);
        if (!achema) {
            return;
        }
        const sitemmap = new Map();
        if (achema.parentschema) {
            achema.parentschema.items.forEach((item) => sitemmap.set(item.id, item));
        }
        achema.items.forEach((item) => sitemmap.set(item.id, item));
        const field = sitemmap.get(xfield);
        const yfd = sitemmap.get(yfield);
        if (!field || !yfd) {
            return;
        }
        cstate.setBuildingChart(true);
        // now lets build this!!
        cstate.setChartType(ctype);
        cstate.setYName(yfd.name);
        cstate.setXName(field.name);
        cstate.setYID(yfd.id);
        cstate.setXID(field.id);
        if (colorid) {
            const cofile = sitemmap.get(colorid);
            if (cofile) {
                cstate.setColorFieldid(cofile === null || cofile === void 0 ? void 0 : cofile.id);
                cstate.setColorFieldName(cofile.name);
            }
        }
        const xdata = [];
        const ydata = [];
        let index = 0;
        for (const [_, item] of this.rowsMap) {
            if (this.hiddenrows.has(item.rowid))
                continue;
            index++;
            let mycolor = this.colors[(index % 3 === 0 ? 2 : index % 2 === 0 ? 1 : 0)];
            let doneyset = false;
            for (const fitem of item.entry) {
                if (fitem.cellid !== xfield && fitem.cellid !== yfield && (colorid &&
                    fitem.cellid !== colorid)) {
                    continue;
                }
                if (!fitem.decrypted) {
                    this.decryptCell(fitem);
                }
                let value = fitem.celldata;
                if (!value) {
                    continue;
                }
                if (fitem.cellid === xfield) {
                    const sitem = sitemmap.get(fitem.cellid);
                    if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Text) {
                        let tmp = document.createElement("DIV");
                        tmp.innerHTML = value;
                        value = (_a = tmp.textContent) !== null && _a !== void 0 ? _a : '';
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Date) {
                        const sitem = sitemmap.get(fitem.cellid);
                        value = (_c = DateLib.displayDateWIthFormat(fitem.celldata, sitem.inlcudetime, (_b = sitem.excludedate) !== null && _b !== void 0 ? _b : false)) !== null && _c !== void 0 ? _c : '';
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Choice) {
                        let parts = fitem.celldata.split(",");
                        if (parts.length > 0) {
                            if (!sitem.multiselect) {
                                parts = [parts[0]];
                            }
                            const items = sitem.items.filter((it) => parts.indexOf(it.id) !== -1);
                            if (items.length > 0) {
                                value = items.map((it) => it.name).join(", ");
                            }
                            else {
                                value = "";
                            }
                        }
                        else {
                            value = "";
                        }
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) === SchemaItemType.Boolean) {
                        value = (fitem.celldata === 'true' ? 'Checked' : 'Unchecked');
                    }
                    else if ((sitem === null || sitem === void 0 ? void 0 : sitem.type) == SchemaItemType.UserChoice) {
                        let parts = fitem.celldata.split(",");
                        if (parts.length > 0) {
                            if (!sitem.multiselect) {
                                parts = [parts[0]];
                            }
                            const items = this.activeusers.filter((it) => parts.indexOf(it.id) !== -1);
                            if (items.length > 0) {
                                value = items.map((it) => it.name).join(", ");
                            }
                            else {
                                value = "";
                            }
                        }
                        else {
                            value = "";
                        }
                    }
                    xdata.push(value);
                }
                else if (fitem.cellid === yfield) {
                    doneyset = true;
                    ydata.push({
                        val: value,
                        color: mycolor,
                        id: item.rowid
                    });
                }
                else if (fitem.cellid === colorid) {
                    mycolor = fitem.celldata;
                    if (doneyset) {
                        ydata[ydata.length - 1].color = mycolor;
                    }
                }
            }
        }
        cstate.setXDataset(xdata);
        cstate.setYDataset(ydata);
        cstate.setBuildingChart(false);
    }
    showAllRows() {
        this.hiddenrows.clear();
    }
    setRunningAiQuery(running) {
        this.runningaiquery = running;
    }
    setFilterResetBtnStatus(running) {
        this.showfiltereset = running;
    }
    escapeJSONString(jsonString) {
        // Replace special characters in JSON string
        return jsonString.replace(/\\/g, '\\\\') // Escape backslashes
            .replace(/"/g, '\\"'); // Escape double quotes
        // Escape newlines
        // Escape carriage returns
    }
    async sheetQuery(aikey, apikey, his, customdisfun, cellids = []) {
        var _a, _b, _c, _d;
        let doc = "";
        let rows = this.getRows();
        let index = 0;
        let sh = this.schemas.get(this.activeschema);
        if (!sh)
            return "";
        let headers = [];
        let hid = [];
        let hmap = new Map();
        let items = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        for (const item of items) {
            if (item.type === SchemaItemType.List) {
                let lit = item;
                for (const li of lit.items) {
                    if (cellids.length === 0 || cellids.indexOf(item.id + "----" + li.item.id) !== -1) {
                        headers.push(li.item.name);
                        hid.push(item.id + "----" + li.item.id);
                        hmap.set(item.id + "----" + li.item.id, li.item);
                    }
                }
            }
            else {
                if (cellids.length === 0 || cellids.indexOf(item.id) !== -1) {
                    headers.push(item.name);
                    hid.push(item.id);
                    hmap.set(item.id, item);
                }
            }
        }
        let rindex = -1;
        for (const row of rows) {
            rindex++;
            let rowdoc = [];
            let enmap = new Map();
            for (const en of row.entry) {
                if (!enmap.has(en.cellid)) {
                    enmap.set(en.cellid, []);
                }
                (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
            }
            let listdata = new Map();
            for (const hs of hid) {
                let val = "";
                let ens = enmap.get(hs);
                for (const en of ens !== null && ens !== void 0 ? ens : []) {
                    let si = hmap.get(hs);
                    if (en && si) {
                        let type = si.type;
                        if (!en.decrypted) {
                            this.decryptCellInnline(en);
                        }
                        // now lets check the type and we done!
                        // for now this should be enough!!
                        val = stripHTML(en.celldata);
                        if (type === SchemaItemType.Remote) {
                            const uent = si;
                            const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                            const vals = this.dependentdata.get(id);
                            if (vals) {
                                // now we have this
                                const bits = en.celldata.split(",");
                                if (bits && bits.length > 0) {
                                    let remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1).sort((r1, r2) => {
                                        const r1index = bits.indexOf(r1.id);
                                        const r2index = bits.indexOf(r2.id);
                                        return r1index - r2index;
                                    });
                                    if (remotevals.length > 0) {
                                        val = remotevals.map((val) => val.value).join(", ");
                                    }
                                }
                            }
                        }
                        else if (type === SchemaItemType.Choice) {
                            const ebots = en.celldata.split(",");
                            let choices = [];
                            if (ebots.length > 0) {
                                if (!si.multiselect) {
                                    const cval = ebots[0];
                                    for (const val of si.items) {
                                        if (cval === (val.id)) {
                                            choices.push(val.name);
                                            break;
                                        }
                                    }
                                }
                                else {
                                    for (const val of si.items) {
                                        if (ebots.indexOf(val.id) !== -1) {
                                            choices.push(val.name);
                                        }
                                    }
                                }
                            }
                            val = choices.join(", ");
                        }
                        else if (type === SchemaItemType.Date) {
                            val = DateLib.displayDateWIthFormat(en.celldata, si.inlcudetime, (_b = si.excludedate) !== null && _b !== void 0 ? _b : false);
                        }
                        else if (type === SchemaItemType.CustomDisplayCol) {
                            val = await customdisfun(en, sh, si);
                        }
                        if (hs.indexOf("----") !== -1) {
                            if (!listdata.has(hs)) {
                                listdata.set(hs, []);
                            }
                            (_c = listdata.get(hs)) === null || _c === void 0 ? void 0 : _c.push(val);
                        }
                        else {
                            rowdoc.push({
                                name: si.name,
                                value: val
                            });
                        }
                    }
                    // now if this is list type we need to collect this in list array!
                }
            }
            if (listdata.size > 0) {
                for (const [ld, val] of listdata) {
                    let si = hmap.get(ld);
                    if (si) {
                        rowdoc.push({
                            name: si.name,
                            value: val.join(",")
                        });
                    }
                }
            }
            // now we have this lets add this
            if (rowdoc.length > 0) {
                doc += "\nRowid " + row.rowid + " Rowindex " + rindex + " " + " row data \n";
                for (const rr of rowdoc) {
                    doc += rr.name + " : " + rr.value + "\n";
                }
                if (rindex % 1000 === 0) {
                    await timeout(30);
                }
            }
        }
        let prompt = "You're world best data analyst. Below are the rows of data from excel sheet. Your user has asked a query Your job is to analyse the data answer their query. Make sure you stricly look and follow user query.";
        prompt += "\nAlso, included the history of chat. Please  use that as well  in answering. Also, to support your answer also add rowindex from data. Also, make sure to use basic formatting like line break bold etc in your answer. And if you using markup just use html markup.\n";
        prompt += " Rowdata: " + this.escapeJSONString(doc);
        if (his) {
            prompt += " \nhistory: " + this.escapeJSONString(his);
        }
        prompt += " \nUserquery: " + aikey;
        const req = {
            apikey: apikey,
            prompt: prompt,
            images: [],
            outputjson: "",
            model: 'models/gemini-1.5-flash',
            responsetype: 'text'
        };
        req.images = [];
        req.responsetype = (_d = req.responsetype) !== null && _d !== void 0 ? _d : "application/json";
        const resp = await comm.post(ServerPath.pwaLLMRequest, req);
        if (resp && resp.answer) {
            return resp.answer;
        }
        return "";
    }
    async queryUsingAi(aikey, apikey, customdisfun, cellids = []) {
        var _a, _b, _c, _d;
        // lets build the ui first!
        // if we have remote then extra that 
        // if we have text thats good or number
        let doc = "";
        let rows = this.getRows();
        let index = 0;
        let sh = this.schemas.get(this.activeschema);
        if (!sh)
            return [];
        let headers = [];
        let hid = [];
        let hmap = new Map();
        let items = sh.items.slice().sort((it1, it2) => it1.orderindex - it2.orderindex);
        for (const item of items) {
            if (item.type === SchemaItemType.List) {
                let lit = item;
                for (const li of lit.items) {
                    if (cellids.length === 0 || cellids.indexOf(item.id + "----" + li.item.id) !== -1) {
                        headers.push(li.item.name);
                        hid.push(item.id + "----" + li.item.id);
                        hmap.set(item.id + "----" + li.item.id, li.item);
                    }
                }
            }
            else {
                if (cellids.length === 0 || cellids.indexOf(item.id) !== -1) {
                    headers.push(item.name);
                    hid.push(item.id);
                    hmap.set(item.id, item);
                }
            }
        }
        let docs = [];
        let rindex = -1;
        for (const row of rows) {
            this.hideRow(row.rowid);
        }
        for (const row of rows) {
            rindex++;
            let rowdoc = [];
            let enmap = new Map();
            for (const en of row.entry) {
                if (!enmap.has(en.cellid)) {
                    enmap.set(en.cellid, []);
                }
                (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
            }
            let listdata = new Map();
            for (const hs of hid) {
                let val = "";
                let ens = enmap.get(hs);
                for (const en of ens !== null && ens !== void 0 ? ens : []) {
                    let si = hmap.get(hs);
                    if (en && si) {
                        let type = si.type;
                        if (!en.decrypted) {
                            this.decryptCellInnline(en);
                        }
                        // now lets check the type and we done!
                        // for now this should be enough!!
                        val = stripHTML(en.celldata);
                        if (type === SchemaItemType.Remote) {
                            const uent = si;
                            const id = uent.id + "---" + uent.sid + "---" + uent.cid;
                            const vals = this.dependentdata.get(id);
                            if (vals) {
                                // now we have this
                                const bits = en.celldata.split(",");
                                if (bits && bits.length > 0) {
                                    let remotevals = vals.filter((val) => bits.indexOf(val.id) !== -1).sort((r1, r2) => {
                                        const r1index = bits.indexOf(r1.id);
                                        const r2index = bits.indexOf(r2.id);
                                        return r1index - r2index;
                                    });
                                    if (remotevals.length > 0) {
                                        val = remotevals.map((val) => val.value).join(", ");
                                    }
                                }
                            }
                        }
                        else if (type === SchemaItemType.Choice) {
                            const ebots = en.celldata.split(",");
                            let choices = [];
                            if (ebots.length > 0) {
                                if (!si.multiselect) {
                                    const cval = ebots[0];
                                    for (const val of si.items) {
                                        if (cval === (val.id)) {
                                            choices.push(val.name);
                                            break;
                                        }
                                    }
                                }
                                else {
                                    for (const val of si.items) {
                                        if (ebots.indexOf(val.id) !== -1) {
                                            choices.push(val.name);
                                        }
                                    }
                                }
                            }
                            val = choices.join(", ");
                        }
                        else if (type === SchemaItemType.Date) {
                            val = DateLib.displayDateWIthFormat(en.celldata, si.inlcudetime, (_b = si.excludedate) !== null && _b !== void 0 ? _b : false);
                        }
                        else if (type === SchemaItemType.CustomDisplayCol) {
                            val = await customdisfun(en, sh, si);
                        }
                        if (hs.indexOf("----") !== -1) {
                            if (!listdata.has(hs)) {
                                listdata.set(hs, []);
                            }
                            (_c = listdata.get(hs)) === null || _c === void 0 ? void 0 : _c.push(val);
                        }
                        else {
                            rowdoc.push({
                                name: si.name,
                                value: val
                            });
                        }
                    }
                    // now if this is list type we need to collect this in list array!
                }
            }
            if (listdata.size > 0) {
                for (const [ld, val] of listdata) {
                    let si = hmap.get(ld);
                    if (si) {
                        rowdoc.push({
                            name: si.name,
                            value: val.join(",")
                        });
                    }
                }
            }
            // now we have this lets add this
            if (rowdoc.length > 0) {
                doc += "\nRowid " + row.rowid + " row data \n";
                for (const rr of rowdoc) {
                    doc += rr.name + " : " + rr.value + "\n";
                }
                if (rindex > 0 && (rindex % 1000 === 0 || rindex === rows.length - 1)) {
                    let prompt = "You're world best data analyst. Below are the rows of data from excel sheet. Your user has asked a query Your job is to analyse the data and find all matching rows that matches your user query. Return just the comma separated rowids of matching rows and nothing else. If you find nomatching items then return no rowid.Make sure you stricly look and follow user query.";
                    prompt += " Rowdata: " + this.escapeJSONString(doc);
                    prompt += " Userquery: " + aikey;
                    const req = {
                        apikey: apikey,
                        prompt: prompt,
                        images: [],
                        outputjson: "",
                        model: 'models/gemini-1.5-flash',
                        responsetype: 'text'
                    };
                    req.images = [];
                    req.responsetype = (_d = req.responsetype) !== null && _d !== void 0 ? _d : "application/json";
                    const resp = await comm.post(ServerPath.pwaLLMRequest, req);
                    if (resp && resp.answer) {
                        let pp = resp.answer.split(",");
                        for (const p of pp) {
                            if (this.rowsMap.has(p.trim())) {
                                this.unhideRow(p.trim());
                            }
                        }
                    }
                    doc = "";
                }
            }
        }
        this.setRunningAiQuery(false);
    }
    removeViewFromDelete(id) {
        this.dviews.delete(id);
    }
    deleteView(v) {
        const view = this.schemaviews.get(v);
        if (this.dviews.has(v) || !view)
            return;
        this.dviews.add(v);
        const res = {
            letrid: this.activelterid,
            shid: this.activeschema,
            view: view
        };
        Apphandler.sendMessage("deletewebview", res);
    }
    canshowEntryFromLM(entries, fil) {
        let lm = 0;
        for (const en of entries) {
            if (en.updatetime && en.updatetime > lm) {
                lm = en.updatetime;
            }
        }
        if (fil.optype === SearchMetadataOp.Equal) {
            const fdate = new Date(parseInt(fil.value));
            const ldate = new Date(lm);
            fdate.setSeconds(0);
            fdate.setMilliseconds(0);
            ldate.setSeconds(0);
            ldate.setMilliseconds(0);
            if (ldate.getTime() !== fdate.getTime()) {
                return false;
            }
        }
        else if (fil.optype === SearchMetadataOp.GreateEqual ||
            fil.optype === SearchMetadataOp.Greater ||
            fil.optype === SearchMetadataOp.Less ||
            fil.optype === SearchMetadataOp.LessEqual) {
            try {
                const fdate = new Date(parseInt(fil.value));
                const ldate = new Date(lm);
                fdate.setSeconds(0);
                fdate.setMilliseconds(0);
                ldate.setSeconds(0);
                ldate.setMilliseconds(0);
                const v1 = ldate.getTime();
                const v2 = fdate.getTime();
                if (fil.optype === SearchMetadataOp.GreateEqual && v1 < v2) {
                    return false;
                }
                else if (fil.optype === SearchMetadataOp.Greater && v1 <= v2) {
                    return false;
                }
                else if (fil.optype === SearchMetadataOp.Less && v1 >= v2) {
                    return false;
                }
                else if (fil.optype === SearchMetadataOp.LessEqual && v1 > v2) {
                    return false;
                }
            }
            catch (ex) {
                return false;
            }
        }
        else if (fil.optype === SearchMetadataOp.InBetween) {
            try {
                const fdate = new Date(parseInt(fil.value));
                const fdate2 = new Date(parseInt(fil.value2));
                const ldate = new Date(lm);
                fdate.setSeconds(0);
                fdate.setMilliseconds(0);
                ldate.setSeconds(0);
                ldate.setMilliseconds(0);
                fdate2.setSeconds(0);
                fdate2.setMilliseconds(0);
                const v1 = ldate.getTime();
                const v2 = fdate.getTime();
                const v3 = fdate2.getTime();
                if (v1 >= v2 && v1 <= v3) {
                    // just leave it!!
                }
                else {
                    return false;
                }
            }
            catch (ex) {
                return false;
            }
        }
        return true;
    }
    canShowRow(entries, filter) {
        var _a, _b, _c, _d, _e;
        const enmap = new Map();
        for (const en of entries) {
            if (!enmap.has(en.cellid)) {
                enmap.set(en.cellid, []);
            }
            (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        for (const fil of filter) {
            if (fil.id === "lastmodifief") {
                if (!this.canshowEntryFromLM(entries, fil)) {
                    return false;
                }
                continue;
            }
            const ens = enmap.get(fil.id);
            if (!ens || ens.length === 0) {
                return false;
            }
            let nomatch = true;
            entryloop: for (const en of ens) {
                if (!en.decrypted) {
                    if (en.ruleopen) {
                        this.parseCellRule(en);
                    }
                    else {
                        this.decryptCell(en);
                    }
                }
                if (fil.fielditem.type === SchemaItemType.FormInput || fil.fielditem.type === SchemaItemType.URL) {
                    if (en.celldata.toLowerCase().indexOf(fil.value.toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.Text) {
                    const est = (_b = LWStripHTML(en.celldata)) !== null && _b !== void 0 ? _b : '';
                    const cval = (_c = LWStripHTML(fil.value)) !== null && _c !== void 0 ? _c : '';
                    if (est.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.ID) {
                    const est = (_d = (en.celldata)) !== null && _d !== void 0 ? _d : '';
                    let cval = (_e = (fil.value)) !== null && _e !== void 0 ? _e : '';
                    cval = cval.replace('-', '');
                    if (est.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.SquenceNumber) {
                    const est = en.celldata;
                    let cval = fil.value;
                    if (est.trim().toLowerCase() !== cval.trim().toLowerCase()) {
                        continue entryloop;
                    }
                }
                else if ((fil.fielditem.type === SchemaItemType.Choice) ||
                    (fil.fielditem.type === SchemaItemType.UserChoice)) {
                    let vals = fil.value.split(",");
                    let carr = en.celldata.split(",");
                    if (!fil.fielditem.multiselect) {
                        carr.splice(1, carr.length);
                    }
                    const fv = vals.filter(val => carr.includes(val));
                    if (fv.length === 0) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.Remote) {
                    let vals = fil.value.split(",");
                    let carr = en.celldata.split(",");
                    const fv = vals.filter(val => carr.includes(val));
                    if (fv.length === 0) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.Equal) {
                    if (en.celldata.toLowerCase() !== fil.value.toLowerCase()) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.GreateEqual ||
                    fil.optype === SearchMetadataOp.Greater ||
                    fil.optype === SearchMetadataOp.Less ||
                    fil.optype === SearchMetadataOp.LessEqual) {
                    try {
                        const v1 = parseFloat(en.celldata);
                        const v2 = parseFloat(fil.value);
                        if (fil.optype === SearchMetadataOp.GreateEqual && v1 < v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.Greater && v1 <= v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.Less && v1 >= v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.LessEqual && v1 > v2) {
                            continue entryloop;
                        }
                    }
                    catch (ex) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.InBetween) {
                    try {
                        const v1 = parseFloat(en.celldata);
                        const v2 = parseFloat(fil.value);
                        const v3 = parseFloat(fil.value2);
                        if (v1 >= v2 && v1 <= v3) {
                            // just leave it!!
                        }
                        else {
                            continue entryloop;
                        }
                    }
                    catch (ex) {
                        continue entryloop;
                    }
                }
                nomatch = false;
                break;
            }
            // if we find a no
            if (nomatch) {
                return false;
            }
        }
        return true;
    }
    searchCanShowRow(entries, filter) {
        var _a, _b, _c, _d, _e;
        const enmap = new Map();
        for (const en of entries) {
            if (!enmap.has(en.cellid)) {
                enmap.set(en.cellid, []);
            }
            (_a = enmap.get(en.cellid)) === null || _a === void 0 ? void 0 : _a.push(en);
        }
        for (const fil of filter) {
            const ens = enmap.get(fil.id);
            if (!ens || ens.length === 0) {
                continue;
            }
            let nomatch = true;
            entryloop: for (const en of ens) {
                if (!en.decrypted) {
                    if (en.ruleopen) {
                        this.parseCellRule(en);
                    }
                    else {
                        this.decryptCell(en);
                    }
                }
                if (fil.fielditem.type === SchemaItemType.FormInput || fil.fielditem.type === SchemaItemType.URL) {
                    if (en.celldata.toLowerCase().indexOf(fil.value.toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.Text) {
                    const est = (_b = LWStripHTML(en.celldata)) !== null && _b !== void 0 ? _b : '';
                    const cval = (_c = LWStripHTML(fil.value)) !== null && _c !== void 0 ? _c : '';
                    if (est.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.ID) {
                    const est = (_d = (en.celldata)) !== null && _d !== void 0 ? _d : '';
                    let cval = (_e = (fil.value)) !== null && _e !== void 0 ? _e : '';
                    cval = cval.replace('-', '');
                    if (est.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.SquenceNumber) {
                    const est = en.celldata;
                    let cval = fil.value;
                    if (est.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) === -1) {
                        continue entryloop;
                    }
                }
                else if ((fil.fielditem.type === SchemaItemType.Choice) ||
                    (fil.fielditem.type === SchemaItemType.UserChoice)) {
                    let cval = fil.value;
                    let carr = en.celldata.split(",");
                    if (!fil.fielditem.multiselect) {
                        carr.splice(1, carr.length);
                    }
                    const chItems = fil.fielditem.items;
                    let nmatch = true;
                    for (const ch of chItems) {
                        if (carr.includes(ch.id) && ch.name.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) !== -1) {
                            nmatch = false;
                            break;
                        }
                    }
                    if (nmatch) {
                        continue entryloop;
                    }
                }
                else if (fil.fielditem.type === SchemaItemType.Remote) {
                    let cval = fil.value;
                    let carr = en.celldata.split(",");
                    const ri = fil.fielditem;
                    let riID = ri.id;
                    if (riID.indexOf("----") !== -1) {
                        const bits = riID.split("----");
                        if (bits.length > 1) {
                            riID = bits[1];
                        }
                    }
                    const items = this.dependentdata.get(riID + "---" + ri.sid + "---" + ri.cid);
                    let nmatch = true;
                    if (items !== undefined) {
                        for (const it of items) {
                            if (carr.includes(it.id) && it.value.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) !== -1) {
                                nmatch = false;
                                break;
                            }
                        }
                        let rowids = new Set();
                        for (const it of items) {
                            if (carr.includes(it.id)) {
                                if (it.rowid) {
                                    rowids.add(it.rowid);
                                }
                            }
                        }
                        if (nmatch && ri.rtextra && ri.rtextra.length > 0) {
                            const rtextra = ri.rtextra;
                            for (const ext of rtextra) {
                                let riID = ri.id;
                                if (riID.indexOf("----") !== -1) {
                                    const bits = riID.split("----");
                                    if (bits.length > 1) {
                                        riID = bits[1];
                                    }
                                }
                                const items = this.dependentdata.get(riID + "---" + ri.sid + "---" + ext.cid);
                                if (items !== undefined) {
                                    let nm = true;
                                    for (const it of items) {
                                        if (it.rowid && rowids.has(it.rowid)
                                            && it.value.trim().toLowerCase().indexOf(cval.trim().toLowerCase()) !== -1) {
                                            nmatch = false;
                                            break;
                                        }
                                    }
                                    if (!nmatch) {
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    if (nmatch) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.Equal) {
                    if (en.celldata.toLowerCase() !== fil.value.toLowerCase()) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.GreateEqual ||
                    fil.optype === SearchMetadataOp.Greater ||
                    fil.optype === SearchMetadataOp.Less ||
                    fil.optype === SearchMetadataOp.LessEqual) {
                    try {
                        const v1 = parseFloat(en.celldata);
                        const v2 = parseFloat(fil.value);
                        if (fil.optype === SearchMetadataOp.GreateEqual && v1 < v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.Greater && v1 <= v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.Less && v1 >= v2) {
                            continue entryloop;
                        }
                        else if (fil.optype === SearchMetadataOp.LessEqual && v1 > v2) {
                            continue entryloop;
                        }
                    }
                    catch (ex) {
                        continue entryloop;
                    }
                }
                else if (fil.optype === SearchMetadataOp.InBetween) {
                    try {
                        const v1 = parseFloat(en.celldata);
                        const v2 = parseFloat(fil.value);
                        const v3 = parseFloat(fil.value2);
                        if (v1 >= v2 && v1 <= v3) {
                            // just leave it!!
                        }
                        else {
                            continue entryloop;
                        }
                    }
                    catch (ex) {
                        continue entryloop;
                    }
                }
                nomatch = false;
                break;
            }
            // if we find a no
            if (!nomatch) {
                return true;
            }
        }
        return false;
    }
    scanCanShowRow(entries, barcode) {
        var _a;
        const aschema = this.schemas.get(this.activeschema);
        if (aschema === undefined) {
            return;
        }
        for (const en of entries) {
            if (!en.decrypted) {
                this.decryptCell(en);
            }
            if (en.rowbarcode && en.rowbarcode.startsWith("crypt-")) {
                en.rowbarcode = (_a = this.decryptBCWithKeyNonde(en.rowbarcode, aschema.accesskey, aschema.nonce)) !== null && _a !== void 0 ? _a : '';
            }
            if (en.rowbarcode !== undefined && en.rowbarcode === barcode) {
                return true;
            }
        }
        return false;
    }
    filterUsingScanner(code = "", rowid = "") {
        this.hiddenrows.clear();
        for (const [_, row] of this.rowsMap) {
            const entries = row.entry;
            if (rowid.trim() && row.rowid.trim() === rowid) {
                //do nothing
            }
            else if (!rowid && code && this.scanCanShowRow(entries, code)) {
                //do nothing
            }
            else {
                this.hiddenrows.add(row.rowid);
            }
        }
    }
    async slowFilterRows(search = false, openw = undefined, workingcb = undefined) {
        // lets check if we need rule or not!!
        let slow = false;
        const vids = Array.from(this.filterdialogstate.valuesbyid.values());
        console.log(vids);
        if (vids && vids.length > 0) {
            for (const v of vids) {
                // check if v has rule
                if (this.checkSchemaCellHasRule(v.fielditem.id)) {
                    slow = true;
                    break;
                }
            }
        }
        let i = 0;
        if (slow) {
            openw === null || openw === void 0 ? void 0 : openw();
        }
        let totaltime = 0;
        for (const [_, row] of this.rowsMap) {
            if (slow && totaltime > (10 * 1000)) {
                if (workingcb) {
                    workingcb("Checked " + (i + 1) + "/" + this.rowsMap.size);
                }
                totaltime = 0;
                await timeout(0);
            }
            let st = 0;
            if (slow) {
                st = new Date().getTime();
            }
            this.filterRow(row, search);
            if (slow) {
                let en = new Date().getTime();
                totaltime += (en - st);
            }
            i++;
        }
    }
    filterRow(row, search = false) {
        const entries = row.entry;
        let st = new Date().getTime();
        if (search) {
            if (!this.searchCanShowRow(entries, Array.from(this.filterdialogstate.valuesbyid.values()))) {
                this.hiddenrows.add(row.rowid);
            }
        }
        else {
            if (!this.canShowRow(entries, Array.from(this.filterdialogstate.valuesbyid.values()))) {
                this.hiddenrows.add(row.rowid);
            }
            else {
            }
        }
    }
    filterRows(search = false) {
        this.hiddenrows.clear();
        rowloop: for (const [_, row] of this.rowsMap) {
            this.filterRow(row, search);
        }
    }
    async filterViewRows(view) {
        if (view.customfilerjs) {
            const f = new Function("config", view.customfilerjs);
            let config = {
                getschemarows: (sid) => {
                    let apish = this.schemaapimap.get(sid);
                    let tid = this.schematemplatemap.get(sid);
                    if (apish) {
                        sid = apish.id;
                    }
                    else if (tid) {
                        sid = tid.id;
                    }
                    return this.getDependSchemaRows(sid);
                },
                decryptcell: (entry, sid, pr) => {
                    if (!entry.decrypted) {
                        this.decryptEntry(entry, sid, pr);
                    }
                    return entry;
                }
            };
            const bui = f(config);
            if (!bui || !bui.canShowRow)
                return;
            let hidros = [];
            let i = 0;
            for (const [_, row] of this.rowsMap) {
                if (!this.hiddenrows.has(row.rowid) && !bui.canShowRow(row.entry)) {
                    hidros.push(row.rowid);
                }
                if (i > 0 && i % 1000 === 0)
                    await timeout(10);
                i++;
            }
            if (hidros.length > 0) {
                for (const s of hidros) {
                    this.hiddenrows.add(s);
                }
            }
        }
    }
    createFilterForView() {
        const filters = [];
        for (const [_, fil] of this.filterdialogstate.valuesbyid) {
            const viewf = {
                value: fil.value,
                value2: fil.value2,
                op: fil.optype
            };
            filters.push({
                columnid: fil.fielditem.id,
                data: viewf
            });
        }
        return filters;
    }
    addChart(ctype) {
        const id = Math.random() + '';
        const cstate = new ChartViewState(id);
        cstate.setChartType(ctype);
        this.chartstate.set(id, cstate);
        return id;
    }
    clearChartState() {
        this.chartstate.clear();
    }
    saveTriggers(tr) {
        this.setAddingTriggers(true);
        tr[0].letrid = this.activelterid;
        tr[0].schemaid = this.activeschema;
        Apphandler.sendMessage("addtriggers", tr);
    }
    addTrigger(tr) {
        var _a;
        this.triggersbyCols.clear();
        for (const tt of tr) {
            if (!this.triggersbyCols.has(tt.columnid)) {
                this.triggersbyCols.set(tt.columnid, new Map());
            }
            (_a = this.triggersbyCols.get(tt.columnid)) === null || _a === void 0 ? void 0 : _a.set(tt.id, tt);
        }
    }
    reset() {
        this.triggersbyCols.clear();
        this.setActiveCustomTab("");
        this.setInitialTopMostItemIndex(0);
        clearTimeout(this.schematimeout);
        this.loadedentry = 0;
        this.setUpdatingDatasheet(false);
        this.removingrowsfromsh.clear();
        this.hiddencolumns.clear();
        this.setActiveChildSchema("");
        this.setActiveAction("unknown");
        this.setAddingRowToChildren(false);
        this.resetNotes();
        this.setNotesLoading(false);
        this.setActiveTab('detail');
        this.setActiveRowId("");
        this.schemas.clear();
        this.setLoading(false);
        this.dependentdata.clear();
        this.customcolcb.clear();
        this.customcolbuilder.clear();
        this.buildingcolns.clear();
        // this.rtdependentdata.clear();
        this.setActiveSchema("");
        this.setLoadingContent(false);
        this.setActiveView("grid");
        this.showganttenddatename = "Task End Date";
        this.showganttstartdatename = "Task Start Date";
        this.colorfieldname = "Default Colors";
        this.setShowGanttEndDate(false);
        this.setShowGanttStartDate(false);
        this.setGanttEndDate("");
        this.setGanttStartDate("");
        this.formentry.clear();
        this.newrowsmap.splice(0, this.newrowsmap.length);
        this.calendarstate.clear();
        this.kanbanstatus.clear();
        this.timelinestatus.clear();
        this.chartstate.clear();
        this.selectallrows = false;
        this.selectedrows.clear();
        this.getAnalytics(); // 
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "schemas", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "sortedschemaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "enableallsel", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "editrowslistitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "runningaiquery", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "chathis", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "duplicating", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "duplicatingcount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "attaching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "addingbarcodecol", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "deleteentries", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "gettingstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "savingstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activeschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingcontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showform", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "listitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "rebuildformcompo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "storingform", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "updatingdatasheet", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "parsingentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "newformmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "listdetails", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activeformid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "addnforms", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "formentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "newrowsmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "columnwidths", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "webviewcolwidths", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "buildingview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showlinkdialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "deleteingrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showactiveviewmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showwebview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showfiltereset", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showworksheetattach", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "showalertforentries", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showinfopanelshow", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "viewdefaultvalue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activeview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "copyactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showdtmennu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "copyschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "dviews", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "viewjs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "viewfilterjs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "viewdefaultvaluejs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showwebviewfilterjs", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "expandlistitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "expandlistrow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadinganaview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showdefaultvaluejs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "shownormaldispaly", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "addview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "selectedrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "attchinglabel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showactions", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showbacodes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showstatuesmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "buildingrulefor", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "buildingruleforscol", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activecardsttaus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activecardgroupby", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "hiddenrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activecardstatusname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activecardgroupname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "startnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showgroupbymenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showganttstartdate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showganttstartdatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showganttenddatename", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "colorfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "colorfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showcolorfield", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showchartmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showcolumnview", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "links", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "schemanotesloading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "checkingandcollecting", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "rowRules", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "rowDataRules", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "schemaviews", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "storeschemaids", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "activeschemametaids", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "colwithschemarules", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "rowsorter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "rowsorterorderasc", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "forcerebuildcustom", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "gettinganas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "anas", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "anasschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "deletenoteids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "shownotespanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "descfieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "descfieldid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showdescfield", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SchemaStore.prototype, "activedetailtab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingchats", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "deletingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "enableannotation", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "readonlyrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showrowsilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showchatbot", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "savingschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "selectallrows", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "notesbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "activeaccessids", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SchemaStore.prototype, "appliedaclstr", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "editnoteid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "authors", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showdervivedschemafields", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "hiddencolumns", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showganttenddate", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "ganttstartid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "ganttendid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "ganttasknameid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "ganttasknamefieldname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activerowid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "savingrow", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "savingnote", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "addingrowtochild", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activechildschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "editrowproperty", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "notelinksdialogleft", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "notelinksdialogtop", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "chartstate", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "removingrowsfromsh", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "showpasswordfor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingviews", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "triggersbyCols", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "showinoutlinks", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SchemaStore.prototype, "activeaction", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "fetchingdepend", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "ignorerebuildcustomcomponent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadedentry", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "viewname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "viewuseall", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "deletingschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "startnewview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "rebuildingcustom", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showoperatormenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "datasheets", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "duplicatecount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "updateitemcount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "initialTopMostItemIndex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "currentactiverowid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "colEditId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "editColName", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaStore.prototype, "selattachids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "attachdialogfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "colDeleteId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "addingtriggers", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "loadingremotecontent", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activeremoteschema", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "rerunning", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "remoteRowRules", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "customtabs", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activecustomtab", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "activeschemametalist", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], SchemaStore.prototype, "reportname", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], SchemaStore.prototype, "showreport", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "activewebview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showcustomview", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showsearchbar", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaStore.prototype, "barcodeinput", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "triggerrowids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "showonhomepage", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaStore.prototype, "twopanelfields", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "reverseorder", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaStore.prototype, "enableCodeView", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAddNForms", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setTwoPanelField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearTwoPanelField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingAnaView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowSearchBar", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAddingTriggers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRowSorter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRowSorterOrder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addCustomTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAddingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number, Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "reorderListItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setExpandEntireList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "readListState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCollapseEntireList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setExpandListRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCollapseListRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addNewForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setTriggerRowIds", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setWebViewJs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setWebViewFilterJs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setWebViewDefaultJs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowWebViewFilterJs", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowWebViewDefaultValueJS", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCustomViewColWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "resetCustomViewColWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setWebViewNormalDisplat", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowCustomView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "updateRowBarcode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAttachinglabel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAddingBarcodecol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setViewName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowOnHomePage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setReverseOrder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setEnableCodeView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setViewAll", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setStartActiveNewView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAttachDialogtext", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeAttachMents", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addAttachMents", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAttachSelids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveCustomTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingRemoteContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "deleteSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setReportName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "editSchemaItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setColDeleteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setEditColName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setColEditId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "fetchUpdates", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setUpdateItemCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "showAllColumns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setViewDefaultValue", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveWebView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDuplicateCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "addDuplicateRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowOperatorMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setSavngSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setGanttTaskField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAttaching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "insertRowsAtBeginning", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "insertRowsAtEnd", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "insertRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setGettingAns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setUpdatingDatasheet", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addSchemaToRowChList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addSchemaToParent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setFeatchingDepende", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRebuildingCustom", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setIgnoreCustomComponentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeIgnoreCustomComponentId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowRowFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowChatBot", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeSchemaFromRowChList", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowPasswordFor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setBarcodeInput", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCopySchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "cancelCopySchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setHidePasswordFor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setGanttTaskFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setSavingRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setReadonlyRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDatasheetMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveChildSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "execFooterRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "collectRowsAndBuildRulesResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowDerviedSchemaFields", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAuthor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowActions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowbarcode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDeleting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addListItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeListItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "resetListItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setEnableAnnotation", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveAction", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "deleteLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addIdToRemovingCh", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeIdToRemovingCh", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "checkAndAddSoftRowsForItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setNoteLinksDialogLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setNoteLinksDialogTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setSelectedRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setUnSelectedRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "selectAllRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "unselectAllRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAddingRowToChildren", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeShowLinksForNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowNotesPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDeletingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowFilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addLink", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setSavingNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setEditNoteId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingChat", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearLinks", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeNote", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setAppliedAclString", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "selectAccessids", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addActiveAccessId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setStartNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Array, Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "updateRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowLinkDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setNotesLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDeleteingRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowChartMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowGanttStartDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowGanttEndDateName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowColorField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setColorFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setColorFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addEntryForDeletion", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowinfopanelshow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCurrentActiveRowId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveRowId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removePropertiesFromActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object, Boolean, Array]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setPropertiesForActiveRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRebuildId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeRebuildId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowDescField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDescFieldId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDescFieldName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setGanttStartDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeChartState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setGanttEndDate", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveGroupByMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowStatusesMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveCardStatusName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveCardGroupName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveCardStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveCardGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "redoRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "parseCellRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeIdfromParsing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "decryptCell", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearAllViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "loadAllTriggers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "decryptRemoteCell", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowWorksheetAttach", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowWebView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setBuildingView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "updateSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "addRowInline", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "addRemoteRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "addRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRuleEntryToRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRuleEntryToRemoteRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "addRuleEntryToRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeNewRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setStoringForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setCollectingData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadingContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadmore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "resetNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "hideColumn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDuplicatingRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setDuplicatedCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "showColumn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowColumns", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "hideRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "unhideRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setInitialTopMostItemIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "getRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearMetadataSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addMetadataSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "deleteMetadataSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRemoteRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "cleaRowRule", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setLoadedRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveRemoteSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRerunning", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "checkAndAddRowEntriesToAlert", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeSchemaState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeSchemaSaveState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Function]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "getSchemaState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRebuildFormCom", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeRebuildFormCom", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearHist", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addChatHis", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "updateChatHit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setActiveSchema", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setColWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "resetSchemaForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setShowForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object, Boolean, Array]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addFormEntry", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "showAllRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setRunningAiQuery", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "setFilterResetBtnStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "removeViewFromDelete", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "deleteView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "filterUsingScanner", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "filterRow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "filterRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], SchemaStore.prototype, "filterViewRows", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addChart", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "clearChartState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "addTrigger", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaStore.prototype, "reset", null);
